window.HotelDetails = null;
window.HotelPhotoList = [];
window.ExprezyData = null;
var CheckExprezy;

window.HotelRoomPhotoSortedData = null;

window.WhatCurrentImageIndex = 0;
var MainImageSwiper;

window.CurrentExprezyIndex = 1;
window.ExprezyLastPage = 1;
window.HowManyExprezyPerPage = 6;
window.ExprezyScrollObserver = null;

var MobileBookCheckRoomButtonHotelDetails;

window.SelectedHotelDetailsFilter = null; // Rooms or Experiences -


// ====================================== PREPARE EARLY UI ======================================

window.PrepareUIHotelDetails = function()
{
    let SeeAllPhotosEarly = document.getElementById("SeeAllPhotosEarly");
    if(SeeAllPhotosEarly != null)
        SeeAllPhotosEarly.innerHTML = window["SeeAllPhotosTxt" + window.CurrentCountryID];
    
    let FacilityHeaderText = document.getElementById("FacilityHeaderText");
    if(FacilityHeaderText != null)
        FacilityHeaderText.innerHTML = window["FacilityTxt" + window.CurrentCountryID];
    
    let FacilityHeaderTextMobile = document.getElementById("FacilityHeaderTextMobile");
    if(FacilityHeaderTextMobile != null)
        FacilityHeaderTextMobile.innerHTML = window["FacilityTxt" + window.CurrentCountryID];

    let ChooseAccOrExpHeaderText = document.getElementById("ChooseAccOrExpHeaderText");
    if(ChooseAccOrExpHeaderText != null)
        ChooseAccOrExpHeaderText.innerHTML = window["ChooseAccommodationTxt" + window.CurrentCountryID];

    let FilterHotelDetailsAccText = document.getElementById("FilterHotelDetailsAccText");
    if(FilterHotelDetailsAccText != null)
        FilterHotelDetailsAccText.innerHTML = window["AccommodationTxt" + window.CurrentCountryID];

    let FilterHotelDetailsExperienceText = document.getElementById("FilterHotelDetailsExperienceText");
    if(FilterHotelDetailsExperienceText != null)
        FilterHotelDetailsExperienceText.innerHTML = window["ExperienceTxt" + window.CurrentCountryID];


    let PingNowButton = document.getElementById("PingNowButton");
    if(PingNowButton != null)
        PingNowButton.innerHTML = window["PingNowBtnTxt" + window.CurrentCountryID] + "<a id='PingNowButtonHREF' class='HREFInsideContainer'></a>";

    let ShareThisPingButtonText = document.getElementById("ShareThisPingButtonText");
    if(ShareThisPingButtonText != null)
        ShareThisPingButtonText.innerHTML = window["ShareThisPingTxt" + window.CurrentCountryID];

    let DapatkanRefMessageText = document.getElementById("DapatkanRefMessageText");
    if(DapatkanRefMessageText != null)
        DapatkanRefMessageText.innerHTML = window["DapatkanRefMessageTxt" + window.CurrentCountryID];

    let DownPaymentPriceHeaderText = document.getElementById("DownPaymentPriceHeaderText");
    if(DownPaymentPriceHeaderText != null)
        DownPaymentPriceHeaderText.innerHTML = window["DownPaymentPriceTxt" + window.CurrentCountryID];

    let EstimatedFinalPriceHeaderText = document.getElementById("EstimatedFinalPriceHeaderText");
    if(EstimatedFinalPriceHeaderText != null)
        EstimatedFinalPriceHeaderText.innerHTML = window["EstimatedFinalPriceTxt" + window.CurrentCountryID];

    let SeeNearbyHeaderText = document.getElementById("SeeNearbyHeaderText");
    if(SeeNearbyHeaderText != null)
        SeeNearbyHeaderText.innerHTML = window["SeeNearbyOnMapTxt" + window.CurrentCountryID];

    let ViewMoreExperiencesButtonText = document.getElementById("ViewMoreExperiencesButtonText");
    if(ViewMoreExperiencesButtonText != null)
        ViewMoreExperiencesButtonText.innerHTML = window["ViewMoreExpTxt" + window.CurrentCountryID];

    let AddOnHeaderText = document.getElementById("AddOnHeaderText");
    if(AddOnHeaderText != null)
        AddOnHeaderText.innerHTML = window["AddOnsTxt" + window.CurrentCountryID];

    let LihatSemuaTextDescription = document.getElementById("LihatSemuaTextDescription");
    if(LihatSemuaTextDescription != null)
        LihatSemuaTextDescription.innerHTML = window["ViewAllTxt" + window.CurrentCountryID];

    let SeeMoreFacilityButtonText = document.getElementById("SeeMoreFacilityButtonText");
    if(SeeMoreFacilityButtonText != null)
        SeeMoreFacilityButtonText.innerHTML = window["ViewAllTxt" + window.CurrentCountryID];

    let NoRoomAvailableHeaderText = document.getElementById("NoRoomAvailableHeaderText");
    if(NoRoomAvailableHeaderText != null)
        NoRoomAvailableHeaderText.innerHTML = window["NoRoomAvailableHeaderTxt" + window.CurrentCountryID];

    let NoRoomAvailableMessageText = document.getElementById("NoRoomAvailableMessageText");
    if(NoRoomAvailableMessageText != null)
        NoRoomAvailableMessageText.innerHTML = window["NoRoomAvailableMessageTxt" + window.CurrentCountryID];

    let ExploreHotelDetailsButton = document.getElementById("ExploreHotelDetailsButton");
    if(ExploreHotelDetailsButton != null)
    {
        ExploreHotelDetailsButton.innerHTML = window["ExploreMoreTxt" + window.CurrentCountryID];
        ExploreHotelDetailsButton.href = "/search/en/bali.html?search=Bali&type=" + window.SearchFilterType;
    }
    MobileBookCheckRoomButtonHotelDetails = document.getElementById("MobileBookCheckRoomButtonHotelDetails");

    let CheckInHeaderText = document.getElementById("CheckInHeaderText");
    if(CheckInHeaderText != null)
        CheckInHeaderText.innerHTML = window["CheckInTxt" + window.CurrentCountryID];

    let DateOfVisitHeaderText = document.getElementById("DateOfVisitHeaderText");
    if(DateOfVisitHeaderText != null)
        DateOfVisitHeaderText.innerHTML = window["DateOfVisitTxt" + window.CurrentCountryID];

    let TipeExperienceHeaderText = document.getElementById("TipeExperienceHeaderText");
    if(TipeExperienceHeaderText != null)
        TipeExperienceHeaderText.innerHTML = window["TipeExperienceTxt" + window.CurrentCountryID];

    // Footer -----------------------------------------------------------------------------------
    let MulaiDariHeaderText = document.getElementById("MulaiDariHeaderText");
    if(MulaiDariHeaderText != null)
        MulaiDariHeaderText.innerHTML = window["FromTxt" + window.CurrentCountryID];

    let TotalHargaHeaderTextMobile = document.getElementById("TotalHargaHeaderTextMobile");
    if(TotalHargaHeaderTextMobile != null)
        TotalHargaHeaderTextMobile.innerHTML = window["TotalHargaTxt" + window.CurrentCountryID];

    let AddOnsSwiperContainer = document.getElementById("AddOnsHotelDetailSwiperContainer");
    let AddOnsSwiper = new window.Swiper(AddOnsSwiperContainer,
    {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        observer: true,
        observeParents: true,
    });

    // Some Mobile UI ------------------------------------------------------------------

    let BackButtonMobile = document.querySelectorAll(".BackButtonMobile");
    BackButtonMobile.forEach(thisbutton =>
    {
        thisbutton.onclick = function()
        {
            window.history.back();
        }
    });

    let PilihKamarMobileText = document.querySelectorAll(".PilihKamarMobileText");
    PilihKamarMobileText.forEach(thistext =>
    {
        thistext.innerHTML = window["SelectRoomItemButtonTxt" + window.CurrentCountryID];
    });

    let UbahButtonText = document.querySelectorAll(".UbahKamarMobileButtonText");
    UbahButtonText.forEach(thistext =>
    {
        thistext.innerHTML = window["EditButtonTxt" + window.CurrentCountryID];
    });


    // Set Early Hotel Details Mobile Check In - Out ----------------------------------------------------

    let ExtraMobileCheckInOutDateContainer = document.querySelectorAll(".ExtraMobileCheckInOutDateContainer");
    if(ExtraMobileCheckInOutDateContainer != null && ExtraMobileCheckInOutDateContainer.length > 0)
    {
        ExtraMobileCheckInOutDateContainer.forEach(thiscontainer =>
        {
            let ThisCheckInOutMobileButton = thiscontainer.querySelector(".ExtraMobileCheckInOutDateButton");
            ThisCheckInOutMobileButton.onclick = function()
            {
                let PreviousCheckIn = window.CurrentSelectedCheckIn;
                let PreviousCheckOut = window.CurrentSelectedCheckOut;

                let PreviousCheckInYear = window.CurrentSelectedYearEdit;
                let PreviousCheckInMonth = window.CurrentSelectedMonthEdit;
                let PreviousCheckInDay = window.CurrentSelectedDayEdit;

                let isallowmorethanone = true;
                if(window.ThisRoomData != null && window.ThisRoomData.book_type == "per day")
                    isallowmorethanone = false;

                window.InstantiateDateChoiceMobilePanel(()=>
                {
                    let NewCheckInYear;
                    let NewCheckInMonth;
                    let NewCheckInDay;

                    let NewCheckOutYear;
                    let NewCheckOutMonth;
                    let NewCheckOutDay;

                    if(window.ThisRoomData.book_type == "per night")
                    {
                        let NewUpdateCheckInDateInfo = window.CurrentSelectedCheckIn;

                        NewCheckInYear = NewUpdateCheckInDateInfo.getFullYear();
                        NewCheckInMonth = (NewUpdateCheckInDateInfo.getMonth() + 1);
                        NewCheckInDay = NewUpdateCheckInDateInfo.getDate();

                        let NewUpdateCheckOutDateInfo = window.CurrentSelectedCheckOut;

                        NewCheckOutYear = NewUpdateCheckOutDateInfo.getFullYear();
                        NewCheckOutMonth = (NewUpdateCheckOutDateInfo.getMonth() + 1);
                        NewCheckOutDay = NewUpdateCheckOutDateInfo.getDate();
                    }
                    else
                    {
                        NewCheckInYear = window.CurrentSelectedYearEdit;
                        NewCheckInMonth = window.CurrentSelectedMonthEdit;
                        NewCheckInDay = window.CurrentSelectedDayEdit;

                        let CurrentCheckOutDate = new Date(NewCheckInYear, NewCheckInMonth-1, NewCheckInDay);
                        CurrentCheckOutDate.setDate(CurrentCheckOutDate.getDate() + 1);

                        NewCheckOutYear = CurrentCheckOutDate.getFullYear();
                        NewCheckOutMonth = (CurrentCheckOutDate.getMonth() + 1);
                        NewCheckOutDay = CurrentCheckOutDate.getDate();
                    }

                    window.CheckInDateNonTop = NewCheckInYear + "-" + NewCheckInMonth + "-" + NewCheckInDay;
                    window.CheckInNonTopInput.setAttribute("Date", NewCheckInDay);
                    window.CheckInNonTopInput.setAttribute("Month", NewCheckInMonth);
                    window.CheckInNonTopInput.setAttribute("Year", NewCheckInYear);

                    window.CheckOutDateNonTop = NewCheckOutYear + "-" + NewCheckOutMonth + "-" + NewCheckOutDay;
                    window.CheckOutNonTopInput.setAttribute("Date", NewCheckOutDay);
                    window.CheckOutNonTopInput.setAttribute("Month", NewCheckOutMonth);
                    window.CheckOutNonTopInput.setAttribute("Year", NewCheckOutYear);
                    
                    window.CalculateTotalHotelDetails(true);

                },
                ()=>
                {
                    window.CurrentSelectedCheckIn = PreviousCheckIn;
                    window.CurrentSelectedCheckOut = PreviousCheckOut;
                    window.CurrentSelectedYearEdit = PreviousCheckInYear;
                    window.CurrentSelectedMonthEdit = PreviousCheckInMonth;
                    window.CurrentSelectedDayEdit = PreviousCheckInDay;

                }, true, isallowmorethanone);
            }
        });
    }
    
    // ------------------------------ SET UBAH KAMAR MOBILE ---------------------------
    
    let UbahKamarMobileButton = document.querySelectorAll(".UbahKamarMobileButton");
    UbahKamarMobileButton.forEach(thisbutton =>
    {
        thisbutton.onclick = function()
        {
            let PrevData = window.CreateHotelDetailsSnapshot();

            window.InstantiateEditHotelDetailsMobileMenu(()=>
            {
                console.log("Update All Mobile");

                let NewUpdateCheckInDateInfo;
                let NewUpdateCheckOutDateInfo;

                if(window.ThisRoomData.book_type == "per night")
                {
                    NewUpdateCheckInDateInfo = window.CheckInDateNonTop;
                    NewUpdateCheckOutDateInfo = window.CheckOutDateNonTop;

                    if(NewUpdateCheckInDateInfo != null && typeof NewUpdateCheckInDateInfo === 'string')
                    {
                        NewUpdateCheckInDateInfo = window.ConvertDateStringToDateFormat(NewUpdateCheckInDateInfo);
                    }

                    if(NewUpdateCheckOutDateInfo != null && typeof NewUpdateCheckOutDateInfo === 'string')
                    {
                        NewUpdateCheckOutDateInfo = window.ConvertDateStringToDateFormat(NewUpdateCheckOutDateInfo);
                    }

                    console.log("NewUpdateCheckInDateInfo", NewUpdateCheckInDateInfo);
                    console.log("NewUpdateCheckOutDateInfo", NewUpdateCheckOutDateInfo);
                }
                else
                {
                    console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedYearEdit);
                    console.log("window.CurrentSelectedMonthEdit", window.CurrentSelectedMonthEdit);
                    console.log("window.CurrentSelectedDayEdit", window.CurrentSelectedDayEdit);

                    let GetFinalSelectedCheckInDate = new Date(window.CurrentSelectedYearEdit, parseInt(window.CurrentSelectedMonthEdit) - 1, window.CurrentSelectedDayEdit);
                    let GetFinalSelectedCheckOutDate = new Date(window.CurrentSelectedYearEdit, parseInt(window.CurrentSelectedMonthEdit) - 1, window.CurrentSelectedDayEdit);
                    GetFinalSelectedCheckOutDate.setDate(GetFinalSelectedCheckOutDate.getDate() + 1);

                    NewUpdateCheckInDateInfo = GetFinalSelectedCheckInDate;
                    NewUpdateCheckOutDateInfo = GetFinalSelectedCheckOutDate;

                    console.log("NewUpdateCheckInDateInfo", NewUpdateCheckInDateInfo);
                    console.log("NewUpdateCheckOutDateInfo", NewUpdateCheckOutDateInfo);
                }

                let NewCheckInYear = NewUpdateCheckInDateInfo.getFullYear();
                let NewCheckInMonth = (NewUpdateCheckInDateInfo.getMonth() + 1);
                let NewCheckInDay = NewUpdateCheckInDateInfo.getDate();

                window.CheckInDateNonTop = NewCheckInYear + "-" + NewCheckInMonth + "-" + NewCheckInDay;
                window.CheckInNonTopInput.setAttribute("Date", NewCheckInDay);
                window.CheckInNonTopInput.setAttribute("Month", NewCheckInMonth);
                window.CheckInNonTopInput.setAttribute("Year", NewCheckInYear);


                let NewCheckOutYear = NewUpdateCheckOutDateInfo.getFullYear();
                let NewCheckOutMonth = (NewUpdateCheckOutDateInfo.getMonth() + 1);
                let NewCheckOutDay = NewUpdateCheckOutDateInfo.getDate();

                window.CheckOutDateNonTop = NewCheckOutYear + "-" + NewCheckOutMonth + "-" + NewCheckOutDay;
                window.CheckOutNonTopInput.setAttribute("Date", NewCheckOutDay);
                window.CheckOutNonTopInput.setAttribute("Month", NewCheckOutMonth);
                window.CheckOutNonTopInput.setAttribute("Year", NewCheckOutYear);

                console.log("window.CheckInDateNonTop", window.CheckInDateNonTop);


                document.getElementById("RoomQuotaHotelDetailsInput").setAttribute("room-quota", window.ThisCurrentQuotaInput);    

                window.CalculateTotalHotelDetails(true);
            },
            ()=>
            {
                window.RestoreHotelDetailsSnapshot(PrevData);

                window.CalculateTotalHotelDetails(false);

            }, false, true, true);
        }
    });

    window.HotelDetailsScrollSetting();
}

window.LoadAllHotelDetails = function(MainSession, loggedin, functiontocallontypechange)
{
    if(sessionStorage.getItem("tempstatus") != null) // If Hotel Not Exist -----------------------------
    {
        sessionStorage.removeItem("tempstatus");
        return;
    }

    // let CurrentUrl = new URL(window.location.href);
    // let param = new URLSearchParams(CurrentUrl.search.slice(1));
    window.HotelID = window.location.pathname.split("/").pop().split(".")[0];

    // ------------------- DETERMINE SLUG EXIST OR NOT -------------------------------------------------

    // if(param.has('slug') == true || (window.location.pathname.includes(".php") == false && window.TempSlugFromHTML != null))
    // {
    //     if(param.has('slug') == true)
    //     {
    //         window.HotelSlug = CurrentUrl.searchParams.get("slug");
    //     }
    //     else
    //     {
    //         window.HotelSlug = window.TempSlugFromHTML;
    //     }
    // }
    // else
    // {
    //     // window.location.href = "index.php";
    //     return;
    // }

    // ------------------------- SET TOP SEARCH INFO --------------------------------

    window.SetUpTopDateQuotaSearch(false);

    window.CheckInDateNonTop = window.CheckInInfo;
    window.CheckOutDateNonTop = window.CheckOutInfo;
    window.RoomQuotaNonTop = window.RoomNumberInfo;


    // ----------------------- SET EARLY -----------------------------------------------
    
    let RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["RoomTxt" + window.CurrentCountryID];
    if(window.RoomQuotaNonTop > 1)
    {
        RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["RoomTxtex" + window.CurrentCountryID];
    }

    let MobileCurrentStatusHotelDetailsText = document.querySelectorAll(".MobileCurrentStatusHotelDetailsText");
    let DifferenceBetweenDays = window.GetDateDifferences(window.CheckInDateNonTop, window.CheckOutDateNonTop);
    MobileCurrentStatusHotelDetailsText.forEach(thistext =>
    {
        thistext.innerHTML = "-- ----";
        // thistext.innerHTML =  window.NightTextDisplayer(DifferenceBetweenDays) + " • " + RoomQuotaTextToDisplay;
    });

    //--------------------------------------- LOAD HOTEL DETAILS -----------------------------------

    window.LoadAccommodationDetails(null, ()=>
    {
        // -------------------------------------- CHANGE TOP ------------------------------------------

        if(functiontocallontypechange != null)
            functiontocallontypechange();

        // LOAD ADD ONS ---------------------------------------------------------
        
        LoadAddOnsHotel();

        // Set Slug -------------------------------------
        
        window.HotelSlug = window.HotelDetails.slug;

        //--------------------------------------- CHANGE URL --------------------------------

        let CheckInInfoToPadStart = window.CheckInInfo.split("-")
        let CheckInInfoCombined = CheckInInfoToPadStart[0] + "-" + CheckInInfoToPadStart[1].toString().padStart(2, '0') + "-" + CheckInInfoToPadStart[2].toString().padStart(2, '0');
            
        let CheckOutInfoToPadStart = window.CheckOutInfo.split("-")
        let CheckOutInfoCombined = CheckOutInfoToPadStart[0] + "-" + CheckOutInfoToPadStart[1].toString().padStart(2, '0') + "-" + CheckOutInfoToPadStart[2].toString().padStart(2, '0');
            
        // Replace URL -------------------------------------------------------------------------------

        if(window.SearchInfo == null)
        {
            window.SearchInfo = window.HotelDetails.province;
            window.MainSearchInputField.value =  window.SearchInfo;
            window.MainSearchInputField.setAttribute("province-slug", window.HotelDetails.province_slug);
            window.MainSearchInputField.setAttribute("current-inputed", window.SearchInfo);
            window.LoadTotalAccommodation(window.SlugInfo, window.SearchInfo);
        }
        // let UpdateURL = "
        // window.history.replaceState(window.history.state, document.title, UpdateURL);

        let UpdateURL = null;
        if(window.WhichPageisNow == "HotelDetails")
        {
            UpdateURL = "/" + window.HotelDetails.category.category_name.toLowerCase() + "/" + window.CurrentCountryID + "/" +  window.HotelDetails.id_hotel  + ".html?search=" + window.SearchInfo + "&checkin=" + CheckInInfoCombined + "&checkout=" + CheckOutInfoCombined + "&room=" + window.RoomNumberInfo + "&type=" + window.SearchFilterType;
        }

        if (typeof (window.history.replaceState) != "undefined" && UpdateURL != null)
        {
            var obj =
            {
                Url: UpdateURL
            };
            window.history.replaceState(obj, obj.Title, obj.Url);
        }

        
        // Max Discount -----------------------------------------------------------------------------------

        if(window.HotelDetails.max_disc != null && window.HotelDetails.max_disc > 0)
        {
            document.getElementById("MaxDiscountContainer").className = "RedBorderMaxDiscountHotelDetails";
            document.getElementById("MaxDiscountText").innerHTML = window["DiscountTxt" + window.CurrentCountryID](parseInt(window.HotelDetails.max_disc));
            document.getElementById("MaxDiscountText").style.opacity = 1;

            if(document.getElementById("MaxDiscountContainerMobile") != null)
            {
                document.getElementById("MaxDiscountContainerMobile").className = "RedBorderMaxDiscountHotelDetails";
                document.getElementById("MaxDiscountTextMobile").innerHTML = window["DiscountTxt2" + window.CurrentCountryID](parseInt(window.HotelDetails.max_disc));
                document.getElementById("MaxDiscountTextMobile").style.opacity = 1;
            }

            if(document.getElementById("MaxDiscountContainerMobile2") != null)
            {
                document.getElementById("MaxDiscountContainerMobile2").className = "RedBorderMaxDiscountHotelDetails LowMaxDiscountMobileContainer";
                document.getElementById("MaxDiscountTextMobile2").innerHTML = window["DiscountTxt2" + window.CurrentCountryID](parseInt(window.HotelDetails.max_disc));
                document.getElementById("MaxDiscountTextMobile2").style.opacity = 1;
            }


            document.getElementById("RedDiscountDetailsRightContainer").style.display = "";
            document.getElementById("RedDiscountDetailsRightText").innerHTML = parseInt(window.HotelDetails.max_disc) + "%";

            if(document.getElementById("PotonganMessageMobileContainer") != null)
            {
                document.getElementById("PotonganMessageMobileContainer").style.display = "";
                document.getElementById("PotonganMessageMobile").innerHTML = window["DiscountWithMaxTxt" + window.CurrentCountryID](parseInt(window.HotelDetails.max_disc), window.HotelDetails.max_disc_until);
            }

            if(document.getElementById("PotonganMessageMobileContainerTop") != null)
            {
                document.getElementById("PotonganMessageMobileContainerTop").style.display = "";
                document.getElementById("PotonganMessageMobileTop").innerHTML = window["DiscountWithMaxTxt" + window.CurrentCountryID](parseInt(window.HotelDetails.max_disc), window.HotelDetails.max_disc_until);
            }
            

            // Up To -----------------------------------------

            if(window.HotelDetails.max_disc_until != null && window.HotelDetails.max_disc_until > 0)
            {
                document.getElementById("UpToTextContainer").style.display = "";
                document.getElementById("UpToText").innerHTML = window["UpToTxt" + window.CurrentCountryID] + " " + window.ConvertTextToRP(parseInt(window.HotelDetails.max_disc_until), 1, false, false);

                if(document.getElementById("UpToTextContainerMobile") != null)
                {
                    // document.getElementById("UpToTextContainerMobile").style.display = "flex";
                    document.getElementById("UpToTextMobile").innerHTML = window["UpToTxt" + window.CurrentCountryID] + " " + window.ConvertTextToRP(parseInt(window.HotelDetails.max_disc_until), 1, false, false);
                }
            }
        }
        else
        {
            document.getElementById("MaxDiscountDesktopMainContainer").style.display = "none";

            if(document.getElementById("MaxDiscountContainerMobile") != null)
                document.getElementById("MaxDiscountContainerMobile").style.display = "none";

            if(document.getElementById("MaxDiscountContainerMobile2") != null)
                document.getElementById("MaxDiscountContainerMobile2").style.display = "none";

            document.getElementById("RedDiscountDetailsRightContainer").style.display = "none";
        }

        // Accommodation Type and Name -----------------------------------------------------------------------------------
            
        document.getElementById("AccommodationnameTypeLoading").style.display = "none";
        document.getElementById("AccommodationTypeandNameContainer").style.display = "";
        document.getElementById("AccommodationTypeText").innerHTML = window.HotelDetails.category.category_name;
        document.getElementById("AccommodationNameText").innerHTML = window.HotelDetails.hotel_name;
        if(document.getElementById("HotelNameHeaderTopBar") != null)
        document.getElementById("HotelNameHeaderTopBar").innerHTML = window.HotelDetails.hotel_name;

        // Location -----------------------------------------------------------------------------------------

        document.getElementById("LoadingLocationTextWrapper").style.display = "none";
        document.getElementById("LocationTextWrapper").style.display = "";
        document.getElementById("LocationText").innerHTML = window.HotelDetails.location;

        if(window.HotelDetails.link_gmaps != null)
        {
            document.getElementById("LocationText").innerHTML = window.HotelDetails.location + " - <a class='SeeMapTextInsidePanel InterBoldTextFont HyperlinkUnderlineText' id='SeeMapTextInsidePanel'>" + window["SeeMapTxt" + window.CurrentCountryID] +"</a>";
            document.getElementById("SeeMapTextInsidePanel").href = window.HotelDetails.link_gmaps;
            document.getElementById("SeeMapTextInsidePanel").target = "_blank";
            document.getElementById("SeeMapTextInsidePanel").rel = "noopener noreferrer";
        }

        // Description -----------------------------------------------------------------------------------------
        let HotelDescriptionToDisplay = window.HotelDetails.hotel_description.replace(/(?:\r\n|\r|\n)/g, '<br>');
        HotelDescriptionToDisplay = window.decodeGarbledContent(HotelDescriptionToDisplay);


        document.getElementById("AboutHotelTextMobileText").innerHTML = window["TentangTxt" + window.CurrentCountryID] + " " + window.HotelDetails.hotel_name;
        document.getElementById("AboutHotelTextMobileText").style.display = "";
        document.getElementById("AboutHotelTextMobileLoading").style.display = "none";

        document.getElementById("AccommodationDescriptionLoading").style.display = "none";
        document.getElementById("AccommodationDescriptionText").style.display = "";
        document.getElementById("AccommodationDescriptionText").innerHTML = HotelDescriptionToDisplay;

        document.getElementById("AccommodationDescriptionLoadingMobile").style.display = "none";
        document.getElementById("AccommodationDescriptionTextMobile").style.display = "";
        document.getElementById("AccommodationDescriptionTextMobile").innerHTML = HotelDescriptionToDisplay;

        let AccommodationDescriptionCollapsible = document.getElementById("AccommodationDescriptionCollapsible");
        let SeeMoreButtonDescription = document.getElementById("SeeMoreButtonDescription");
        SeeMoreButtonDescription.style.display = "";
        let LihatSemuaTextDescription = document.getElementById("LihatSemuaTextDescription");

        if(HotelDescriptionToDisplay.length >= 500)
        {
            window.SetDynamicCollapsible(AccommodationDescriptionCollapsible, SeeMoreButtonDescription, LihatSemuaTextDescription);
        }
        else
        {
            AccommodationDescriptionCollapsible.className = "";
            SeeMoreButtonDescription.style.display = "none";

        }

        // Facility -----------------------------------------------------------------------------------------

        document.getElementById("FacilityLoadingWrapper").style.display = "none";
        document.getElementById("FacilityListMainWrapper").style.display = "";

        let MainFacilityContainer = document.getElementById("FacilityAndBenefitsContainer");
        let MobileFacilityContainer = document.getElementById("FacilityAndBenefitsContainerMobile");

        let MainHotelFaciltyList = [MainFacilityContainer, MobileFacilityContainer];

        MainHotelFaciltyList.forEach(ThisContainer =>
        {
            ThisContainer.innerHTML = "";

            for(let i = 0; i < window.HotelDetails.facilities.length; i++)
            {
                let FaciltyChildrenContainer = document.createElement("div");
                FaciltyChildrenContainer.className = "FaciltyChildrenContainer";
                ThisContainer.append(FaciltyChildrenContainer);

                let FacilityIcon = document.createElement("img");
                FacilityIcon.className = "FacilityIcon";
                FacilityIcon.src = window.HotelDetails.facilities[i].icon_link;
                FaciltyChildrenContainer.append(FacilityIcon);

                let FacilityNameText = document.createElement("p");
                FacilityNameText.className = "FacilityNameText InterRegularTextFont";
                FacilityNameText.innerHTML = window.HotelDetails.facilities[i]["facility_name_" + window.CurrentCountryID];
                FaciltyChildrenContainer.append(FacilityNameText);
            }
        });

        let SeeMoreFacilityButton = document.getElementById("SeeMoreFacilityButton");
        let SeeMoreFacilityButtonText = document.getElementById("SeeMoreFacilityButtonText");

        if(window.HotelDetails.facilities.length >= 11)
        {
            SeeMoreFacilityButton.style.display = "";
            window.SetDynamicCollapsible(MobileFacilityContainer, SeeMoreFacilityButton, SeeMoreFacilityButtonText);
        }
        else
        {
            
            MobileFacilityContainer.className = "FacilityAndBenefitsContainer";
            SeeMoreButtonDescription.style.display = "none";

        }



        // Room and Hotel Photo -----------------------------------------------------------------------------------

        window.LoadAllMainAccommodationPhoto("HotelDetails", loggedin);
        // window.LoadRoomPhotoBeforeHotelPhoto("HotelDetails", loggedin);

        // Nearby Map -----------------------------------------------------------------------------------

        document.getElementById("SeeNearbyHeaderText").style.display = "";
        document.getElementById("SeeNearbyHeaderLoading").style.display = "none";
        
        let EmbedMapContainer = document.getElementById("EmbedMapContainer");
        InstantiateNearbyMap(window.HotelDetails.embed_maps_med, EmbedMapContainer);


        // Load Exprezy Data -----------------------------------------------------------------------------

        document.getElementById("PingExprezyHeaderText").innerHTML = window["WhatPeopleSayAboutTxt" + window.CurrentCountryID](window.HotelDetails.hotel_name);
        window.LoadExprezyData(MainSession, loggedin);

        // Mobile Low Panel Button -----------------------------------------------------------------------

        if(MobileBookCheckRoomButtonHotelDetails != null)
        {
            // MobileBookCheckRoomButtonHotelDetails.className = "BasicTextButton BasicBoxShadow OrangeButton HorizontalButtonExpanded SignInTopDropDownText Selectable";
            MobileBookCheckRoomButtonHotelDetails.innerHTML = window["LihatKamarButtonTxt" + window.CurrentCountryID];
            MobileBookCheckRoomButtonHotelDetails.onclick = function()
            {
                const RoomHotelContainer = document.getElementById("ChangeRoomContainerHotelDetailsMobile");
                window.ScrollToWindow(RoomHotelContainer);
            }
        }




        return
        //!!!!!!!!!!!!!
        // Share Button -----------------------------------------------------------------------------------

        // window.LoadAllHotelDetails();
        // LoadBasicPanel(("nearby_property.php?search=" + window.SearchInfo.toLowerCase() + "&checkin=" + window.CheckInInfo + "&checkout=" + window.CheckOutInfo + "&room=" + window.RoomNumberInfo + "&id_hotel="+window.HotelID), "NearBy", "Nearby Property", "List-of-Nearby-Property");
    }, ()=>
    {
        // window.location.replace("/not_found");
    });
}


// ==================================== 

window.HotelDetailsScrollSetting = function()
{
    const AccommodationNameTextMain = document.getElementById("AccommodationNameText");
    const TopBarHotelDetails = document.getElementById("HeaderSearchHotelDetailsTopBar");
    const WhichTopBarCheckCollide = document.getElementById("TopCornerButtonContainer");

    const hotelObserver = new IntersectionObserver(
    ([entry]) =>
    {
        if(entry.isIntersecting)
        {
            if(TopBarHotelDetails.classList.contains("TopBarHotelDetailsNameDisplayed") == true)
                TopBarHotelDetails.classList.remove("TopBarHotelDetailsNameDisplayed");
        }
        else
        {
            if(TopBarHotelDetails.classList.contains("TopBarHotelDetailsNameDisplayed") == false)
                TopBarHotelDetails.classList.add("TopBarHotelDetailsNameDisplayed");
        }
    },
    {
        threshold:0
    });
    hotelObserver.observe(AccommodationNameTextMain);


    const ChangeRoomContainer = document.getElementById('ChangeRoomContainerHotelDetailsMobile');
    const TotalPriceMobileBottom = document.getElementById('TotalPriceMobileBottom');
    const BottomIndexContainer = document.getElementById("BottomIndexContainer");

    function UpdateStickyBookingBar()
    {
        const navbarRect = WhichTopBarCheckCollide.getBoundingClientRect();
        const roomRect = ChangeRoomContainer.getBoundingClientRect();
        const bottompanelRect = BottomIndexContainer.getBoundingClientRect();

        const collided = roomRect.top <= navbarRect.bottom;
        TopBarHotelDetails.classList.toggle("TopBarEditBookingDisplayed", collided);


        const viewportHeight = window.innerHeight;
        const collidedWithBottom = (roomRect.bottom <= viewportHeight && bottompanelRect.top >= viewportHeight);
        TotalPriceMobileBottom.classList.toggle("TotalPriceMobileBottomDisplay", collidedWithBottom);
    }

    window.addEventListener("scroll", UpdateStickyBookingBar, { passive: true });
    window.addEventListener("resize", UpdateStickyBookingBar);
    
    // window.addEventListener("scroll", () =>
    // {
    //     const navbarRect = TopBarHotelDetails.getBoundingClientRect();
    //     const roomRect = ChangeRoomContainer.getBoundingClientRect();

    //     if(roomRect.top <= navbarRect.bottom)
    //     {
    //         if(TopBarHotelDetails.classList.contains("TopBarEditBookingDisplayed") == false)
    //             TopBarHotelDetails.classList.add("TopBarEditBookingDisplayed");
    //     }
    //     else
    //     {
    //         if(TopBarHotelDetails.classList.contains("TopBarEditBookingDisplayed") == true)
    //             TopBarHotelDetails.classList.remove("TopBarEditBookingDisplayed");
    //     }
    // });

    // const bookingObserver = new IntersectionObserver(
    // ([entry]) =>
    // {
    //     if(entry.isIntersecting)
    //     {
    //         stickyBooking.classList.remove("Show");
    //     }
    //     else
    //     {
    //         stickyBooking.classList.add("Show");
    //     }
    // },
    // {
    //     threshold:0
    // });

    // bookingObserver.observe(bookingSection);
    
};



// =========================== LOAD HOTEL & ROOM PHOTO ===========================

window.LoadAllMainAccommodationPhoto = function(whichtype, loggedin)
{
    // Prepare Early Elements (Especially Hotel Details) --------------------------------------------

    let HotelDetailsFilterButtons = document.querySelectorAll(".HotelDetailsFilterButton");
    let OnFilterChangeFunctionToCall = null;

    if(whichtype == "HotelDetails")
    {
        // Set Early Default Selected Filter --------------------------------------------------------------

        if(window.SelectedHotelDetailsFilter == null)
        {
            window.SelectedHotelDetailsFilter = "Rooms";
        }

        // Set Loading Due To Main Photo Instantiate -----------------------------------------------------

        let RoomHotelContainer = document.getElementById("RoomHotelContainer");
        RoomHotelContainer.innerHTML = "";

        let LoadingContainer = document.createElement("div");
        LoadingContainer.style.width = "100%";
        LoadingContainer.style.height = "fit-content";
        LoadingContainer.style.display = "flex";
        LoadingContainer.id = "LoadingContainer";
        LoadingContainer.style.flexDirection = "column";
        RoomHotelContainer.append(LoadingContainer);

        for(let i = 0; i < 4; i++)
        {
            window.LoadingContentPanel(LoadingContainer, 4, null);
        }

        // Set Checkin Out Button -----------------------------------------------------------------------------

        let CheckInDateHotelDetailsInput = document.getElementById("CheckInDateHotelDetailsInput");
        if(CheckInDateHotelDetailsInput != null)
        {
            CheckInDateHotelDetailsInput.onclick = function()
            {
                window.OpenDateChoiceContainer('CheckInDateHotelDetailsInput', 'CheckOutDateHotelDetailsInput', '', 'Start', 'HowManyNightHotelDetailsInput', 1, false, false, true, true, true, true, ()=>window.CalculateTotalHotelDetails(true));
            }
        }
        
        let CheckOutDateHotelDetailsInput = document.getElementById("CheckOutDateHotelDetailsInput");
        if(CheckOutDateHotelDetailsInput != null)
        {
            CheckOutDateHotelDetailsInput.onclick = function()
            {
                window.OpenDateChoiceContainer('CheckOutDateHotelDetailsInput', 'CheckInDateHotelDetailsInput', '', 'End', 'HowManyNightHotelDetailsInput', 1, false, false, true, false, true, true, ()=>window.CalculateTotalHotelDetails(true))
            }
        }

        // Function To Call Whenever Filter Selected ----------------------------------------------------------

        OnFilterChangeFunctionToCall = function() 
        {
            let ChooseAccOrExpHeaderText = document.getElementById("ChooseAccOrExpHeaderText");  // Display The Header To Display -------------
            ChooseAccOrExpHeaderText.style.display = "";

            document.getElementById("RoomHeaderLoading").style.display = "none";

            HotelDetailsFilterButtons.forEach(ThisButton =>
            {
                ThisButton.className = "BasicTextButton BasicBoxShadow BlueOutlineButton SignInButtonTop Selectable HotelDetailsTypeToBookContainer HotelDetailsFilterButton";

                if(ThisButton.id == (window.SelectedHotelDetailsFilter + "FilterButtonHotelDetails"))
                {
                    ThisButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop Selectable HotelDetailsTypeToBookContainer HotelDetailsFilterButton";
                }
            });
            
            if(ChooseAccOrExpHeaderText != null)
                ChooseAccOrExpHeaderText.innerHTML = window["Choose" + window.SelectedHotelDetailsFilter + "Txt" + window.CurrentCountryID];

            window.LoadAccommodationRoomExperience(RoomHotelContainer, null);
        }
    }


    // Load Photo ---------------------------------------------------------------------------

    // let UrlHotelPhoto = "/v2/hotels/" + window.HotelID + "/photos?page=1&limit=9999";
    let UrlHotelPhoto = "/v2/hotels/" + window.HotelID + "/media?page=1&limit=9999";
    
    window.CallApiAxios({
        method: "GET",
        url: UrlHotelPhoto,
    }).then(res =>
    {
        console.log(res);

        if(res.status == 200)
        {
            console.log(UrlHotelPhoto);
            window.HotelPhotoList = res.data.data;
            console.log(window.HotelPhotoList);

            // Share Button -----------------------------------------------------------------------------------
            //!!!!!!!!!!!!!!!!!!!!!!! CHECK IF SHARE IMAGE AVAILABLE
            if(loggedin == true)
            {
                document.getElementById("ShareAccommodationButtonWrapper").style.display = "";

                if(whichtype == "HotelDetails")
                {
                    document.getElementById('ShareAccommodationButton').onclick = function()
                    {
                        // let HotelImageFullUrlArray = window.HotelDetails.photos[0].split("/");
                        // let HotelName = HotelImageFullUrlArray[HotelImageFullUrlArray.length-1];
                        window.CheckHotelImageExist(window.HotelPhotoList[0].photo_url, window.HotelDetails.id_hotel, loggedin);
                    }
                }

                if(document.getElementById("ShareAccommodationButtonWrapperMobile") != null)
                {
                    document.getElementById("ShareAccommodationButtonWrapperMobile").style.display = "";

                    if(whichtype == "HotelDetails")
                    {
                        document.getElementById('ShareAccommodationButtonMobile').onclick = function()
                        {
                            // let HotelImageFullUrlArray = window.HotelDetails.photos[0].split("/");
                            // let HotelName = HotelImageFullUrlArray[HotelImageFullUrlArray.length-1];
                            window.CheckHotelImageExist(window.HotelPhotoList[0].photo_url, window.HotelDetails.id_hotel, loggedin);
                        }
                    }
                }
            }
            else
            {
                document.getElementById("ShareAccommodationButtonWrapper").remove();

                if(document.getElementById("ShareAccommodationButtonWrapperMobile") != null)
                    document.getElementById("ShareAccommodationButtonWrapperMobile").remove();
            }

            // Sort All Image Based On Type -----------------------------------------------------------

            let AllHotelRoomPhotosBecomeOne =  [];

            const PhotoTypePriority =
            {
                hotel: 1,
                room: 2,
                experience: 3
            };
            window.HotelPhotoList.sort((a, b) =>
            {
                return PhotoTypePriority[a.type] - PhotoTypePriority[b.type];
            });

            window.HotelRoomPhotoSortedData = 
            {
                "hotel_photo":[],
                "room_photo":[],
                "experience_photo":[],
            }

            for(let i = 0; i < window.HotelPhotoList.length; i++)
            {
                if(window.HotelPhotoList[i].type == "room")
                {
                    window.HotelRoomPhotoSortedData.room_photo.push(window.HotelPhotoList[i]);
                }
                else if(window.HotelPhotoList[i].type == "experience")
                {
                    window.HotelRoomPhotoSortedData.experience_photo.push(window.HotelPhotoList[i]);
                }
                else
                {
                    window.HotelRoomPhotoSortedData.hotel_photo.push(window.HotelPhotoList[i]);
                }

                AllHotelRoomPhotosBecomeOne.push(window.HotelPhotoList[i]);
            }

            console.log(window.HotelRoomPhotoSortedData);

            // Instantiate Photos --------------------------------------------------------------------------------------------
            
            console.log("AllHotelRoomPhotosBecomeOne", AllHotelRoomPhotosBecomeOne);
            
            window.PreparetoInstantiateHotelImage(AllHotelRoomPhotosBecomeOne);


            // Instantiate Room or Experience Panel ----------------------------------------------------------------------------------

            if(whichtype == "HotelDetails") 
            {
                let AccommodationFilterButtonHotelDetails = document.getElementById("RoomsFilterButtonHotelDetails");
                if(AccommodationFilterButtonHotelDetails != null)
                {
                    AccommodationFilterButtonHotelDetails.onclick = function()
                    {
                        window.SelectedHotelDetailsFilter = "Rooms";
                        OnFilterChangeFunctionToCall();
                    }
                }

                let ExperienceFilterButtonHotelDetails = document.getElementById("ExperiencesFilterButtonHotelDetails");
                if(ExperienceFilterButtonHotelDetails != null)
                {
                    ExperienceFilterButtonHotelDetails.onclick = function()
                    {
                        window.SelectedHotelDetailsFilter = "Experiences";
                        OnFilterChangeFunctionToCall();
                    }
                }

                OnFilterChangeFunctionToCall();
            }

        }
    })
    .catch(err =>
    {
        console.error(err);
    });
}


window.LoadRoomPhotoBeforeHotelPhoto = function(whichtype, loggedin)
{
    let RoomData = window.HotelDetails.rooms;

    let LoadingContainer = null;
    let RoomContainerToInstant = null;

    let HotelDetailsFilterButtons = document.querySelectorAll(".HotelDetailsFilterButton");

    if(whichtype == "HotelDetails")
    {
        if(window.SelectedHotelDetailsFilter == null)
        {
            window.SelectedHotelDetailsFilter = "Rooms";
        }
        
        HotelDetailsFilterButtons.forEach(ThisButton =>
        {
            ThisButton.className = "BasicTextButton BasicBoxShadow BlueOutlineButton SignInButtonTop Selectable HotelDetailsTypeToBookContainer HotelDetailsFilterButton";

            if(ThisButton.id == (window.SelectedHotelDetailsFilter + "FilterButtonHotelDetails"))
            {
                ThisButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop Selectable HotelDetailsTypeToBookContainer HotelDetailsFilterButton";
            }
        });
        

        let ChooseAccOrExpHeaderText = document.getElementById("ChooseAccOrExpHeaderText");
           
        if(ChooseAccOrExpHeaderText != null)
            ChooseAccOrExpHeaderText.innerHTML = window["Choose" + window.SelectedHotelDetailsFilter + "Txt" + window.CurrentCountryID];
        
        document.getElementById("ChooseAccOrExpHeaderText").style.display = "";
        document.getElementById("RoomHeaderLoading").style.display = "none";

        let RoomHotelContainer = document.getElementById("RoomHotelContainer");
        RoomHotelContainer.innerHTML = "";

        LoadingContainer = document.createElement("div");
        LoadingContainer.style.width = "100%";
        LoadingContainer.style.height = "fit-content";
        LoadingContainer.style.display = "flex";
        LoadingContainer.style.flexDirection = "column";
        RoomHotelContainer.append(LoadingContainer);

        RoomData.forEach(rooms =>
        {
            window.LoadingContentPanel(LoadingContainer, 4, null);
        });

        RoomContainerToInstant = document.createElement("div");
        RoomContainerToInstant.style.width = "100%";
        RoomContainerToInstant.style.height = "fit-content";
        RoomContainerToInstant.style.display = "flex";
        RoomContainerToInstant.style.flexDirection = "column";
        RoomContainerToInstant.style.display = "none";
        RoomHotelContainer.append(RoomContainerToInstant);
    }


    let UrlHotelPhoto = "/v2/hotels/" + window.HotelID + "/photos?page=1&limit=9999";
    let LoadRoomPhotoURL = "/v2/hotels/" + window.HotelID + "/rooms/photos?page=1&limit=99999";
    
    window.CallApiAxios({
        method: "GET",
        url: LoadRoomPhotoURL,
    }).then(res =>
    {
        console.log(LoadRoomPhotoURL);

        if(res.status == 200)
        {
            let LoadRoomListData = res.data.data;
            console.log(LoadRoomListData);

            // Assign Each Room Photo To Room Data -------------------------------
            
            for(let i = 0; i < LoadRoomListData.length; i++)
            {
                for(let j = 0; j < window.HotelDetails.rooms.length; j++)
                {
                    if(window.HotelDetails.rooms[j].id_hotel_room == LoadRoomListData[i].id_hotel_room)
                    {
                        window.HotelDetails.rooms[j].room_photo = LoadRoomListData[i];
                    }
                }
            }

            // Instantiate Room List -------------------------------------------

            if(whichtype == "HotelDetails")
            {
                let AccommodationFilterButtonHotelDetails = document.getElementById("AccommodationFilterButtonHotelDetails");
                if(AccommodationFilterButtonHotelDetails != null)
                {
                    AccommodationFilterButtonHotelDetails.onclick = function()
                    {
                        window.SelectedHotelDetailsFilter = "Rooms";
                        window.LoadRoomPhotoBeforeHotelPhoto(whichtype, loggedin);
                    }
                }

                let ExperienceFilterButtonHotelDetails = document.getElementById("ExperienceFilterButtonHotelDetails");
                if(ExperienceFilterButtonHotelDetails != null)
                {
                    ExperienceFilterButtonHotelDetails.onclick = function()
                    {
                        window.SelectedHotelDetailsFilter = "Experiences";
                        window.LoadRoomPhotoBeforeHotelPhoto(whichtype, loggedin);
                    }
                }

                window.InstantiateRoomList(RoomContainerToInstant, window.HotelDetails.rooms);
                window.CheckImageContainerImageLoaded(RoomContainerToInstant, LoadingContainer, true);
            }

            // Load Hotel Photo ------------------------------------------

            window.LoadPhotoAccommodationDetails(window.HotelDetails.rooms, UrlHotelPhoto, whichtype, loggedin);
            //window.PreparetoInstantiateHotelImage(RoomData, UrlHotelPhoto, "HotelDetails");
        }
    })
    .catch(err =>
    {
        console.error(err);
        window.LoadPhotoAccommodationDetails(window.HotelDetails.rooms, UrlHotelPhoto, whichtype, loggedin);
    });
}


window.LoadPhotoAccommodationDetails = function(roomdatas, UrlHotelPhoto, whichtype, loggedin)
{
    window.CallApiAxios({
        method: "GET",
        url: UrlHotelPhoto,
    }).then(res =>
    {
        console.log(res);
        if(res.status == 200)
        {
            console.log(UrlHotelPhoto);
            window.HotelPhotoList = res.data.data;
            console.log(window.HotelPhotoList);
            console.log(roomdatas);

            // Share Button -----------------------------------------------------------------------------------
            //!!!!!!!!!!!!!!!!!!!!!!! CHECK IF SHARE IMAGE AVAILABLE
            if(loggedin == true)
            {
                document.getElementById("ShareAccommodationButtonWrapper").style.display = "";

                if(whichtype == "HotelDetails")
                {
                    document.getElementById('ShareAccommodationButton').onclick = function()
                    {
                        // let HotelImageFullUrlArray = window.HotelDetails.photos[0].split("/");
                        // let HotelName = HotelImageFullUrlArray[HotelImageFullUrlArray.length-1];
                        window.CheckHotelImageExist(window.HotelPhotoList[0].hotel_photo, window.HotelDetails.id_hotel, loggedin);
                    }
                }

                if(document.getElementById("ShareAccommodationButtonWrapperMobile") != null)
                {
                    document.getElementById("ShareAccommodationButtonWrapperMobile").style.display = "";

                    if(whichtype == "HotelDetails")
                    {
                        document.getElementById('ShareAccommodationButtonMobile').onclick = function()
                        {
                            // let HotelImageFullUrlArray = window.HotelDetails.photos[0].split("/");
                            // let HotelName = HotelImageFullUrlArray[HotelImageFullUrlArray.length-1];
                            window.CheckHotelImageExist(window.HotelPhotoList[0].hotel_photo, window.HotelDetails.id_hotel, loggedin);
                        }
                    }
                }
            }
            else
            {
                document.getElementById("ShareAccommodationButtonWrapper").remove();

                if(document.getElementById("ShareAccommodationButtonWrapperMobile") != null)
                    document.getElementById("ShareAccommodationButtonWrapperMobile").remove();
            }

            // Combine All Image From Hotel First -----------------------------------------------------------

            let AllHotelRoomPhotosBecomeOne =  [...window.HotelPhotoList];
            let SortedRoomPhotos = [];
            window.HotelRoomPhotoSortedData = [];

            for(let i = 0; i < roomdatas.length; i++)
            {
                AllHotelRoomPhotosBecomeOne.push(roomdatas[i].room_photo);
                SortedRoomPhotos.push(roomdatas[i].room_photo);
            }

            window.HotelRoomPhotoSortedData = 
            {
                "hotel_photo":window.HotelPhotoList,
                "room_photo":SortedRoomPhotos,
            }

            console.log(window.HotelRoomPhotoSortedData);

            // Instantiate Photos --------------------------------------------------------------------------------------------
            
            console.log("AllHotelRoomPhotosBecomeOne", AllHotelRoomPhotosBecomeOne);
            
            window.PreparetoInstantiateHotelImage(AllHotelRoomPhotosBecomeOne);

        }
    })
    .catch(err =>
    {
        console.error(err);
    });
}

// =========================== LOAD ACCOMMODATION ROOM EXPERIENCE ===================================

window.CurrentLoadedListRoomExp = [];
window.CurrentLoadedExperience = [];
window.ListOfChoicesThisAccommodation = [];

window.LoadAccommodationRoomExperience = function(RoomHotelContainer, functiontocall)
{
    let URLAccRoomExpData = "/v2/hotels/" + window.HotelID + "/accommodations?checkin=" + window.ConvertArrayedDateString(window.CheckInDateNonTop) + "&checkout=" + window.ConvertArrayedDateString(window.CheckOutDateNonTop) + "&rooms=" + window.RoomQuotaNonTop;
    if(window.SelectedHotelDetailsFilter == "Experiences")
        URLAccRoomExpData = "/v2/hotels/" + window.HotelID + "/experiences?date_visit=" + window.ConvertArrayedDateString(window.CheckInDateNonTop) + "&date_until=" + window.ConvertArrayedDateString(window.CheckOutDateNonTop) + "&rooms=" + window.RoomQuotaNonTop;

    window.CurrentLoadedListRoomExp = [];
    window.CurrentLoadedExperience = [];

    // Instantiate Loading Container -----------------------------------

    RoomHotelContainer.style.display = "flex";
    RoomHotelContainer.innerHTML = "";

    let LoadingContainer = document.createElement("div");
    LoadingContainer.style.width = "100%";
    LoadingContainer.style.height = "fit-content";
    LoadingContainer.style.display = "flex";
    LoadingContainer.id = "LoadingContainer";
    LoadingContainer.style.flexDirection = "column";
    RoomHotelContainer.append(LoadingContainer);

    for(let i = 0; i < 4; i++)
    {
        window.LoadingContentPanel(LoadingContainer, 4, null);
    }

    window.ListOfChoicesThisAccommodation = [];

    // Load Room or Experience Data -----------------------------

    window.CallApiAxios({
        method: "GET",
        url: URLAccRoomExpData,
    })
    .then(res =>
    {
        console.log(URLAccRoomExpData);
        console.log(res);


        if(res.status == 200)
        {
            let WhichData = res.data.data[0];
            console.log("WhichData", WhichData);

            window.CurrentLoadedListRoomExp = WhichData.rooms || WhichData.experiences;
            if(window.SelectedHotelDetailsFilter == "Experiences")
                window.CurrentLoadedExperience = window.CurrentLoadedListRoomExp;

            console.log("ThisAccExpData", window.CurrentLoadedListRoomExp);
            
            // Prepare For Choices --------------------------------------------------

            for(let i = 0; i < window.CurrentLoadedListRoomExp.length; i++)
            {
                let ChoiceDataToAppend =
                {
                    "id": window.CurrentLoadedListRoomExp[i]?.id_hotel_room || window.CurrentLoadedListRoomExp[i]?.id,
                    "type": window.SelectedHotelDetailsFilter,
                    "name_en": window.CurrentLoadedListRoomExp[i]?.room_name || window.CurrentLoadedListRoomExp[i]?.name_en,
                    "name_id": window.CurrentLoadedListRoomExp[i]?.room_name || window.CurrentLoadedListRoomExp[i]?.name_id,
                    "book_type": window.CurrentLoadedListRoomExp[i].book_type,
                    "data": window.CurrentLoadedListRoomExp[i],
                }
                window.ListOfChoicesThisAccommodation.push(ChoiceDataToAppend);
            }

            // ----------------------------------------------------------------------

            window.InstantiateRoomList(RoomHotelContainer, window.CurrentLoadedListRoomExp);

            if(functiontocall != null)
                functiontocall();
            // window.CheckImageContainerImageLoaded(RoomContainerToInstant, LoadingContainer, true);
        }
    })
    .catch(err =>
    {
        console.error(err);

        window.InstantiateRoomList(RoomHotelContainer, window.CurrentLoadedListRoomExp);

        if(functiontocall != null)
            functiontocall();
        // window.CheckImageContainerImageLoaded(RoomContainerToInstant, LoadingContainer, true);
    });
}



window.CheckIfAllRoomExperienceDataAlreadyLoaded = async function(functiontocall)
{
    console.log("window.CurrentChoiceDataJenisExperience", window.CurrentChoiceDataJenisExperience);

    let NeedCheck = false;
    let RoomExist = false;
    let ExperienceExist = false;

    let CheckInDateNow = window.ConvertDateStringToDateFormat(window.CheckInDateNonTop);
    let CheckOutDateNow = window.ConvertDateStringToDateFormat(window.CheckOutDateNonTop);

    CheckOutDateNow.setDate(CheckOutDateNow.getDate() - 1);

    let CurrentLoadedChoice = window.AllChoicesBasedOnCurrentSelectedRoomAccType;
    console.log("CurrentLoadedChoice", CurrentLoadedChoice);
    
    if(CurrentLoadedChoice.length == 0)
    {
        NeedCheck = true;
    }

    if(CurrentLoadedChoice.length > 0)
    {
        RoomExist = CurrentLoadedChoice.some(choice => choice.id_hotel_room != null);

        if(RoomExist == false)
        {
            for(let i = 0; i < window.ListOfChoicesThisAccommodation.length; i++)
            {
                if(window.ListOfChoicesThisAccommodation[i].type == "Rooms")
                {
                    window.ListOfChoicesThisAccommodation.splice(i, 1);
                }
            }
        }
        ExperienceExist = CurrentLoadedChoice.some(choice => choice.id_experience_type != null);

        if(ExperienceExist == false)
        {
            for(let i = 0; i < window.ListOfChoicesThisAccommodation.length; i++)
            {
                if(window.ListOfChoicesThisAccommodation[i].type == "Experiences")
                {
                    window.ListOfChoicesThisAccommodation.splice(i, 1);
                }
            }
        }

        for(let i = 0; i < CurrentLoadedChoice.length; i++)
        {
            let ThisBookType = CurrentLoadedChoice[i]?.book_type;

            let ThisDates = CurrentLoadedChoice[i]?.room_pings?.[0]?.dates ?? CurrentLoadedChoice[i]?.dates ?? CurrentLoadedChoice[i]?.options?.[0]?.dates;

            if(!ThisDates || ThisDates.length == 0)
            {
                RoomExist = false;
                ExperienceExist = false;

                window.AllChoicesBasedOnCurrentSelectedRoomAccType = [];
                window.ListOfChoicesThisAccommodation = [];

                break;
            }

            let TheFirstDateOfThisDates = window.ConvertDateStringToDateFormat(ThisDates[0].date);
            let TheLastDateOfThisDates = window.ConvertDateStringToDateFormat(ThisDates[ThisDates.length - 1].date);


            if(ThisBookType == "per night")
            {
                let IsCheckInSame = TheFirstDateOfThisDates.getTime() === CheckInDateNow.getTime();

                let IsCheckOutSame = TheLastDateOfThisDates.getTime() === CheckOutDateNow.getTime();

                if(!IsCheckInSame || !IsCheckOutSame)
                {
                    RoomExist = false;
                    ExperienceExist = false;

                    window.AllChoicesBasedOnCurrentSelectedRoomAccType = [];
                    window.ListOfChoicesThisAccommodation = [];

                    break;
                }
            }
            else if(ThisBookType == "per day")
            {
                let IsCheckInSame = TheFirstDateOfThisDates.getTime() === CheckInDateNow.getTime();

                if(!IsCheckInSame)
                {
                    RoomExist = false;
                    ExperienceExist = false;

                    window.AllChoicesBasedOnCurrentSelectedRoomAccType = [];
                    window.ListOfChoicesThisAccommodation = [];

                    break;
                }
            }
        }
        
        if(RoomExist == false || ExperienceExist == false)
        {
            NeedCheck = true;
            window.RoomPingDataCheck = null;
        }
    }
    

    if(NeedCheck == true)
    {
        let ToLoad = "Rooms";
        if(ExperienceExist == false && RoomExist == true)
            ToLoad = "Experiences";

        window.JustLoadAccommodationRoomExperience(ToLoad,
            (ThisRoomOrExperienceData, ThisChoiceGet) =>
            {
                if(!ThisRoomOrExperienceData || ThisRoomOrExperienceData.length === 0)
                {
                    return;
                }

                window.AllChoicesBasedOnCurrentSelectedRoomAccType = window.AllChoicesBasedOnCurrentSelectedRoomAccType.concat(ThisRoomOrExperienceData);
                window.ListOfChoicesThisAccommodation = window.ListOfChoicesThisAccommodation.concat(ThisChoiceGet);


                window.CheckIfAllRoomExperienceDataAlreadyLoaded(functiontocall);
            }
        );
    }
    else
    {
        console.log("window.AllChoicesBasedOnCurrentSelectedRoomAccType", window.AllChoicesBasedOnCurrentSelectedRoomAccType);
        console.log("window.ListOfChoicesThisAccommodation", window.ListOfChoicesThisAccommodation);

        if(functiontocall != null)
        {
            functiontocall();
        }
    }
};

window.JustLoadAccommodationRoomExperience = async function(whichtype, functiontocall)
{
    let URLAccRoomExpData = "/v2/hotels/" + window.HotelID + "/accommodations?checkin=" + window.ConvertArrayedDateString(window.CheckInDateNonTop) + "&checkout=" + window.ConvertArrayedDateString(window.CheckOutDateNonTop) + "&rooms=" + window.RoomQuotaNonTop;
    if(whichtype == "Experiences")
        URLAccRoomExpData = "/v2/hotels/" + window.HotelID + "/experiences?date_visit=" + window.ConvertArrayedDateString(window.CheckInDateNonTop) + "&date_until=" + window.ConvertArrayedDateString(window.CheckOutDateNonTop) + "&rooms=" + window.RoomQuotaNonTop;

    let ThisRoomOrExperienceData = [];
    let ThisChoiceGet = [];

    // Load Room or Experience Data -----------------------------

    window.CallApiAxios({
        method: "GET",
        url: URLAccRoomExpData,
    })
    .then(res =>
    {
        console.log(URLAccRoomExpData);
        
        if(res.status == 200)
        {
            let WhichData = res.data.data[0];
            ThisRoomOrExperienceData = WhichData.rooms || WhichData.experiences;

            if(whichtype == "Experiences")
            {
                window.CurrentLoadedExperience = ThisRoomOrExperienceData;
                window.CurrentChoiceDataJenisExperience = ThisRoomOrExperienceData
            }

            console.log("ThisAccExpData", ThisRoomOrExperienceData);
            
            // Prepare For Choices --------------------------------------------------

            for(let i = 0; i < ThisRoomOrExperienceData.length; i++)
            {
                let ChoiceDataToAppend =
                {
                    "id": ThisRoomOrExperienceData[i]?.id_hotel_room || ThisRoomOrExperienceData[i]?.id,
                    "type": whichtype,
                    "name_en": ThisRoomOrExperienceData[i]?.room_name || ThisRoomOrExperienceData[i]?.name_en,
                    "name_id": ThisRoomOrExperienceData[i]?.room_name || ThisRoomOrExperienceData[i]?.name_id,
                    "book_type": ThisRoomOrExperienceData[i].book_type,
                    "data": ThisRoomOrExperienceData[i],
                }
                ThisChoiceGet.push(ChoiceDataToAppend);
            }

            if(functiontocall != null)
                functiontocall(ThisRoomOrExperienceData, ThisChoiceGet);
        }
    })
    .catch(err =>
    {
        console.error(err);

        if(functiontocall != null)
            functiontocall(ThisRoomOrExperienceData, ThisChoiceGet);
        // window.CheckImageContainerImageLoaded(RoomContainerToInstant, LoadingContainer, true);
    });
} 



// =========================== EXPREZY DATA ===========================

window.LoadExprezyData = function(MainSession, loggedin)
{
    //!!!!!!!!!!!!!!!!!!!!!!!
    let URLLoadExprezy = "/v2/hotels/" + window.HotelID + "/exprezy?page=1&limit=" + window.HowManyExprezyPerPage;
    
    window.CallApiAxios({
        method: "GET",
        url: URLLoadExprezy,
    }).then(res =>
    {
        console.log(URLLoadExprezy);
        console.log(res);

        if(res.status == 200)
        {
            window.ExprezyData = res.data.data.exprezy;

            console.log(window.ExprezyData);

            if(loggedin == true) // If User Has Booked Previously, Instantiate The Section Where User Can Comment -------------------------
            {
                let CheckUserBookedHotelURL = "/v2/hotels/" + window.HotelID + "/exprezy/check?id_user=" + MainSession.usd_PING_id + "&token=" + MainSession.usd_PING_tkn;

                window.CallApiAxios({
                    method: "GET",
                    url: CheckUserBookedHotelURL,
                }).then(res =>
                {
                    CheckExprezy = res.data;

                    console.log("Check Whether User Has Book or Not-------------------------------");
                    console.log(CheckUserBookedHotelURL);
                    // console.log(res);
                    console.log(CheckExprezy);

                    // Instantiate All Commentary ----------------------------------------------
                            
                    if(CheckExprezy.data.length > 0)
                    {
                        document.getElementById("SubmitExperienceContainer").style.display = "";
                        document.getElementById("YouHaveFinishedBookMesText").innerHTML = window["YouHaveBookedPreviouslyMesTxt" + window.CurrentCountryID](window.HotelDetails.hotel_name);

                        document.getElementById("SubmitExperienceButton").onclick = function()
                        {
                            window.OpenViewMoreExperiences(null, CheckExprezy.data[0].booking_reference, MainSession, window.HotelID);
                        }
                    }
                })
                .catch(err =>
                {
                    console.error(err);
                });

                window.InstantiateAllPingExprezyData(window.ExprezyData, null, MainSession, window.HotelID, null);
            }
            else
            {
                window.InstantiateAllPingExprezyData(window.ExprezyData, null, null, window.HotelID, null);
            }
            


            // Ratings ------------------------------------------------------------

            document.getElementById("RatingMainWrapper").style.display = "";
            document.getElementById("RatingMainWrapperMobile").style.display = "";
            document.getElementById("LoadingRatingMainWrapper").style.display = "none";
                
            let TotalRating = 0;
            let TotalQuantity = window.ExprezyData.length;
                    
            for(let i = 0; i < TotalQuantity; i++)
            {
                TotalRating = TotalRating + parseInt(window.ExprezyData[i].rating);
            }

            let RatingAverage = TotalRating / TotalQuantity; // For Star Icon Class
            let ValueForClassRating = 0;

            if (Number.isInteger(RatingAverage))
            {
                ValueForClassRating = RatingAverage;
            }
            else
            {
                ValueForClassRating = Math.floor(RatingAverage) * 10 + 5;
            }

            document.getElementById("AccRatingText").innerHTML = RatingAverage;
            document.getElementById("AccRatingTextMobile").innerHTML = RatingAverage;

            document.getElementById("StarRatingIconMainWrapperMobile").classList.add("StarRating" + RatingAverage);
            document.getElementById("StarRatingIconMainWrapper").classList.add("StarRating" + RatingAverage);

            document.getElementById("TotalRatingsText").innerHTML = TotalQuantity + " " + window["RatingTxt" + window.CurrentCountryID];
            document.getElementById("TotalRatingsTextMobile").innerHTML = TotalQuantity + " " + window["RatingTxt" + window.CurrentCountryID];

            if(TotalQuantity > 1)
            {
                document.getElementById("TotalRatingsText").innerHTML = TotalQuantity + " " + window["RatingTxtex" + window.CurrentCountryID];
                document.getElementById("TotalRatingsTextMobile").innerHTML = TotalQuantity + " " + window["RatingTxtex" + window.CurrentCountryID];
            }
        }
        else
        {
            document.getElementById("RatingMainWrapper").style.display = "none";
            document.getElementById("RatingMainWrapperMobile").style.display = "none";
            document.getElementById("LoadingRatingMainWrapper").style.display = "none";
        }
    })
    .catch(err =>
    {
        console.error(err);
        document.getElementById("RatingMainWrapper").style.display = "none";
        document.getElementById("RatingMainWrapperMobile").style.display = "none";
        document.getElementById("LoadingRatingMainWrapper").style.display = "none";
    });
}

window.InstantiateAllPingExprezyData = function(ExprezyData, idbookingadd, MainUserInfo, hotelid, LocationTextToDisplay)
{
    let userID = MainUserInfo?.usd_PING_id;
    
    let PingExprezyMainContainer = document.getElementById("PingExprezyMainContainer");
    let PingExprezySwiperContainer = document.getElementById("PingExprezySwiperContainer");
    let PingExprezyWrapper = document.getElementById("PingExprezyWrapper");
    PingExprezyWrapper.innerHTML = "";

    let ExprezyButtonLeft = document.getElementById("ExprezyButtonLeft");
    let ExprezyButtonRight = document.getElementById("ExprezyButtonRight");

    PingExprezyMainContainer.style.display = "";

    console.log("ExprezyData", ExprezyData);
    
    for(let i = 0; i < ExprezyData.length; i++)
    {
        let ThisLoadingPanel = window.LoadingContentPanel(PingExprezyWrapper, 5, null);
        
        let PingExprezyPanel = document.createElement("div");
        PingExprezyPanel.className = "PingExprezyPanel InterMediumTextFont Selectable swiper-slide";
        PingExprezyPanel.onclick = function()
        {
            window.OpenViewMoreExperiences(ExprezyData[i].id_experience, idbookingadd, MainUserInfo, hotelid);
        }
        PingExprezyPanel.style.display = "none";
        PingExprezyWrapper.append(PingExprezyPanel);

        let PingExprezyImageContainer = document.createElement("div"); // Ping Exprezy -----------------------
        PingExprezyImageContainer.className = "PingExprezyImageContainer";
        PingExprezyPanel.append(PingExprezyImageContainer);

        let ThisExprezyPhotos = ExprezyData[i].photos;
        if(ExprezyData[i].photos.length <= 0)
        {
            let PhotoTempData =
            {
                "photo":"/Assets/images/NoHotelImage.jpg"
            }
            ThisExprezyPhotos.push(PhotoTempData);
        }

        let FunctionToCallAfterLoaded = function()
        {
            ThisLoadingPanel.remove();
            PingExprezyPanel.style.display = "";
        }

        window.CheckAllImageRemoveEmptyAndWaitLoadCallFunc(ThisExprezyPhotos, "photo", "/Assets/images/NoHotelImage.jpg", PingExprezyImageContainer, { quality: 70}, PingExprezyPanel, ()=>FunctionToCallAfterLoaded());

        let RatingPingExprezyContainer = document.createElement("div"); // Star Rating
        RatingPingExprezyContainer.className = "RatingPingExprezyContainer";
        PingExprezyImageContainer.append(RatingPingExprezyContainer);

        let StarRatingIcon = document.createElement("img");
        StarRatingIcon.src = "/Assets/images/ButtonIcon/star-fill.svg";
        RatingPingExprezyContainer.append(StarRatingIcon);

        let RatingTextMain = document.createElement("p");
        RatingTextMain.className = "RatingPingExprezyRatingText RobotoBoldTextFont";
        RatingTextMain.style.color = "#2494D9";
        RatingTextMain.innerHTML = ExprezyData[i].rating;
        RatingPingExprezyContainer.append(RatingTextMain);

        let RatingTextSub = document.createElement("p");
        RatingTextSub.className = "RatingPingExprezyRatingText RobotoTextFont";
        RatingTextSub.innerHTML = "/5";
        RatingPingExprezyContainer.append(RatingTextSub);


        let PingExprezyDescriptionContainer = document.createElement("div"); // Bottom Description -----------------------
        PingExprezyDescriptionContainer.className = "PingExprezyDescriptionContainer";
        PingExprezyPanel.append(PingExprezyDescriptionContainer);

        let PingExperienceDescriptionText = document.createElement("div");
        PingExperienceDescriptionText.className = "PingExperienceDescriptionText";
        PingExprezyDescriptionContainer.append(PingExperienceDescriptionText);

        let RoomHotelDescriptionInsidePanel = document.createElement("p");
        RoomHotelDescriptionInsidePanel.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont";
        RoomHotelDescriptionInsidePanel.style.color = "#344054";
        RoomHotelDescriptionInsidePanel.innerHTML = ExprezyData[i].experience;
        PingExperienceDescriptionText.append(RoomHotelDescriptionInsidePanel);

        let PingExprezyUserInfoWrapper = document.createElement("div");
        PingExprezyUserInfoWrapper.className = "PingExprezyUserInfoWrapper";
        PingExprezyDescriptionContainer.append(PingExprezyUserInfoWrapper);

        let PingExprezyUserProfileIcon = document.createElement("img");
        PingExprezyUserProfileIcon.className = "PingExprezyUserProfileIcon";
        PingExprezyUserProfileIcon.src = ExprezyData[i].user.profile_picture;
        PingExprezyUserInfoWrapper.append(PingExprezyUserProfileIcon);

        let PingExprezyUserNameLocationWrapper = document.createElement("div");
        PingExprezyUserNameLocationWrapper.className = "PingExprezyUserNameLocationWrapper";
        PingExprezyUserInfoWrapper.append(PingExprezyUserNameLocationWrapper);

        let PingExprezyUserProfileText = document.createElement("p");
        PingExprezyUserProfileText.className = "LabelGreyHeaderSmallerText InterBoldTextFont";
        let UserToDisplay = ExprezyData[i].user.first_name;
        if(userID == ExprezyData[i].user.id_user)
        {
            UserToDisplay = UserToDisplay + " <a class='InterItalicTextFont'>(" + window["YouTxt" + window.CurrentCountryID] + ")</a>";
        }
        PingExprezyUserProfileText.innerHTML = UserToDisplay;
        PingExprezyUserNameLocationWrapper.append(PingExprezyUserProfileText);

        if(LocationTextToDisplay != null)
        {
            let PingExprezyLocationText = document.createElement("p");
            PingExprezyLocationText.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
            PingExprezyLocationText.innerHTML = LocationTextToDisplay;
            PingExprezyUserNameLocationWrapper.append(PingExprezyLocationText);
        }
    }
 
    let PingExprezySwiper = new window.Swiper(PingExprezySwiperContainer,
    {
        slidesPerView: 'auto',
        spaceBetween: 0,
        direction: 'vertical',
        freeMode: true,
        observer: true,
        observeParents: true,
        navigation: {
            prevEl: ExprezyButtonLeft,
            nextEl: ExprezyButtonRight,
        },
        breakpoints:
        {
            561:
            {
                direction: 'horizontal'
            }
        }
    });

    document.getElementById("ViewMoreExperiencesButtonText").onclick = function()
    {
        window.OpenViewMoreExperiences(null, idbookingadd, MainUserInfo, hotelid);
    }

    PingExprezyMainContainer.style.display = "";
}


window.OpenViewMoreExperiences = function(whichidcurrentlyselected, bookingreferences, MainUserInfo, hotelid)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexContainerWithTopPanel = document.createElement("div");
    FlexContainerWithTopPanel.className = "FlexContainerWithTopPanel";
    BasicBlackBlocker.append(FlexContainerWithTopPanel);

    let TopHeaderContainerInsidePanel = document.createElement("div"); // Top Blue Container ------------------------------------
    TopHeaderContainerInsidePanel.className = "TopHeaderContainerInsidePanel";
    TopHeaderContainerInsidePanel.style.zIndex = 1;
    FlexContainerWithTopPanel.append(TopHeaderContainerInsidePanel);

    let TopHeaderContentWrapper = document.createElement("div");
    TopHeaderContentWrapper.className = "TopHeaderContentWrapper";
    TopHeaderContainerInsidePanel.append(TopHeaderContentWrapper)

    let PinginGoLogo = document.createElement("img");
    PinginGoLogo.className = "PinginGoLogo";
    PinginGoLogo.src = "/Assets/images/Icon/pingingo-icon.svg";
    TopHeaderContentWrapper.append(PinginGoLogo)

    let PingExprezyText = document.createElement("p");
    PingExprezyText.className = "PingExprezyText RobotoBoldTextFont";
    PingExprezyText.innerHTML = "PING-EXPREZY";
    TopHeaderContentWrapper.append(PingExprezyText)

    let CloseButtonInsidePanel = document.createElement("img");
    CloseButtonInsidePanel.className = "CloseButtonInsidePanel Selectable2";
    CloseButtonInsidePanel.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButtonInsidePanel.onclick = function()
    {
        window.ClosePanelAnimate(FlexContainerWithTopPanel, BasicBlackBlocker, null);
    }
    TopHeaderContainerInsidePanel.append(CloseButtonInsidePanel)


    let FlexContainerBaseAnimate = document.createElement("div"); // Main Container ------------------------------------------------------
    FlexContainerBaseAnimate.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    FlexContainerWithTopPanel.append(FlexContainerBaseAnimate);

    
    if(bookingreferences != null)
    {
        let InputUserExperienceMainContainer = document.createElement("div"); // Main Container ----------
        InputUserExperienceMainContainer.className = "InputUserExperienceMainContainer";
        FlexContainerBaseAnimate.append(InputUserExperienceMainContainer);

        let YouHaveFinishedMessageP = document.createElement("p");
        YouHaveFinishedMessageP.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont";
        YouHaveFinishedMessageP.innerHTML = window["YouHaveFinishedStayingExprezyTxt" + window.CurrentCountryID](window.HotelDetails.hotel_name);
        InputUserExperienceMainContainer.append(YouHaveFinishedMessageP);

        let TellUserExperienceWrapper = document.createElement("div");
        TellUserExperienceWrapper.className = "TellUserExperienceWrapper";
        InputUserExperienceMainContainer.append(TellUserExperienceWrapper);
        
        let TellMeYourExperienceMessageP = document.createElement("p");
        TellMeYourExperienceMessageP.className = "LabelGreyHeaderText InterBoldTextFont";
        TellMeYourExperienceMessageP.style.marginBottom = "0 !important;";
        TellMeYourExperienceMessageP.style.width = "100%";
        TellMeYourExperienceMessageP.style.textAlign = "center";
        TellMeYourExperienceMessageP.textContent = window["TellMeYourExperiencesTxt" + window.CurrentCountryID];
        TellUserExperienceWrapper.append(TellMeYourExperienceMessageP);

        // Rating Star
        let RatingStarContainer = document.createElement("div");
        RatingStarContainer.className = "UserExperienceRatingContainer";
        RatingStarContainer.setAttribute("current-rating", 0);
        TellUserExperienceWrapper.append(RatingStarContainer);


        // Upload Photo
        let uploadPhotoExprezyContainer = document.createElement("div");
        uploadPhotoExprezyContainer.className = "UserExperienceUploadPhoto BasicRadius BasicBoxShadowMid";
        uploadPhotoExprezyContainer.style.display = "none";
        TellUserExperienceWrapper.append(uploadPhotoExprezyContainer);

        let uploadPhotoExprezyImg = document.createElement("img");
        // uploadPhotoExprezyImg.src = "/Assets/images/AnimateBG/1.jpg";
        uploadPhotoExprezyContainer.append(uploadPhotoExprezyImg);

        let uploadPhotoExprezyBlocker = document.createElement("div");
        uploadPhotoExprezyBlocker.className = "BlockerWithHoverableText BlockerOpacityOnHover";
        uploadPhotoExprezyBlocker.style = "width: 100%; height: 100%; position: absolute; top: 0; left: 0;";
        uploadPhotoExprezyContainer.append(uploadPhotoExprezyBlocker);

        let uploadPhotoExprezyBlockerText = document.createElement("p");
        uploadPhotoExprezyBlockerText.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont";
        uploadPhotoExprezyBlockerText.textContent = window["RemovePhotoTxt" + window.CurrentCountryID];
        uploadPhotoExprezyBlocker.append(uploadPhotoExprezyBlockerText);


        let NewExperiencesInputFileImg = document.createElement("input");
        NewExperiencesInputFileImg.type = "file";
        NewExperiencesInputFileImg.id = "NewExperiencesInputFileImg";
        NewExperiencesInputFileImg.style.display = "none";
        NewExperiencesInputFileImg.accept = ".jpg, .png, .jpeg";
        TellUserExperienceWrapper.append(NewExperiencesInputFileImg);

        
        // Warning Error
        let PingExprezyWarningContainer = document.createElement("div");
        PingExprezyWarningContainer.className = "BasicRadius MarginTextUpDown RedWarningContainer";
        PingExprezyWarningContainer.id = "PingExprezyWarningContainer";
        PingExprezyWarningContainer.style.marginTop = 0;
        PingExprezyWarningContainer.style.display = "none";
        TellUserExperienceWrapper.append(PingExprezyWarningContainer);

        let PingExprezyWarningText = document.createElement("p");
        PingExprezyWarningText.className = "InterMediumTextFont";
        PingExprezyWarningText.id = "PingExprezyWarningText";
        PingExprezyWarningContainer.append(PingExprezyWarningText);


        // Text Area container
        let PingExprezyTextContainer = document.createElement("div");
        PingExprezyTextContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        PingExprezyTextContainer.id = "ContactUsYourMessageInputContainer";
        PingExprezyTextContainer.style.cssText = "width: 100%; min-width: 100%;";
        TellUserExperienceWrapper.append(PingExprezyTextContainer);

        let PingExprezyTextArea = document.createElement("textarea");
        PingExprezyTextArea.rows = "4";
        PingExprezyTextArea.cols = "50";
        PingExprezyTextArea.className = "InputFieldInsideSmallPanel ContactUsMessageInputField InputFieldSelectable InterMediumTextFont";
        PingExprezyTextArea.placeholder = window["PlaceholderTellMeExperiencesTxt" + window.CurrentCountryID];
        PingExprezyTextContainer.append(PingExprezyTextArea);


        // Add photo button
        let AddPhotoButtonExprezy = document.createElement("button");
        AddPhotoButtonExprezy.className = "BasicTextButton OrangeButton SignInButtonTop Selectable MarginTextUpDown";
        AddPhotoButtonExprezy.style = "width: 100%; margin-bottom: 0 !important";
        TellUserExperienceWrapper.append(AddPhotoButtonExprezy);

        let AddPhotoButtonExprezyWrapper = document.createElement("div");
        AddPhotoButtonExprezyWrapper.style.cssText = "width: fit-content; height: fit-content; display: flex; margin: auto;";
        AddPhotoButtonExprezy.append(AddPhotoButtonExprezyWrapper);

        let AddPhotoButtonExprezyIcon = document.createElement("img");
        AddPhotoButtonExprezyIcon.src = "/Assets/images/ButtonIcon/camera-plus.svg";
        AddPhotoButtonExprezyIcon.className = "BasicIconInsideButton";
        AddPhotoButtonExprezyIcon.style.marginLeft = "0";
        AddPhotoButtonExprezyWrapper.append(AddPhotoButtonExprezyIcon);

        let AddPhotoButtonExprezyText = document.createElement("p");
        AddPhotoButtonExprezyText.textContent = window["AddPhotoToYourExperiencesButtonTxt" + window.CurrentCountryID];
        AddPhotoButtonExprezyText.style.whiteSpace = "nowrap";
        AddPhotoButtonExprezyWrapper.append(AddPhotoButtonExprezyText);


        // Submit button
        let SubmitExperienceButton = document.createElement("button");
        SubmitExperienceButton.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable MarginTextUpDown";
        SubmitExperienceButton.style.marginBottom = "0 !important";
        SubmitExperienceButton.style.cssText = "width: 100%; background-color: #50A9E1; margin-bottom: 0!important";
        TellUserExperienceWrapper.append(SubmitExperienceButton);

        let SubmitExperienceWrapper = document.createElement("div");
        SubmitExperienceWrapper.style.cssText = "width: fit-content; height: fit-content; display: flex; margin: auto;";
        SubmitExperienceButton.append(SubmitExperienceWrapper);

        let SubmitExperienceIcon = document.createElement("img");
        SubmitExperienceIcon.className = "BasicIconInsideButton PlusIconWhiteButton";
        SubmitExperienceIcon.style.marginLeft = "0";
        SubmitExperienceWrapper.append(SubmitExperienceIcon);

        let SubmitExperienceText = document.createElement("p");
        SubmitExperienceText.innerHTML = window["SubmitExperienceButtonTxt" + window.CurrentCountryID];
        SubmitExperienceText.style.whiteSpace = "nowrap";
        SubmitExperienceWrapper.append(SubmitExperienceText);


        // ------------------------ ADD FUNCTION --------------------------------

        let CheckFunctionToCall = function(isallowchange)
        {
            CheckInputtedNewExprezzy(isallowchange, bookingreferences, MainUserInfo, hotelid, FlexContainerWithTopPanel, BasicBlackBlocker, RatingStarContainer, NewExperiencesInputFileImg, PingExprezyWarningContainer, PingExprezyWarningText, PingExprezyTextContainer, PingExprezyTextArea, SubmitExperienceButton);
        }

        for (let i = 0; i < 5; i++)
        {
            let RatingStar = document.createElement("img");
            RatingStar.className = "UserExperienceStar Selectable2";
            RatingStar.onclick = function()
            {
                PingExprezyWarningContainer.style.display = "none";
                RatingStarContainer.className = "UserExperienceRatingContainer UserExperienceCurrent" + (i+1);
                RatingStarContainer.setAttribute("current-rating", i+1);
                CheckFunctionToCall(true);
            }
            RatingStarContainer.append(RatingStar);
        }

        NewExperiencesInputFileImg.onchange = function()
        {
            if(NewExperiencesInputFileImg.files[0] == null)
            {
                uploadPhotoExprezyContainer.style.display = "none";
                uploadPhotoExprezyImg.src = "";
            }
            else
            {
                uploadPhotoExprezyContainer.style.display = "";
                uploadPhotoExprezyImg.src = URL.createObjectURL(NewExperiencesInputFileImg.files[0]);
            }
            CheckFunctionToCall(true);
        }

        uploadPhotoExprezyBlocker.onclick = function()
        {
            NewExperiencesInputFileImg.value = null;
            uploadPhotoExprezyContainer.style.display = "none";
            CheckFunctionToCall(true);
        }

        AddPhotoButtonExprezy.onclick = function()
        {
            NewExperiencesInputFileImg.click();
        }


        PingExprezyTextArea.onfocus = function(event)
        {
            SubmitExperienceButton.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable MarginTextUpDown";
            PingExprezyTextContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
            PingExprezyWarningContainer.style.display = "none";
        }
        PingExprezyTextArea.addEventListener("focusout", (event) =>
        {
            CheckFunctionToCall(true);
        });

        CheckFunctionToCall(false);
    }

    // ------------------------------ PAST EXPREZY------------------------------

    if(bookingreferences == null)
    {
        let PastExprezyMainContainer = document.createElement("div"); 
        PastExprezyMainContainer.className = "ListofExprezyAllContainer";
        FlexContainerBaseAnimate.append(PastExprezyMainContainer);

        let PaymentSectionHeaderText = document.createElement("p"); 
        PaymentSectionHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
        PaymentSectionHeaderText.style = "width: fit-content; margin: 0 auto;";
        PaymentSectionHeaderText.innerHTML = window.HotelDetails.hotel_name;
        PastExprezyMainContainer.append(PaymentSectionHeaderText);

        let BasicContentScroller = document.createElement("div");
        BasicContentScroller.className = "BasicContentScroller HideScrollBar";
        PastExprezyMainContainer.append(BasicContentScroller);

        let ScrollSentinelExprezy = document.createElement("div");
        PastExprezyMainContainer.append(ScrollSentinelExprezy);
        
        window.CurrentExprezyIndex = 1;
        window.ExprezyLastPage = 1;
        window.LoadExprezyDataBasedOnPage(whichidcurrentlyselected, hotelid, MainUserInfo, BasicContentScroller, ScrollSentinelExprezy);
    }


    //------------------------------------ ANIMATE EASE IN --------------------------------------

    window.OpenPanelAnimate(FlexContainerWithTopPanel, BasicBlackBlocker);
}

window.LoadExprezyDataBasedOnPage = function(whichidcurrentlyselected, hotelid, MainUserInfo, BasicContentScroller, ScrollSentinelExprezy)
{
    let LoadingTempInstantiated = [];
    for(let i = 0; i < window.HowManyExprezyPerPage; i++)
    {
        LoadingTempInstantiated.push(InstantiateLoadingExprezyCommentFullScreen(BasicContentScroller));
    }
    
    let URLLoadExprezy = "/v2/hotels/" + hotelid + "/exprezy?page=" + window.CurrentExprezyIndex + "&limit=" + window.HowManyExprezyPerPage;

    window.CallApiAxios({
        method: "GET",
        url: URLLoadExprezy,
    }).then(res =>
    {
        console.log(URLLoadExprezy);
        console.log(res);

        if(res.status == 200)
        {
            let ExprezyData = res.data.data.exprezy;

            LoadingTempInstantiated.forEach(loadingtemp => {
                loadingtemp.remove();
            });

            InstantiateExprezyCommentPanel(ExprezyData, whichidcurrentlyselected, MainUserInfo, BasicContentScroller);

            if(window.CurrentExprezyIndex == 1)
            {
                if(res.data.pagination.total_pages != null)
                {
                    window.ExprezyLastPage = res.data.pagination.total_pages;
                }

                let ThisDataObserverOption = {
                    pageKey: "CurrentExprezyIndex",
                    lastPageKey: "ExprezyLastPage",
                    sentinelEl: ScrollSentinelExprezy,
                    functiontocall: () =>
                    {
                        return window.LoadExprezyDataBasedOnPage(whichidcurrentlyselected, hotelid, MainUserInfo, BasicContentScroller, ScrollSentinelExprezy);
                    }
                };
                window.ExprezyScrollObserver = window.makeObserver(ThisDataObserverOption);
            }
        }
    })
    .catch(err =>
    {
        console.error(err);
        LoadingTempInstantiated.forEach(loadingtemp => {
            loadingtemp.remove();
        });
    });
}

function InstantiateExprezyCommentPanel(ExprezyData, whichidcurrentlyselected, MainUserInfo, wheretoInstantiate)
{
    let ScrollToDropDown;
    let userID = MainUserInfo.usd_PING_id;

    for(let i = 0; i < ExprezyData.length; i++)
    {
        let LoadingExprezy = InstantiateLoadingExprezyCommentFullScreen(wheretoInstantiate)

        let PingExprezyPanelViewDetails = document.createElement("div");
        PingExprezyPanelViewDetails.className = "PingExprezyPanelViewDetails InterMediumTextFont";
        PingExprezyPanelViewDetails.style.opacity = 0;
        wheretoInstantiate.append(PingExprezyPanelViewDetails);

        let PingExprezyImageContainerFullDisplay = document.createElement("img");
        PingExprezyImageContainerFullDisplay.className = "PingExprezyImageContainerFullDisplay";
        window.checkImageUrlValid(ExprezyData[i].photos[0], "/Assets/images/NoHotelImage.jpg", PingExprezyImageContainerFullDisplay, () =>
        {
            window.CheckIfImageLoadedAndCallAFunction(PingExprezyPanelViewDetails, ()=>
            {
                LoadingExprezy.remove();
                PingExprezyPanelViewDetails.style.opacity = 1;
            });
        }, {});
        PingExprezyPanelViewDetails.append(PingExprezyImageContainerFullDisplay);

        let PingExprezyDescriptionContainer = document.createElement("div");
        PingExprezyDescriptionContainer.className = "PingExprezyDescriptionContainer";
        PingExprezyPanelViewDetails.append(PingExprezyDescriptionContainer);

        let TopUserAndDateInfoWrapper = document.createElement("div"); // User and Date ---------------------
        TopUserAndDateInfoWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
        TopUserAndDateInfoWrapper.style = "flex: 1; height: fit-content; display: flex;";
        PingExprezyDescriptionContainer.append(TopUserAndDateInfoWrapper);

        let PingExprezyUserInfoWrapper = document.createElement("div");
        PingExprezyUserInfoWrapper.className = "PingExprezyUserInfoWrapper";
        TopUserAndDateInfoWrapper.append(PingExprezyUserInfoWrapper);

        let PingExprezyUserProfileIcon = document.createElement("img");
        PingExprezyUserProfileIcon.className = "PingExprezyUserProfileIcon";
        PingExprezyUserProfileIcon.src = ExprezyData[i].user.profile_picture;
        PingExprezyUserInfoWrapper.append(PingExprezyUserProfileIcon);

        let PingExprezyUserProfileName = document.createElement("p");
        PingExprezyUserProfileName.className = "LabelGreyHeaderText InterBoldTextFont";
        let UserToDisplay = ExprezyData[i].user.first_name;
        if(userID == ExprezyData[i].user.id_user)
        {
            UserToDisplay = UserToDisplay + " <a class='InterItalicTextFont'>(" + window["YouTxt" + window.CurrentCountryID] + ")</a>";
        }
        PingExprezyUserProfileName.innerHTML = UserToDisplay;
        PingExprezyUserInfoWrapper.append(PingExprezyUserProfileName);

        let DatePublishedText = document.createElement("p");
        DatePublishedText.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
        DatePublishedText.style = "margin-left: auto; white-space: nowrap;";
        DatePublishedText.innerHTML = window.GetHowManyPastMinHourDaysDate(ExprezyData[i].create_update_at);
        TopUserAndDateInfoWrapper.append(DatePublishedText);


        let StarRatingWrapper = document.createElement("div"); // Star Rating ---------------------
        StarRatingWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
        PingExprezyDescriptionContainer.append(StarRatingWrapper);

        let StarRatingIconWrapper = document.createElement("div");
        StarRatingIconWrapper.className = "StarRatingIconWrapper StarRating" + ExprezyData[i].rating;
        StarRatingWrapper.append(StarRatingIconWrapper);
        

        for(let j = 0; j < 5; j++)
        {
            let StarRatingIcon = document.createElement("div");
            StarRatingIcon.className = "StarRatingIcon";
            StarRatingIconWrapper.append(StarRatingIcon);
        }

        let StarRatingTextWrapper = document.createElement("div");
        StarRatingTextWrapper.className = "StarRatingIconWrapper";
        StarRatingWrapper.append(StarRatingTextWrapper);

        let RatingMainText = document.createElement("p");
        RatingMainText.className = "RatingBlueText InterBoldTextFont";
        RatingMainText.innerHTML = ExprezyData[i].rating;
        StarRatingTextWrapper.append(RatingMainText);

        let RatingSubsText = document.createElement("p");
        RatingSubsText.className = "RatingGreyText InterRegularTextFont";
        RatingSubsText.innerHTML = "/5";
        StarRatingTextWrapper.append(RatingSubsText);


        let RoomHotelDescriptionInsidePanel = document.createElement("p"); // Description ---------------------
        RoomHotelDescriptionInsidePanel.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont";
        RoomHotelDescriptionInsidePanel.style = "color: rgb(52, 64, 84); margin-bottom: 0;";
        RoomHotelDescriptionInsidePanel.innerHTML = ExprezyData[i].experience;
        PingExprezyDescriptionContainer.append(RoomHotelDescriptionInsidePanel);

        // Get Information For Basic Scroll Start
        if(whichidcurrentlyselected == ExprezyData[i].id_experience)
        {
            ScrollToDropDown = PingExprezyPanelViewDetails;
        }
    }

    window.ScrollToSelectedDropDown(wheretoInstantiate, ScrollToDropDown);

}

function InstantiateLoadingExprezyCommentFullScreen(wheretoInstantiate)
{
    let PingExprezyPanelViewDetails = document.createElement("div");
    PingExprezyPanelViewDetails.className = "PingExprezyPanelViewDetails InterMediumTextFont";
    wheretoInstantiate.append(PingExprezyPanelViewDetails);

    let DivImageExprezyContainer = document.createElement("div");
    DivImageExprezyContainer.className = "PingExprezyImageContainerFullDisplay";
    PingExprezyPanelViewDetails.append(DivImageExprezyContainer);

    let LoadingGreyCover = document.createElement("div");
    LoadingGreyCover.className = "loading_grey ImageFullCover";
    DivImageExprezyContainer.append(LoadingGreyCover);

    let PingExprezyImageContainerFullDisplay = document.createElement("img");
    PingExprezyImageContainerFullDisplay.className = "PingExprezyImageContainerFullDisplay";
    PingExprezyImageContainerFullDisplay.style.opacity = 0;
    PingExprezyImageContainerFullDisplay.src = "/Assets/images/NoHotelImage.jpg";
    DivImageExprezyContainer.append(PingExprezyImageContainerFullDisplay);

    let PingExprezyDescriptionContainer = document.createElement("div");
    PingExprezyDescriptionContainer.className = "PingExprezyDescriptionContainer";
    PingExprezyPanelViewDetails.append(PingExprezyDescriptionContainer);

    let TopUserAndDateInfoWrapper = document.createElement("div"); // User and Date ---------------------
    TopUserAndDateInfoWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    TopUserAndDateInfoWrapper.style = "flex: 1; height: fit-content; display: flex;";
    PingExprezyDescriptionContainer.append(TopUserAndDateInfoWrapper);

    let PingExprezyUserInfoWrapper = document.createElement("div");
    PingExprezyUserInfoWrapper.className = "PingExprezyUserInfoWrapper";
    TopUserAndDateInfoWrapper.append(PingExprezyUserInfoWrapper);

    let LoadingProfileImageExprezy = document.createElement("div");
    LoadingProfileImageExprezy.className = "PingExprezyUserProfileIcon loading_grey ImageFullCover";
    PingExprezyUserInfoWrapper.append(LoadingProfileImageExprezy);

    let PingExprezyUserProfileIcon = document.createElement("div");
    PingExprezyUserProfileIcon.className = "ImageFullCover loading_grey";
    LoadingProfileImageExprezy.append(PingExprezyUserProfileIcon);

    let PingExprezyUserProfileName = document.createElement("p");
    PingExprezyUserProfileName.className = "LabelGreyHeaderText InterBoldTextFont loading_grey";
    PingExprezyUserProfileName.innerHTML = "Test1234";
    PingExprezyUserProfileName.style.color = "transparent";
    PingExprezyUserInfoWrapper.append(PingExprezyUserProfileName);

    let DatePublishedText = document.createElement("p");
    DatePublishedText.className = "LabelGreyHeaderSmallerText InterRegularTextFont loading_grey";
    DatePublishedText.style = "margin-left: auto; white-space: nowrap;";
    DatePublishedText.style.color = "transparent";
    DatePublishedText.innerHTML = "01 January 2025";
    TopUserAndDateInfoWrapper.append(DatePublishedText);


    let StarRatingWrapper = document.createElement("div"); // Star Rating ---------------------
    StarRatingWrapper.className = "HotelDetailsHotelInformationMarginWrapper loading_grey";
    StarRatingWrapper.style.width = "fit-content";
    PingExprezyDescriptionContainer.append(StarRatingWrapper);

    let StarRatingIconWrapper = document.createElement("div");
    StarRatingIconWrapper.className = "StarRatingIconWrapper StarRating5";
    StarRatingWrapper.append(StarRatingIconWrapper);

    for(let j = 0; j < 5; j++)
    {
        let StarRatingIcon = document.createElement("div");
        StarRatingIcon.className = "StarRatingIcon";
        StarRatingIcon.style.opacity = 0;
        StarRatingIconWrapper.append(StarRatingIcon);
    }

    let StarRatingTextWrapper = document.createElement("div");
    StarRatingTextWrapper.className = "StarRatingIconWrapper";
    StarRatingWrapper.append(StarRatingTextWrapper);

    let RatingMainText = document.createElement("p");
    RatingMainText.className = "RatingBlueText InterBoldTextFont";
    RatingMainText.innerHTML = 5;
    RatingMainText.style.opacity = 0;
    StarRatingTextWrapper.append(RatingMainText);

    let RatingSubsText = document.createElement("p");
    RatingSubsText.className = "RatingGreyText InterRegularTextFont";
    RatingSubsText.innerHTML = "/5";
    RatingSubsText.style.opacity = 0;
    StarRatingTextWrapper.append(RatingSubsText);


    let RoomHotelDescriptionInsidePanel = document.createElement("p"); // Description ---------------------
    RoomHotelDescriptionInsidePanel.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont loading_grey";
    RoomHotelDescriptionInsidePanel.style = "color: transparent; margin-bottom: 0;";
    RoomHotelDescriptionInsidePanel.innerHTML = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vel justo hendrerit, fermentum velit ut, hendrerit mauris. Aenean placerat purus ut magna faucibus malesuada. Proin ultrices euismod diam sed mollis. Fusce pretium magna non leo mollis, quis luctus nunc consequat. Integer a vestibulum ante. Donec et dolor dui. Integer lobortis in risus pharetra congue. Morbi at enim blandit, posuere metus at, cursus nibh. Nunc nec volutpat felis, eget tristique lectus. Morbi vel ex a tortor viverra dapibus.";
    PingExprezyDescriptionContainer.append(RoomHotelDescriptionInsidePanel);

    return PingExprezyPanelViewDetails
}


function CheckInputtedNewExprezzy(isallowchange, bookingreferences, MainUserInfo, hotelid, FlexContainerWithTopPanel, BasicBlackBlocker, RatingStarContainer, NewExperiencesInputFileImg, PingExprezyWarningContainer, PingExprezyWarningText, PingExprezyTextContainer, PingExprezyTextArea, SubmitExperienceButton)
{
    let IsInputtedValid = true;
    let CurrentRating = RatingStarContainer.getAttribute("current-rating");
    PingExprezyWarningContainer.style.display = "none";

    if(parseInt(CurrentRating) < 1)
    {
        IsInputtedValid = false;

        if(isallowchange == true)
        {
            PingExprezyWarningContainer.style.display = "";
            PingExprezyWarningText.innerHTML = window["RatingMustBetween1To5Txt" + window.CurrentCountryID];
        }
    }

    if(PingExprezyTextArea.value == ""  || PingExprezyTextArea.value.replace(/ /g, "") == "") // First Name
    {
        IsInputtedValid = false;

        if(isallowchange == true)
        {
            PingExprezyTextContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";

            PingExprezyWarningContainer.style.display = "";
            PingExprezyWarningText.innerHTML = window["UserExperienceCannotBeEmptyTxt" + window.CurrentCountryID];
        }
    }

    if(NewExperiencesInputFileImg.files.length <= 0)
    {
        IsInputtedValid = false;

        if(isallowchange == true)
        {
            PingExprezyWarningContainer.style.display = "";
            PingExprezyWarningText.innerHTML = window["ExperiencePhotoCannotEmptyTxt" + window.CurrentCountryID];
        }
    }

    if(IsInputtedValid == true)
    {
        SubmitExperienceButton.className = "BasicTextButton OrangeButton SignInButtonTop Selectable MarginTextUpDown";
        SubmitExperienceButton.onclick = function()
        {
            let formData = new FormData();

            formData.append('id_user', MainUserInfo.usd_PING_id);
            formData.append('token', MainUserInfo.usd_PING_tkn);
            formData.append('rating', CurrentRating);
            formData.append('experience', PingExprezyTextArea.value);

            PushPhotoAndMessageExperience(bookingreferences, NewExperiencesInputFileImg.files[0], formData, FlexContainerWithTopPanel, BasicBlackBlocker, PingExprezyWarningContainer, PingExprezyWarningText);
        }
    }
    else
    {
        SubmitExperienceButton.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable MarginTextUpDown";
        SubmitExperienceButton.onclick = function(){};
    }
}

function PushPhotoAndMessageExperience(bookingreferences, imageinput, formData, FlexContainerWithTopPanel, BasicBlackBlocker, PingExprezyWarningContainer, PingExprezyWarningText)
{
    let UploadPhotoExprezyURL = "/v2/bookings/" + bookingreferences + "/exprezy/upload";
    let UploadExprezyBasicInfoURL = "/v2/bookings/" + bookingreferences + "/exprezy";

    console.log(window.ConvertFormDataToJSON(formData));
    
    let SubmitExBlocker = window.InstantiateLoadingBlocker("SubmitExBlocker");
    ///!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    window.CallApiAxios({
        method: "POST",
        url: UploadExprezyBasicInfoURL,
        data: formData
    }).then(res =>
    {
        console.log(UploadExprezyBasicInfoURL);
        console.log(res);

        if(res.status == 201)
        {
            formData.append('id_experience', res.data.data.id_experience);
            formData.append('image', imageinput);

            window.CallApiAxios({
                method: "POST",
                url: UploadPhotoExprezyURL,
                data: formData,
                convertFormData: false
            }).then(res =>
            {
                console.log(UploadPhotoExprezyURL);
                console.log(res);
                if(res.status == 201)
                {
                    window.ClosePanelAnimate(FlexContainerWithTopPanel, BasicBlackBlocker, null);
                    window.location.reload();
                }
                else
                {
                    PingExprezyWarningContainer.style.display = "";
                    PingExprezyWarningText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
                }

                SubmitExBlocker.remove();
            })
            .catch(err =>
            {
                console.error(err);
                PingExprezyWarningContainer.style.display = "";
                SubmitExBlocker.remove();
                if(err.data.message == "Failed to upload exprezy photo")
                {
                    PingExprezyWarningText.innerHTML = window["FailedToUploadExprezyPhotoTxt" + window.CurrentCountryID];
                }
                else if(err.data.errors != null)
                {
                    if(err.data.errors.id_experience == "The selected id_experience is invalid.")
                    {
                        PingExprezyWarningText.innerHTML = window["IDExperinceInvalidTxt" + window.CurrentCountryID];
                    }
                    else if(err.data.errors.image == "The image must be an image file.")
                    {
                        PingExprezyWarningText.innerHTML = window["ErrorImageMustBeImageFileTxt" + window.CurrentCountryID];
                    }
                }
                else
                {
                    PingExprezyWarningText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
                }
            });
        }
    })
    .catch(err =>
    {
        console.error(err);
        PingExprezyWarningContainer.style.display = "";
        SubmitExBlocker.remove();

        if(err.data.message == "Booking not found for this user")
        {
            PingExprezyWarningText.innerHTML = window["ErrorBookingNotFoundForThisUserTxt" + window.CurrentCountryID];
        }
        else if(err.data.message == "Experience already exists for this booking")
        {
            PingExprezyWarningText.innerHTML = window["ErrorExprezyAlreayExistTxt" + window.CurrentCountryID];
        }
        else if(err.data.message == "Failed to create exprezy")
        {
            PingExprezyWarningText.innerHTML = window["FailedToSendUserExTxt" + window.CurrentCountryID];
        }
        else
        {
            PingExprezyWarningText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
        }
    });
}

// ========================================== INSTANTIATE HOTEL IMAGE ============================================

window.AllHotelImagePool = null;
window.AllFacilitiesImagePool = [];
window.AllRoomImagePool = [];
window.AllExperienceImagePool = [];

window.PreparetoInstantiateHotelImage = function(HotelPhotos) // Load Hotel Image As Pool ---------------------------------
{
    (async () =>
    {
        window.AllHotelImagePool = await window.createImagePoolImmediate(HotelPhotos);

        window.AllRoomImagePool = window.AllHotelImagePool.filter(img => img.getAttribute("type") === "Room");
        window.AllFacilitiesImagePool = window.AllHotelImagePool.filter(img => img.getAttribute("type") === "Hotel");
        window.AllExperienceImagePool = window.AllHotelImagePool.filter(img => img.getAttribute("type") === "Experience");

        window.FinalPreparationInstantiateHotelImage();
        window.resolvePoolInBackground(window.AllHotelImagePool, "/Assets/images/NoHotelImage.jpg");
    })();

    return
    (async () =>
    {
        window.AllHotelImagePool = await window.buildImagePoolCompleteLoad(HotelPhotos, "/Assets/images/NoHotelImage.jpg", {quality: 100});
        console.log(window.AllHotelImagePool);

        window.AllHotelImagePool.forEach(PhotoData =>
        {
            if(PhotoData.getAttribute("type") == "Room")
            {
                window.AllRoomImagePool.push(PhotoData);
            }
            else
            {
                window.AllFacilitiesImagePool.push(PhotoData);
            }
        });

        window.FinalPreparationInstantiateHotelImage();
    })();
}

window.FinalPreparationInstantiateHotelImage = function()
{
    window.WhatCurrentImageIndex = 0;

    let ImagePreviewBackgroundContainer = document.getElementById("ImagePreviewBackgroundContainer");
    ImagePreviewBackgroundContainer.style.display = "";
    let LoadingImageBackgroundPreview = document.getElementById("LoadingImageBackground");
    LoadingImageBackgroundPreview.style.display = "none";
    let ImageTopMainWrapper = document.getElementById("ImageTopMainWrapper");

    let MiniImageListSwiperContainer = document.getElementById("MiniImageListSwiperContainer");
    let MiniImageListSwiperWrapper = document.getElementById("MiniImageListSwiperWrapper");
    MiniImageListSwiperWrapper.innerHTML = "";
    let ImgSwiperPrevButton = document.getElementById("ImgSwiperPrevButton");
    let ImgSwiperNextButton = document.getElementById("ImgSwiperNextButton");

    let RemainingPhotoTextContainer = document.getElementById("RemainingPhotoTextContainer");
    if(RemainingPhotoTextContainer != null)
    RemainingPhotoTextContainer.style.display = "";

    let RemainingPhotoText = document.getElementById("RemainingPhotoText");

    let PrevMobilePhotoButtonContainer = document.getElementById("PrevMobilePhotoButtonContainer");
    if(PrevMobilePhotoButtonContainer != null)
        PrevMobilePhotoButtonContainer.style.display = "";

    let PrevMobilePhotoButton = document.getElementById("PrevMobilePhotoButton");

    let NextMobilePhotoButtonContainer = document.getElementById("NextMobilePhotoButtonContainer");
    if(NextMobilePhotoButtonContainer != null)
        NextMobilePhotoButtonContainer.style.display = "";

    let NextMobilePhotoButton = document.getElementById("NextMobilePhotoButton");




    let ListOfPrevImageButton = [ImgSwiperPrevButton, PrevMobilePhotoButton];
    let ListOfNextImageButton = [ImgSwiperNextButton, NextMobilePhotoButton];

    // Instantiate Images ------------------------------------------------------------------------------

    window.InstantiateHotelImage(ImagePreviewBackgroundContainer, LoadingImageBackgroundPreview, ImageTopMainWrapper);

    // Mini choice Image ---------------------------------------------------------------------------------
    
    MainImageSwiper = new window.Swiper(MiniImageListSwiperContainer, 
    {
        effect: 'coverflow',
        freeMode: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        centeredSlides: true,
        coverflowEffect: {
            rotate: 30,
            stretch: 0,
            depth: 150,
            modifier: 1,
            slideShadows: true,
        },
        navigation: {
            nextEl: ListOfNextImageButton,
            prevEl: ListOfPrevImageButton,
        },
        on:{
        slideChange : function()
        {
            window.WhatCurrentImageIndex = this.activeIndex;
            const totalSlides = MainImageSwiper.slides.length;

            let TextToDisplay = (window.WhatCurrentImageIndex + 1) + "/" + totalSlides;
            if(RemainingPhotoText != null)
            RemainingPhotoText.innerHTML = TextToDisplay;
            
            window.InstantiateHotelImage(ImagePreviewBackgroundContainer, LoadingImageBackgroundPreview, ImageTopMainWrapper);
        }}
    });


    window.WhatCurrentImageIndex = MainImageSwiper.activeIndex;
    if(RemainingPhotoText != null)
    RemainingPhotoText.innerHTML = (window.WhatCurrentImageIndex + 1) + "/" + window.AllHotelImagePool.length;


    for(let i = 0; i < window.AllHotelImagePool.length; i++)
    {
        let HotelImageSwiperPanel = document.createElement("div");
        HotelImageSwiperPanel.className = "HotelImageSwiperPanel swiper-slide Selectable2";
        HotelImageSwiperPanel.onclick = function()
        {
            MainImageSwiper.slideTo(i);
        }
        MiniImageListSwiperWrapper.append(HotelImageSwiperPanel);

        let LoadingSkeleton = document.createElement("div"); // Loading Grey -------------
        LoadingSkeleton.className = "loading_grey ImageFullCover";
        HotelImageSwiperPanel.append(LoadingSkeleton);

        let baseImg = window.AllHotelImagePool[i]; // Clone Image From Pool ----------------

        let ThisClonedImage = document.createElement("img");
        ThisClonedImage.style.opacity = 0;
        ThisClonedImage.className = "ImageFullCover";

        baseImg._clones ??= [];
        baseImg._clones.push(ThisClonedImage);

        window.HandleLoadingSkeletonAndImage(LoadingSkeleton, ThisClonedImage);

        let ImageSmallChoice = HotelImageSwiperPanel.appendChild(ThisClonedImage); // Append Image ----------------
        ImageSmallChoice.classList.add("ImageFullCover");
    }

    ImgSwiperNextButton.style.opacity = "";
    ImgSwiperPrevButton.style.opacity = "";
}

window.InstantiateHotelImage = function(ImagePreviewBackgroundContainer, LoadingImageBackgroundPreview, ImageTopMainWrapper)
{
    ImageTopMainWrapper.innerHTML = "";
    ImagePreviewBackgroundContainer.innerHTML = "";

    // let ImagePreviewBackground = ImagePreviewBackgroundContainer.appendChild(window.AllHotelImagePool[WhatCurrentImageIndex].cloneNode(true));
    let ImagePreviewBackground = ImagePreviewBackgroundContainer.appendChild(window.bindImageFromPool(window.AllHotelImagePool[window.WhatCurrentImageIndex]));

    ImagePreviewBackground.id = "ImagePreviewBackground";
    ImagePreviewBackground.classList.add("RoomPanelImageBackgroundDisplay");

    // window.checkImageUrlValid(HotelPhotos[WhatCurrentImageIndex], "/Assets/images/NoHotelImage.jpg", BackgroundToDisplay, () =>{}, { quality: 70});

    // Main Hotel Image ----------------------------------------------------------------------------------

    let HotelDetailsHotelImageMain = document.createElement("div");
    HotelDetailsHotelImageMain.className = "HotelDetailsHotelImageMain BasicRadius Selectable";
    ImageTopMainWrapper.append(HotelDetailsHotelImageMain);

    let ImageMainLoading = document.createElement("div");
    ImageMainLoading.className = "loading_grey ImageFullCover";
    HotelDetailsHotelImageMain.append(ImageMainLoading);
    
    let ImageFullCover = HotelDetailsHotelImageMain.appendChild(window.bindImageFromPool(window.AllHotelImagePool[window.WhatCurrentImageIndex]));
    ImageFullCover.className = "ImageFullCover";
    ImageFullCover.style.opacity = 0;
    ImageFullCover.onclick = function()
    {
        window.OpenImageFullScreen("WhatCurrentImageIndex", window.AllHotelImagePool, () => MainImageSwiper.slideTo(window["WhatCurrentImageIndex"]));
    }
    window.HandleLoadingSkeletonAndImage(ImageMainLoading, ImageFullCover);

    let BasicTextButton = document.createElement("button");
    BasicTextButton.className = "BasicTextButton BasicBoxShadow OrangeButton SeeAllPhotosButton Selectable HideOnMobile3";
    BasicTextButton.innerHTML = window["SeeAllPhotosTxt" + window.CurrentCountryID];
    BasicTextButton.onclick = function()
    {
        window.OpenSeeAllPhotosContainer();
    }
    HotelDetailsHotelImageMain.append(BasicTextButton);

    // Sub Hotel Image ---------------------------------------------------------------------------------

    let HotelImageSubsContainer;
    let HowManyInstantiated = 1;

    if(window.AllHotelImagePool.length > 1)
    {
        for(let i = (window.WhatCurrentImageIndex+1); i < window.AllHotelImagePool.length; i++)
        {
            if(HowManyInstantiated < 5)
            {
                if(HowManyInstantiated%2 != 0)
                {
                    HotelImageSubsContainer = document.createElement("div");
                    HotelImageSubsContainer.className = "HotelDetailsHotelImageSub";
                    ImageTopMainWrapper.append(HotelImageSubsContainer);
                }
        
                let ImageSubsMiniContainer = document.createElement("div");
                ImageSubsMiniContainer.className = "HotelDetailsHotelImageSubMini2";
                HotelImageSubsContainer.append(ImageSubsMiniContainer);
    
                let ImageSubsMiniLoading = document.createElement("div");
                ImageSubsMiniLoading.className = "loading_grey ImageFullCover";
                ImageSubsMiniContainer.append(ImageSubsMiniLoading);

                let ImageSubsMiniImage = ImageSubsMiniContainer.appendChild(window.bindImageFromPool(window.AllHotelImagePool[i]));
                ImageSubsMiniImage.className = "ImageFullCover";
                ImageSubsMiniImage.style.opacity = 0;
                ImageSubsMiniImage.onclick = function()
                {
                    MainImageSwiper.slideTo(i);
                }
                window.HandleLoadingSkeletonAndImage(ImageSubsMiniLoading, ImageSubsMiniImage);

                HowManyInstantiated++;
            }
        }
    }

    if(HotelImageSubsContainer != null && HotelImageSubsContainer.children.length == 1) // If the Image inside sub mini wrapper only one, add 1 dummy
    {
        let ImageSubsMiniContainer = document.createElement("div");
        ImageSubsMiniContainer.className = "HotelDetailsHotelImageSubMini2";
        ImageSubsMiniContainer.style.opacity = "0";
        HotelImageSubsContainer.append(ImageSubsMiniContainer);

        let ImageSubsMiniImage = document.createElement("img");
        ImageSubsMiniImage.className = "ImageFullCover";
        ImageSubsMiniContainer.append(ImageSubsMiniImage);
    }

    // window.CheckImageContainerImageLoaded2(document.getElementById("HotelDetailsHotelImageContainer"), true);
}

// ========================================== INSTANTIATE HOTEL IMAGE ============================================

window.InstantiateRoomList = function(RoomHotelContainer, RoomData)
{
    if(window.SelectedHotelDetailsFilter != null)
    {
        let NoRoomAvailableHeaderText = document.getElementById("NoRoomAvailableHeaderText");
        let NoRoomAvailableMessageText = document.getElementById("NoRoomAvailableMessageText");

        // let ToFilter = "per night";
        if(window.SelectedHotelDetailsFilter == "Experiences")
        {
            if(NoRoomAvailableHeaderText != null)
                NoRoomAvailableHeaderText.innerHTML = window["NoExperienceAvailableHeaderTxt" + window.CurrentCountryID];
            
            if(NoRoomAvailableMessageText != null)
                NoRoomAvailableMessageText.innerHTML = window["NoExperienceAvailableMessageTxt" + window.CurrentCountryID];

            // ToFilter = "per day";
        }
        else
        {
            if(NoRoomAvailableHeaderText != null)
                NoRoomAvailableHeaderText.innerHTML = window["NoRoomAvailableHeaderTxt" + window.CurrentCountryID];
            
            if(NoRoomAvailableMessageText != null)
                NoRoomAvailableMessageText.innerHTML = window["NoRoomAvailableMessageTxt" + window.CurrentCountryID];
        }

        // RoomData = RoomData.filter(thisbookingdata => thisbookingdata.book_type === ToFilter);
    }

    let NoRoomAvailableContainer = document.getElementById("NoRoomAvailableContainer");

    // console.log("Room or Experience To Instantiate", RoomData);

    if(RoomData.length > 0)
    {
        RoomHotelContainer.style.display = "";
        RoomHotelContainer.innerHTML = "";
        NoRoomAvailableContainer.style.display = "none";

        let RoomContainerToInstant = document.createElement("div"); // Where To Instantiate ----------------------
        RoomContainerToInstant.style.width = "100%";
        RoomContainerToInstant.style.height = "fit-content";
        RoomContainerToInstant.style.display = "flex";
        RoomContainerToInstant.style.flexDirection = "column";
        RoomContainerToInstant.id = "RoomContainerToInstant";
        RoomHotelContainer.append(RoomContainerToInstant);
        

        for(let i = 0; i < RoomData.length; i++)
        {
            let ThisRoomOrExpData = RoomData[i];
            const countryId = window.CurrentCountryID;
            
            let ThisDataID = ThisRoomOrExpData?.id_hotel_room ?? ThisRoomOrExpData?.id;
            let ThisDataName = ThisRoomOrExpData?.room_name ?? ThisRoomOrExpData["name_" + countryId];
            let ThisDataTypeName = ThisRoomOrExpData?.room_type?.["room_type_name_" + countryId] ?? ThisRoomOrExpData?.experience_type?.["type_name_" + countryId];
            let RoomDescriptionToDisplay = ThisRoomOrExpData?.room_description ?? ThisRoomOrExpData["desc_" + countryId];
            RoomDescriptionToDisplay = window.decodeGarbledContent(RoomDescriptionToDisplay.replace(/(?:\r\n|\r|\n)/g, '<br>'));
            let ThisBookType = ThisRoomOrExpData?.book_type;

            let RoomHotelPanel = document.createElement("div");
            RoomHotelPanel.className = "RoomHotelPanel";
            RoomHotelPanel.style.flexDirection = "column";
            RoomHotelPanel.setAttribute("room-id", ThisDataID);
            RoomHotelPanel.setAttribute("type-facilities", window.SelectedHotelDetailsFilter);
            RoomContainerToInstant.append(RoomHotelPanel);
        
            let RoomHotelWrapper = document.createElement("div"); // Top Info ----------------
            RoomHotelWrapper.className = "RoomHotelWrapper";
            RoomHotelPanel.append(RoomHotelWrapper);
        
            let RoomHotelImageInsidePanel = document.createElement("div"); // Room Hotel
            RoomHotelImageInsidePanel.className = "RoomHotelImageInsidePanel HotelDetailsRoomHotelContainer";
            RoomHotelWrapper.append(RoomHotelImageInsidePanel);

            let LoadingImageGrey = document.createElement("div");
            LoadingImageGrey.className = "loading_grey ImageFullCover";
            RoomHotelImageInsidePanel.append(LoadingImageGrey);

            let PotonganContainer = null;

            if(ThisRoomOrExpData?.room_pings?.length > 0 && ThisRoomOrExpData?.room_pings[0]?.dates?.length > 0)
            {
                let ThisRoomDiscData = ThisRoomOrExpData.room_pings[0].dates[0].disc_now;
                let MaxDiscountPinginGo = parseInt(ThisRoomDiscData.max_price_disc_pingingo ?? 0, 10) || 0;;
                let MaxDiscountMitra = parseInt(ThisRoomDiscData.max_price_disc_mitra ?? 0, 10) || 0;
                let TotalMaxDiscount = MaxDiscountPinginGo + MaxDiscountMitra;
                let DiscountPercentage = ThisRoomDiscData.total_discount;

                if(DiscountPercentage != 0 && TotalMaxDiscount != 0)
                {
                    PotonganContainer = document.createElement("div");  // potongan Menginap Room ----------------
                    PotonganContainer.className = "HotelDetailsHotelInformationMarginWrapper ChangeRoomContainerHotelDetailsMobileTop ShowOnMobile3";
                    PotonganContainer.style.bottom = "0";
                    PotonganContainer.style.position = "absolute";
                    PotonganContainer.style.zIndex = 1;
                    RoomHotelImageInsidePanel.append(PotonganContainer);

                    let MessageContainer = document.createElement("div");
                    MessageContainer.className = "ContainerWithIconAndText2 ShareBookingMesButtonContainer BasicRadius";
                    MessageContainer.style.background = "#FC5555";
                    PotonganContainer.append(MessageContainer);

                    let ContentWrapper = document.createElement("div");
                    ContentWrapper.className = "ColumnGapBasic";
                    ContentWrapper.style.width = "fit-content";
                    ContentWrapper.style.height = "fit-content";
                    ContentWrapper.style.display = "flex";
                    ContentWrapper.style.margin = "auto";
                    MessageContainer.append(ContentWrapper);

                    let PercentIcon = document.createElement("img");
                    PercentIcon.src = "/Assets/images/ButtonIcon/percent-red.svg";
                    PercentIcon.className = "FacilityIcon";
                    PercentIcon.style.marginLeft = "0";
                    ContentWrapper.append(PercentIcon);

                    

                    let MessageText = document.createElement("p");
                    MessageText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    MessageText.style.margin = "auto 0";
                    MessageText.style.color = "white";
                    MessageText.innerText = window.DiscountWithMaxTxtid(DiscountPercentage, TotalMaxDiscount);
                    ContentWrapper.append(MessageText);
                }
            }
            

            let FunctionToCallAfterLoaded = function()
            {
                LoadingImageGrey.remove();
                if(PotonganContainer != null)
                    PotonganContainer.style.display = "flex";
            }

            let WhichRoomPhotoType = "room_photo";
            if(window.SelectedHotelDetailsFilter == "Experiences")
                WhichRoomPhotoType = "photo";

            window.CheckAllImageRemoveEmptyAndWaitLoadCallFunc(ThisRoomOrExpData.photos, WhichRoomPhotoType, "/Assets/images/NoImage.jpeg", RoomHotelImageInsidePanel, {}, RoomHotelImageInsidePanel, ()=>FunctionToCallAfterLoaded());


            let RoomHotelImageRightSectionInSeparatorsidePanel = document.createElement("div");
            RoomHotelImageRightSectionInSeparatorsidePanel.className = "RoomHotelImageRightSectionInSeparatorsidePanel SmallCollapsibleContent BasicGradientBottomMask";
            RoomHotelWrapper.append(RoomHotelImageRightSectionInSeparatorsidePanel);

            let RoomHotelPanelInfoOneWrapper = document.createElement("div");
            RoomHotelPanelInfoOneWrapper.className = "RoomHotelPanelInfoOneWrapper";
            RoomHotelImageRightSectionInSeparatorsidePanel.append(RoomHotelPanelInfoOneWrapper);

            window.SetDynamicCollapsible(RoomHotelImageRightSectionInSeparatorsidePanel, RoomHotelPanel, null);


            let RoomHotelNameDescWrapper = document.createElement("div"); // Name and Description Wrapper ----------------
            RoomHotelNameDescWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
            RoomHotelNameDescWrapper.style.flexDirection = "column";
            RoomHotelPanelInfoOneWrapper.append(RoomHotelNameDescWrapper);

            let RoomTypeAndNameWrapper = document.createElement("div"); // Room Type ---
            RoomTypeAndNameWrapper.className = "HotelDetailsHotelInformationMarginWrapper BasicChildMargin2 RowGapBasic";
            RoomTypeAndNameWrapper.style.marginBottom = 0;
            RoomHotelNameDescWrapper.append(RoomTypeAndNameWrapper);

            let RoomTypeContainer = document.createElement("div"); // Room Type ---
            RoomTypeContainer.className = "RedBorderMaxDiscountHotelDetails";
            RoomTypeContainer.style.backgroundColor = "#2494D9"
            RoomTypeAndNameWrapper.append(RoomTypeContainer);

            let RoomTypeText = document.createElement("p");
            RoomTypeText.className = "LabelGreyHeaderSmallerText InterBoldTextFont";
            RoomTypeText.style = "opacity: 1; color: white;";
            RoomTypeText.innerHTML = ThisDataTypeName;
            RoomTypeContainer.append(RoomTypeText);        
        
            let RoomHotelNameText = document.createElement("p");
            RoomHotelNameText.className = "RoomHotelNameInsidePanel InterBoldTextFont";
            RoomHotelNameText.innerHTML = ThisDataName;
            RoomTypeAndNameWrapper.append(RoomHotelNameText);



            let RoomHotelDescriptionText = document.createElement("p");
            RoomHotelDescriptionText.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont";
            RoomHotelDescriptionText.innerHTML = RoomDescriptionToDisplay;
            RoomHotelNameDescWrapper.append(RoomHotelDescriptionText);

            if(ThisRoomOrExpData.facilities != null && ThisRoomOrExpData.facilities.length > 0)
            {
                let RoomHotelFacilityContainer = document.createElement("div"); // Facility -----------------------
                RoomHotelFacilityContainer.className = "HotelDetailsHotelInformationMarginWrapper";
                RoomHotelFacilityContainer.style.flexDirection = "column";
                RoomHotelPanelInfoOneWrapper.append(RoomHotelFacilityContainer);
        
                let RoomHotelFacilityHeaderText = document.createElement("p");
                RoomHotelFacilityHeaderText.className = "LabelGreyHeaderSmallerText InterBoldTextFont";
                RoomHotelFacilityHeaderText.innerHTML = window["FacilityTxt" + countryId];
                RoomHotelFacilityContainer.append(RoomHotelFacilityHeaderText);
        
                let RoomHotelFacilityWrapper = document.createElement("div");
                RoomHotelFacilityWrapper.className = "FacilityAndBenefitsContainer";
                RoomHotelFacilityContainer.append(RoomHotelFacilityWrapper);
        
                for(let j = 0; j < ThisRoomOrExpData.facilities.length; j++)
                {
                    let FaciltyChildrenContainer = document.createElement("div");
                    FaciltyChildrenContainer.className = "FaciltyChildrenContainer";
                    RoomHotelFacilityWrapper.append(FaciltyChildrenContainer);
        
                    let FacilityIcon = document.createElement("img");
                    FacilityIcon.className = "FacilityIcon";
                    FacilityIcon.src = ThisRoomOrExpData.facilities[j].icon_link;
                    FaciltyChildrenContainer.append(FacilityIcon);
        
                    let FacilityNameText = document.createElement("p");
                    FacilityNameText.className = "FacilityNameText InterRegularTextFont";
                    FacilityNameText.innerHTML = ThisRoomOrExpData.facilities[j]["facility_name_" + countryId];
                    FaciltyChildrenContainer.append(FacilityNameText);
                }
            }


            let RoomHotelPanelBlueBottomPanel = document.createElement("div"); // Bottom Info ----------------
            RoomHotelPanelBlueBottomPanel.className = "RoomHotelPanelBlueBottomPanel";
            RoomHotelPanel.append(RoomHotelPanelBlueBottomPanel);

            // let LastPingandPingToGoWrapper = document.createElement("div"); // Ping to Go and Last Ping
            // LastPingandPingToGoWrapper.className = "RoomHotelPanelBlueBottomLeftWrapper";
            // RoomHotelPanelBlueBottomPanel.append(LastPingandPingToGoWrapper);

            // let PingToGoText = document.createElement("p");
            // PingToGoText.className = "PingToGoHotelDetailsText InterRegularTextFont";
            // PingToGoText.innerHTML = "-- Ping! to go";
            // LastPingandPingToGoWrapper.append(PingToGoText);

            // let LastPingText = document.createElement("p");
            // LastPingText.className = "PingToGoInsidePanel InterBoldTextFont";
            // LastPingText.innerHTML = "Last Ping! -- Hours Ago";
            // LastPingandPingToGoWrapper.append(LastPingText);

            let OriginalandStartPriceWrapper = document.createElement("div"); // Ping to Go and Last Ping
            OriginalandStartPriceWrapper.className = "RoomHotelPanelBlueBottomRightWrapper";
            RoomHotelPanelBlueBottomPanel.append(OriginalandStartPriceWrapper);

            let OriginalPriceDiscountPercentageWrapper = document.createElement("div");
            OriginalPriceDiscountPercentageWrapper.className = "ColumnGapBasic";
            OriginalPriceDiscountPercentageWrapper.style.width = "fit-content";
            OriginalPriceDiscountPercentageWrapper.style.display = "flex";
            OriginalPriceDiscountPercentageWrapper.style.marginLeft = "auto";
            OriginalandStartPriceWrapper.append(OriginalPriceDiscountPercentageWrapper);

            let DiscountPercentageRoomText = document.createElement("p");
            DiscountPercentageRoomText.className = "CuttedPriceText DiscountPercentageRoomPriceHotelDetailsText ShowOnMobile3";
            DiscountPercentageRoomText.style.color = "red";
            DiscountPercentageRoomText.style.textDecoration = "none";
            OriginalPriceDiscountPercentageWrapper.append(DiscountPercentageRoomText);

            let OriginalPriceText = document.createElement("p");
            OriginalPriceText.className = "CuttedPriceText";
            // OriginalPriceText.style.color = "white";
            OriginalPriceDiscountPercentageWrapper.append(OriginalPriceText);

            let StartPriceText = document.createElement("p");
            StartPriceText.className = "OriginalPriceHotelDetailsText InterMediumTextFont";
            OriginalandStartPriceWrapper.append(StartPriceText);


            let SelectRoomButton = document.createElement("button"); // Select Button
            SelectRoomButton.className = "BasicTextButton BasicBoxShadow OrangeButton SelectRoomButton Selectable NotSelectedHotelDetailsButton";
            SelectRoomButton.id = "SelectRoomButton" + ThisDataID;
            RoomHotelPanelBlueBottomPanel.append(SelectRoomButton);

            if(window.SelectedHotelDetailsFilter == "Experiences")
            {
                SelectRoomButton.innerHTML = window["SelectExperienceTxt" + countryId];
            }
            else
            {
                SelectRoomButton.innerHTML = window["SelectRoomButtonTxt" + countryId];
            }

            if(window.CurrentSelectedRoomID != null && window.CurrentSelectedRoomID == ThisDataID)
            {
                SelectRoomButton.className = "BasicTextButton BasicBoxShadow OrangeButton SelectRoomButton Selectable";
                SelectRoomButton.innerHTML = window["SelectedButtonTxt" + countryId];
            }
            

            // ------------------------- ROOM UNAVAILABLE -------------------------------

            let RoomUnavailableBlockerHotelDetails = document.createElement("div");
            RoomUnavailableBlockerHotelDetails.className = "RoomUnavailableBlockerHotelDetails";
            RoomUnavailableBlockerHotelDetails.style.display = "none";
            RoomUnavailableBlockerHotelDetails.style.zIndex = 1;
            RoomHotelPanel.append(RoomUnavailableBlockerHotelDetails);

            let RoomUnavailableWrapper = document.createElement("div");
            RoomUnavailableWrapper.className = "RoomUnavailableWrapper";
            RoomUnavailableBlockerHotelDetails.append(RoomUnavailableWrapper);

            let RoomUnavailableHeaderText = document.createElement("p");
            RoomUnavailableHeaderText.className = "RoomUnavailableHeaderText RoomUnavailableText InterBoldTextFont";
            RoomUnavailableHeaderText.innerHTML = window["WeAreSorryTxt" + countryId];
            RoomUnavailableWrapper.append(RoomUnavailableHeaderText);

            let RoomUnavailableHeaderMessage = document.createElement("p");
            RoomUnavailableHeaderMessage.className = "RoomUnavailableHeaderMessage RoomUnavailableText InterBoldTextFont";
            RoomUnavailableHeaderMessage.innerHTML = window["RoomUnavailableFullyBookedTxt" + countryId];
            RoomUnavailableWrapper.append(RoomUnavailableHeaderMessage);

            let GotoHotelButton = document.createElement("button");
            GotoHotelButton.className = "BasicTextButton BasicBoxShadow OrangeButton LoadMoreButton Selectable";
            GotoHotelButton.innerHTML = window["ChangeDateSettingsTxt" + countryId];
            RoomUnavailableWrapper.append(GotoHotelButton);
            

            // let ThisRoomIsAvailable = GetPingDataInformation(ThisRoomOrExpData, DiscountPercentageRoomText, OriginalPriceText, StartPriceText);
            // if(ThisRoomIsAvailable == false || ThisRoomOrExpData.status_available == "No")
            //     RoomUnavailableBlockerHotelDetails.style.display = "";

            if(ThisRoomOrExpData.status_available == "No")
                RoomUnavailableBlockerHotelDetails.style.display = "";

            // Function To Call ------------------------------------------------

            let FunctionToCallOnClickButton = function()
            {
                // Store Before Change Temporarily if Close Apply This One -------------------------
                let PrevData = window.CreateHotelDetailsSnapshot();

                // Apply Update Based On Selecteed Room or Experience ------------------------------
                window.CurrentSelectedRoomID = ThisDataID;
                window.CurrentSelectedRoomExpBookType = ThisBookType;
                window.CurrentSelectedAccFacilitiesType = window.SelectedHotelDetailsFilter;
                window.ThisRoomData = ThisRoomOrExpData;

                let FunctionOnSelectRoomExperience = function()
                {
                    const HotelDetailsRightPanel = document.getElementById("HotelDetailsInformationRightSection");
                    const RightPanelCSSInfo = window.getComputedStyle(HotelDetailsRightPanel);

                    if(RightPanelCSSInfo.display != "none")
                    window.ScrollToWindow(HotelDetailsRightPanel);

                    window.CalculateTotalHotelDetails(true);
                }

                if(window.SelectedHotelDetailsFilter == "Experiences")
                {
                    window.InstantiateJenisExperienceOptionResponsive(
                        ()=>
                        {
                            let UpdatedCheckInArray = window.CheckInDateNonTop.split("-");
                            window.CheckInNonTopInput.setAttribute("year", UpdatedCheckInArray[0]);
                            window.CheckInNonTopInput.setAttribute("month", parseInt(UpdatedCheckInArray[1]));
                            window.CheckInNonTopInput.setAttribute("date", parseInt(UpdatedCheckInArray[2]));

                            let UpdatedCheckOutArray = window.CheckOutDateNonTop.split("-");
                            window.CheckOutNonTopInput.setAttribute("year", UpdatedCheckOutArray[0]);
                            window.CheckOutNonTopInput.setAttribute("month", parseInt(UpdatedCheckOutArray[1]));
                            window.CheckOutNonTopInput.setAttribute("date", parseInt(UpdatedCheckOutArray[2]));

                            FunctionOnSelectRoomExperience();
                        },
                        ()=>
                        {
                            window.RestoreHotelDetailsSnapshot(PrevData);
                        }, true, true
                    );
                }
                else
                {
                    FunctionOnSelectRoomExperience();
                }
            }

            SelectRoomButton.onclick = function(event)
            {
                event.preventDefault();
                event.stopPropagation();

                FunctionToCallOnClickButton();
            }

            GotoHotelButton.onclick = function(event)
            {
                event.preventDefault();
                event.stopPropagation();

                FunctionToCallOnClickButton();
            }
        }
    }
    else
    {

        console.log("Room or Experience To Instantiate", RoomData);
        RoomHotelContainer.style.display = "none";
        NoRoomAvailableContainer.style.display = "";
    }
}


function GetPingDataInformation(ThisRoomPingsData, DiscountPercentageRoomText, OriginalPriceText, StartPriceText)
{
    let OriginalPrice = "--";
    let PriceAfterDiscount = "--";
    let DiscountPerc = "";
    let ThisRoomIsAvailable = false;

    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    let RoomPingData = ThisRoomPingsData?.room_pings?.[0]?.dates ?? ThisRoomPingsData?.dates;
    console.log("ThisRoomPingsData", ThisRoomPingsData);

    if(RoomPingData != null && RoomPingData.length > 0)
    {
        OriginalPrice = RoomPingData[0].price;
        PriceAfterDiscount = RoomPingData[0].price_after_disc_per_room;
        DiscountPerc = RoomPingData[0].disc_now.total_discount;
        ThisRoomIsAvailable = true;

        for(let j = 0; j < RoomPingData.length; j++) //---------------------- GET ALL REQUIRED ROOM DATA
        {
            if(OriginalPrice == null || parseInt(OriginalPrice) < parseInt(RoomPingData[j].price))
            {
                if(RoomPingData[j].price != null)
                OriginalPrice = RoomPingData[j].price;
            }

            if(PriceAfterDiscount == null || parseInt(PriceAfterDiscount) > parseInt(RoomPingData[j].price_after_disc))
            {
                if(RoomPingData[j].price_after_disc != null)
                PriceAfterDiscount = RoomPingData[j].price_after_disc;
            }

            if(RoomPingData[j].status_available == "No")
            {
                ThisRoomIsAvailable = false;
            }
        }
    }

    if(DiscountPerc != null &&  DiscountPerc != "" && DiscountPerc != 0)
    {
        DiscountPercentageRoomText.innerHTML = DiscountPerc + "%";
    }
    if(OriginalPrice == 0)
    {
        OriginalPriceText.style.opacity = 0;
    }
    OriginalPriceText.innerHTML = OriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    let ThisPriceToDisplay = " <span class='InterExBoldTextFont'>Rp " + PriceAfterDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "</span>";

    if(ThisRoomPingsData.book_type == "per night")
    {
        StartPriceText.innerHTML = window["StartFromTxt" + window.CurrentCountryID] + ThisPriceToDisplay + window["PerMalamTxt" + window.CurrentCountryID];
    }
    else
    {
        StartPriceText.innerHTML = ThisPriceToDisplay + window["PerSessionTxt" + window.CurrentCountryID];
    }

    return ThisRoomIsAvailable;
}

// ======================================= NEARBY MAP =======================================

function InstantiateNearbyMap(EmbedMapUrl, EmbedMapContainer)
{
    if(isValidGoogleMapsEmbedURL(EmbedMapUrl) == true)
    {
        EmbedMapContainer.innerHTML = "";
        
        let LoadingMapEmbedded = document.createElement("div");
        LoadingMapEmbedded.className = "loading_grey ImageFullCover";
        EmbedMapContainer.append(LoadingMapEmbedded);

        let LocationMapIframe = document.createElement("iframe");
        LocationMapIframe.className = "LocationMap";
        LocationMapIframe.style.allowfullscreen = "";
        LocationMapIframe.style.loading = "lazy";
        LocationMapIframe.style.referrerpolicy = "no-referrer-when-downgrade";
        LocationMapIframe.src = EmbedMapUrl;
        LocationMapIframe.onload = function(event)
        {
            OnMapSuccessLoaded(EmbedMapContainer, LoadingMapEmbedded, EmbedMapUrl);
        }
        EmbedMapContainer.append(LocationMapIframe);
    }
    else
    {
        document.getElementById("EmbedUrlMainContainer").remove();
    }
}

function isValidGoogleMapsEmbedURL(url)
{
    try {
      // Using URL API
      const parsedURL = new URL(url);
      
      // Check if the hostname matches the expected pattern
      if (!/^(www\.)?google(\.[a-z]{2,3}){1,2}$/.test(parsedURL.hostname)) {
        return false;
      }
  
      // Check if the path starts with /maps/embed
       if (!parsedURL.pathname.startsWith('/maps/embed')) {
        return false;
      }
  
      return true;
    } catch (error) {
      return false; // Invalid URL format
    }
}

function OnMapSuccessLoaded(EmbedMapContainer, LoadingMapEmbedded, EmbedMapUrl)
{
    LoadingMapEmbedded.remove();

    let ExpandButton = document.createElement("button");
    ExpandButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ExpandMapButton Selectable";
    ExpandButton.onclick = function(event)
    {
        OpenMapInFullScreen(EmbedMapUrl);
    }
    EmbedMapContainer.append(ExpandButton);


    let ExpandButtonIcon = document.createElement("img");
    ExpandButtonIcon.className = "ExpandButtonIcon";
    ExpandButtonIcon.src = "/Assets/images/ButtonIcon/expand-white.svg";
    ExpandButton.append(ExpandButtonIcon);

    let ExpandButtonText = document.createElement("p");
    ExpandButtonText.className = "InterMediumTextFont";
    ExpandButtonText.innerHTML = window["ExpandBtnTxt" + window.CurrentCountryID];
    ExpandButton.append(ExpandButtonText);
}

//============================================ SHOW MAP IN FULL SCREEN ================================================

function OpenMapInFullScreen(EmbedMapUrl)
{
    let ShowFullImageBlocker = document.createElement('div');
    ShowFullImageBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(ShowFullImageBlocker);

    let LocationMapFullScreen = document.createElement('iframe');
    LocationMapFullScreen.className = "LocationMapFullScreen";
    LocationMapFullScreen.src = EmbedMapUrl;
    LocationMapFullScreen.allowFullscreen = "";
    LocationMapFullScreen.loading = "lazy";
    LocationMapFullScreen.referrerPolicy = "no-referrer-when-downgrade";
    ShowFullImageBlocker.append(LocationMapFullScreen);


    let CloseButton = document.createElement('img');
    CloseButton.className = "CloseButton Selectable";
    CloseButton.src = "/Assets/images/ButtonIcon/x-close.svg";
    CloseButton.onclick = function()
    {
        window.ClosePanelAnimate(null, ShowFullImageBlocker, null)
    }
    ShowFullImageBlocker.append(CloseButton);

    //------------------------------------ ANIMATE EASE IN --------------------------------------

    window.OpenPanelAnimate(null, ShowFullImageBlocker);
}

// =============================================== LOAD AND CALCULATE HOTEL DETAILS ================================


window.CalculateTotalHotelDetails = function(allowreload)
{
    // Update Current Choice -------------------------------------------

    if(window.CurrentSelectedAccFacilitiesType == "Rooms")
    {
        window.AllChoicesBasedOnCurrentSelectedRoomAccType = window.CurrentLoadedListRoomExp;
    }
    else
    {
        window.AllChoicesBasedOnCurrentSelectedRoomAccType = window.CurrentChoiceDataJenisExperience;
    }

    // =============================== RELOAD BOTTOM RECOMMENDED ACC HOTEL DETAILS ================================

    if(window.WhichPageisNow == "HotelDetails")
    {
        window.OnChangeFilterMainSearch(null, null, window.WhichPageisNow)
    }

    // ================================================================================================

    // if(window.CurrentSelectedRoomID == null && window.HotelDetails.rooms.length > 0)
    // {
    //     window.CurrentSelectedRoomID = window.HotelDetails.rooms[0].id_hotel_room;
    // }
    
    // Change Room Button To Selected -------------------------------
    let SelectRoomButton = document.querySelectorAll('.SelectRoomButton');
    SelectRoomButton.forEach(RoomButton =>
    {
        RoomButton.className = "BasicTextButton BasicBoxShadow OrangeButton SelectRoomButton Selectable NotSelectedHotelDetailsButton";
        if(window.SelectedHotelDetailsFilter == "Experiences")
        {
            RoomButton.innerHTML = window["SelectExperienceTxt" + window.CurrentCountryID];
        }
        else
        {
            RoomButton.innerHTML = window["SelectRoomButtonTxt" + window.CurrentCountryID];
        }
        // RoomButton.style.pointerEvents = "";

        if(RoomButton.id == "SelectRoomButton" + window.CurrentSelectedRoomID)
        {
            RoomButton.className = "BasicTextButton BasicBoxShadow OrangeButton SelectRoomButton Selectable";
            RoomButton.innerHTML = window["SelectedButtonTxt" + window.CurrentCountryID];
            // RoomButton.style.pointerEvents = "none";
        }
    });


    // let WhichBookTypeNowSelected;
    // window.HotelDetails.rooms.forEach(thisroomdata =>
    // {
    //     if(window.CurrentSelectedRoomID == thisroomdata.id_hotel_room)
    //     {
    //         WhichBookTypeNowSelected = thisroomdata.book_type;
    //     }
    // });

    // Load Room Data ---------------------------------------------
    
    let ThisCheckInYear = window.CheckInNonTopInput.getAttribute("year");
    let ThisCheckInMonth = window.CheckInNonTopInput.getAttribute("month");
    let ThisCheckInDay = window.CheckInNonTopInput.getAttribute("date");
    let ThisCheckInDate = ThisCheckInYear + "-" + ThisCheckInMonth.toString().padStart(2, '0') + "-" + ThisCheckInDay.toString().padStart(2, '0');

    let ThisCheckOutYear = window.CheckOutNonTopInput.getAttribute("year");
    let ThisCheckOutMonth = window.CheckOutNonTopInput.getAttribute("month");
    let ThisCheckOutDay = window.CheckOutNonTopInput.getAttribute("date");
    let ThisCheckOutDate = ThisCheckOutYear + "-" + ThisCheckOutMonth.toString().padStart(2, '0') + "-" + ThisCheckOutDay.toString().padStart(2, '0');

    window.CheckInDateNonTop = ThisCheckInDate;
    window.CheckOutDateNonTop = ThisCheckOutDate;

    if(window.CheckInNonTopInputText != null)
    {
        let ThisCheckInDateToDisplay = ThisCheckInDay.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][parseInt(ThisCheckInMonth)-1] + " " + ThisCheckInYear;
        window.CheckInNonTopInputText.innerHTML = ThisCheckInDateToDisplay;
    }
        
    if(window.CheckOutNonTopInputText != null)
    {
        let ThisCheckOutDateToDisplay = ThisCheckOutDay.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][parseInt(ThisCheckOutMonth)-1] + " " + ThisCheckOutYear;
        window.CheckOutNonTopInputText.innerHTML = ThisCheckOutDateToDisplay;
    }


    // Quota Preparation -------------------------------------------------------------------------------------------------------

    window.RoomQuotaNonTop =  parseInt(document.getElementById("RoomQuotaHotelDetailsInput").getAttribute("room-quota"));

    let RoomQuotaTextToDisplay = "";

    if(window.CurrentSelectedAccFacilitiesType == "Rooms") // Prepare Quota Input (Room) ------------------------------------------------
    {
        RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["RoomTxt" + window.CurrentCountryID];
        
        if(window.RoomQuotaNonTop > 1)
            RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["RoomTxtex" + window.CurrentCountryID];
    }
    else if(window.CurrentSelectedAccFacilitiesType == "Experiences" && Array.isArray(window.CurrentUserInputExperienceAddOns.data_input) == false) // Prepare Quota Input (Experience No Option) ------------------------------------------------
    {
        let CurrentInput = window.CurrentUserInputExperienceAddOns.data_input;

        RoomQuotaTextToDisplay = CurrentInput + " " + window["ItemsTxt" + window.CurrentCountryID];
        
        if(window.RoomQuotaNonTop > 1)
            RoomQuotaTextToDisplay = CurrentInput + " " + window["ItemsTxtex" + window.CurrentCountryID];
    }

    // How Many Nights ------------------------------------------------------------------------------------------------------------

    let HowManyTextNightTextDisplayer = document.getElementById("HowManyNightHotelDetailsInput");

    if(window.CurrentSelectedRoomExpBookType == "per day")
    {
        HowManyTextNightTextDisplayer.style.display = "none";
    }
    else
    {
        HowManyTextNightTextDisplayer.style.display = "";
    }

    // Update All Room Quota Display -------------------------------------------------------------------------------------------------

    let RoomQuotaTextDisplayNonTop = document.getElementById("RoomQuotaHotelDetailsDisplayText");
    if(RoomQuotaTextDisplayNonTop != null)
    {
        RoomQuotaTextDisplayNonTop.innerHTML = RoomQuotaTextToDisplay;
    }

    let MobileQuotaChangeDropDownContainer = document.querySelectorAll(".MobileQuotaChangeDropDownContainer");
    let MobileCurrentStatusHotelDetailsText = document.querySelectorAll(".MobileCurrentStatusHotelDetailsText");    
    let RoomQuotaContainerRight = document.getElementById("RoomQuotaContainerRight");

    let ExperienceOptionRightDisplayText = document.getElementById("ExperienceOptionRightDisplayText");
    if(ExperienceOptionRightDisplayText != null)
        ExperienceOptionRightDisplayText.style.display = "none";

    let RightRoomDoorIconOnNameDisplay = document.getElementById("RightRoomDoorIconOnNameDisplay");
    if(RightRoomDoorIconOnNameDisplay != null)
        RightRoomDoorIconOnNameDisplay.style.display = "";

    let RoomTypeHeaderText = document.getElementById("RoomTypeHeaderText");
    if(RoomTypeHeaderText != null)
        RoomTypeHeaderText.style.display = "none"

    let TipeExperienceRightTextIconContainer = document.getElementById("TipeExperienceRightTextIconContainer");
    if(TipeExperienceRightTextIconContainer != null)
        TipeExperienceRightTextIconContainer.style.display = "none";
    
    let DifferenceBetweenDays = window.GetDateDifferences(window.CheckInDateNonTop, window.CheckOutDateNonTop);
    

    if(window.CurrentSelectedAccFacilitiesType == "Experiences")
    {
        let CurrentInput = window.CurrentUserInputExperienceAddOns.data_input;

        MobileQuotaChangeDropDownContainer.forEach(thismobilequota =>
        {
            thismobilequota.style.display = "none";
        });

        console.log("window.CurrentChoiceDataJenisExperience", window.CurrentChoiceDataJenisExperience);
        // console.log("window.CurrentChoiceExperienceAddOns", window.CurrentChoiceExperienceAddOns);
        // console.log("window.CurrentUserInputExperienceAddOns", window.CurrentUserInputExperienceAddOns);

        let ExperienceData = window.CurrentChoiceDataJenisExperience;
        let OtherExperienceInputToDisplay = "";

        if(RoomQuotaContainerRight != null)
            RoomQuotaContainerRight.style.display = "none";

        if(RightRoomDoorIconOnNameDisplay != null)
            RightRoomDoorIconOnNameDisplay.style.display = "none";

        if(TipeExperienceRightTextIconContainer != null)
            TipeExperienceRightTextIconContainer.style.display = "flex";


        for(let i = 0; i < ExperienceData.length; i++)
        {
            if(ExperienceData[i].id == window.CurrentUserInputExperienceAddOns.id_experiences) // Find the Current Selected Experience Data ------------------------
            {
                if(Array.isArray(CurrentInput) == true) // If Theres Option ---------------------------------------------------
                {
                    let CurrentChoiceList = window.CurrentChoiceExperienceAddOns;
                    let NameAndQuotaInputted = [];
                    let ToDisplayOnRight = "";

                    for(let j = 0; j < CurrentChoiceList.length; j++) // Push Add On Option Name and Quota --------------------
                    {
                        for(let x = 0; x < CurrentInput.length; x++)
                        {
                            if(CurrentChoiceList[j].id == CurrentInput[x].id && CurrentChoiceList[j].id_hotel_experience == CurrentInput[x].id_hotel_experience)
                            {
                                let HowManyInputtedThisOption = CurrentInput[x].quantity;
                                if(HowManyInputtedThisOption > 0)
                                {
                                    let DataToPush =
                                    {
                                        "name":CurrentChoiceList[j]["name_" + window.CurrentCountryID],
                                        "quantity": HowManyInputtedThisOption
                                    }
                                    NameAndQuotaInputted.push(DataToPush);
                                }
                            }
                        }
                    }

                    if(NameAndQuotaInputted.length > 0) // If At Least One Option Selected -----------------------
                    {
                        for(let j = 0; j < NameAndQuotaInputted.length; j++)
                        {
                            OtherExperienceInputToDisplay = OtherExperienceInputToDisplay + NameAndQuotaInputted[j].quantity + " " + NameAndQuotaInputted[j].name;
                            ToDisplayOnRight = ToDisplayOnRight +  NameAndQuotaInputted[j].quantity + "x " + NameAndQuotaInputted[j].name;

                            if(j < NameAndQuotaInputted.length - 1)
                            {
                                OtherExperienceInputToDisplay = OtherExperienceInputToDisplay + " • ";
                                ToDisplayOnRight = ToDisplayOnRight + "<br/>";
                            }
                        }

                        if(ExperienceOptionRightDisplayText != null)
                        {
                            ExperienceOptionRightDisplayText.style.display = "";
                            ExperienceOptionRightDisplayText.innerHTML = ToDisplayOnRight;
                        }
                    }
                }
                else // If No Options -------------------------------------------------------------
                {
                    OtherExperienceInputToDisplay = CurrentInput + " " + window["ItemsTxt" + window.CurrentCountryID];
                    if(CurrentInput > 1)
                        OtherExperienceInputToDisplay = CurrentInput + " " + window["ItemsTxtex" + window.CurrentCountryID];
                }
            }
        }

        MobileCurrentStatusHotelDetailsText.forEach(thistext =>  // Display List User Current Input
        {
            if(window.CurrentSelectedRoomExpBookType == "per day")
            {
                thistext.innerHTML = OtherExperienceInputToDisplay;
            }
            else
            {
                thistext.innerHTML = window.NightTextDisplayer(DifferenceBetweenDays) + " • " + OtherExperienceInputToDisplay;
            }
        });
    }
    else
    {
        MobileQuotaChangeDropDownContainer.forEach(thismobilequota =>  // Update Drop Down Mobile Choice and Display ----------------
        {
            thismobilequota.style.display = "flex";
        });

        if(RoomTypeHeaderText != null)
            RoomTypeHeaderText.style.display = "";

        let HowManyGuestRoomTextMobileText = document.querySelectorAll(".HowManyGuestRoomTextMobile");
        if(HowManyGuestRoomTextMobileText != null)
        {
            HowManyGuestRoomTextMobileText.forEach(thistext =>
            {
                thistext.innerHTML = RoomQuotaTextToDisplay;
            });
        }

        MobileCurrentStatusHotelDetailsText.forEach(thistext => // Display List User Current Input
        {
            if(window.CurrentSelectedRoomExpBookType == "per day")
            {
                thistext.innerHTML = RoomQuotaTextToDisplay;
            }
            else
            {
                thistext.innerHTML = window.NightTextDisplayer(DifferenceBetweenDays) + " • " + RoomQuotaTextToDisplay;
            }
        });

        RoomQuotaContainerRight.style.display = "flex";
        
    }

    // If Allow Reload, then Load All Data ---------------------------------
    
    if(allowreload == true)
    {
        let HotelDetailsBlocker = window.InstantiateLoadingBlocker("HotelDetailsBlocker");

        window.LoadAccommodationDetails(HotelDetailsBlocker, ()=>
        {
            let RoomHotelContainer = document.getElementById("RoomHotelContainer");

            window.LoadAccommodationRoomExperience(RoomHotelContainer, ()=>
            {
                StartUpdatingHotelDetails(window.HotelDetails);

                // Drop Down Room Type -------------------------------------------------------------

                document.getElementById("RoomTypeClickDropDown").onclick = function()
                {
                    window.InstantiateRoomTypeDropDown(document.getElementById('RoomTypeDetailsContainer'), window.AllChoicesBasedOnCurrentSelectedRoomAccType, 'RoomDetails', 'RoomTypeToggleArrow', ()=> window.CalculateTotalHotelDetails(true), false);
                }

                // ---------------------------------------------------------------------------------
                    
                HotelDetailsBlocker.remove();
            })

        }, null)
    }
    else
    {
        StartUpdatingHotelDetails(window.HotelDetails);
    }
}

// ====================== UPDATE RIGHT HOTEL DETAILS ============================================

function StartUpdatingHotelDetails(HotelDetailsLoadedData)
{
    // Animate Right ---------------------------------------

    let RightSectionWrapper = document.getElementById("HotelDetailsInformationRightSection");
    let LeftSectionWrapper = document.getElementById("HotelDetailsInformationLeftSection");

    if(RightSectionWrapper.classList.contains("RightSectionOpen") == false)
    {
        RightSectionWrapper.classList.add('with-transition'); // Enable transition
        RightSectionWrapper.classList.add("RightSectionOpen");

        LeftSectionWrapper.classList.add("RightSectionOpen");

        let propertiesToWatch = new Set(['width','margin-left']);

        RightSectionWrapper.addEventListener('transitionend', function handler(e)
        {
            propertiesToWatch.delete(e.propertyName);

            if (propertiesToWatch.size === 0)
            {
                RightSectionWrapper.classList.remove('with-transition');
                RightSectionWrapper.removeEventListener('transitionend', handler);
            }
        });
    }


    // Get Room Data -------------------------------------

    let RoomHotelPanels = document.querySelectorAll('.RoomHotelPanel');
    let RoomDatas = window.CurrentLoadedListRoomExp;

    for(let i = 0; i < RoomDatas.length; i++)
    {
        let ThisDataID = RoomDatas[i]?.id_hotel_room ?? RoomDatas[i]?.id;

        if(parseInt(ThisDataID) == parseInt(window.CurrentSelectedRoomID)) // Get Which Room Data ------------------
        {
            window.ThisRoomData = RoomDatas[i];
            console.log("ThisRoomData", window.ThisRoomData);
        }

        for(let j = 0; j < RoomHotelPanels.length; j++) // Check Which Room Available Based on Current Input ------------------------
        {
            if(parseInt(ThisDataID) == RoomHotelPanels[j].getAttribute("room-id") && window.CurrentSelectedAccFacilitiesType == RoomHotelPanels[j].getAttribute("type-facilities"))
            {
                let InvalidBlocker = RoomHotelPanels[j].querySelectorAll('.RoomUnavailableBlockerHotelDetails')[0];
                
                if(RoomDatas[i].status_available == "No")
                {
                    InvalidBlocker.style.display = "";
                }
                else
                {
                    InvalidBlocker.style.display = "none";
                }
            }
        }
    }

    // -----------------------------

    console.log("window.CurrentSelectedAccFacilitiesType", window.CurrentSelectedAccFacilitiesType);

    // ----------------------------- ROOM TYPE --------------------------------
    
    let RoomExperienceNameText = window.ThisRoomData.room_name || window.ThisRoomData["name_" + window.CurrentCountryID];

    let RoomTypeHotelDetailsText = document.getElementById("RoomTypeHotelDetailsText");
    if(RoomTypeHotelDetailsText != null)
        RoomTypeHotelDetailsText.innerHTML = RoomExperienceNameText;
    
    let RoomExpSelectedNameMobile = document.getElementById("RoomExpSelectedNameMobile");
    if(RoomExpSelectedNameMobile != null)
        RoomExpSelectedNameMobile.innerHTML = RoomExperienceNameText;

    // ----------------------------- MIN BOOK RANGE DATE ----------------------------------

    let MinRangeDateContainerLeft = document.getElementById("MinRangeDateContainerLeft");
    if(MinRangeDateContainerLeft != null)
        MinRangeDateContainerLeft.style.display = "none";

    let MinRangeDateContainerRight = document.getElementById("MinRangeDateContainerRight");
    if(MinRangeDateContainerRight != null)
        MinRangeDateContainerRight.style.display = "none";

    
    let MinRangeDateContainerMobile = document.getElementById("MinRangeDateContainerMobile");
    if(MinRangeDateContainerMobile != null)
        MinRangeDateContainerMobile.style.display = "none";


    let WhatMinRangeThis = 0;
    WhatMinRangeThis = window.ThisRoomData.min_booking_notice_days;

    if(WhatMinRangeThis > 0)
    {
        MinRangeDateContainerRight.style.display = "flex";
        let KebijakanReservasiHeaderText = document.getElementById("KebijakanReservasiHeaderText");
        if(KebijakanReservasiHeaderText != null)
            KebijakanReservasiHeaderText.innerHTML = window["KebijakanReservasiTxt" + window.CurrentCountryID];

        let MinRangeDateContainerRightText = document.getElementById("MinRangeDateContainerRightText");
        if(MinRangeDateContainerRightText != null)
            MinRangeDateContainerRightText.innerHTML = window.MinRangeTextRight(WhatMinRangeThis);

        MinRangeDateContainerMobile.style.display = "flex";
        let MinRangeDateContainerMobileText = document.getElementById("MinRangeDateContainerMobileText");
        if(MinRangeDateContainerMobileText != null)
            MinRangeDateContainerMobileText.innerHTML = window.MinRangeTextRight(WhatMinRangeThis);
    }

    // ----------------------------- ROOM PRICE & FINAL PRICE --------------------------------

    console.log("window.ThisRoomData ", window.ThisRoomData);

    let ThisRoomPingData = window.ThisRoomData?.room_pings?.[0]?.dates ?? window.ThisRoomData?.dates;

    let RoomTypeUnavailableText = document.getElementById("RoomTypeUnavailableText");
    RoomTypeUnavailableText.style.display = "none";

    // let MobileWarningContainer = document.getElementById("MobileWarningContainer");
    // let MobileWarningText = document.getElementById("MobileWarningText");
    // MobileWarningContainer.style.display = "none";

    (async () =>
    {
        console.log("ThisRoomPingData", ThisRoomPingData);
        
        let RoomPingDataCheck = await window.CheckRoomExpDataAvaliablePrice(window.CurrentSelectedAccFacilitiesType, ThisRoomPingData, window.ThisRoomData, false);

        console.log("HotelDetailsLoadedData", HotelDetailsLoadedData);

        let DPPercentage = HotelDetailsLoadedData?.dp_percentage[0]?.percentage;
        if(DPPercentage == null)
            DPPercentage = 0;

        // APPLY CHANGES =========================================================================

        let HotelDetailsOriginalPriceText = document.getElementById("HotelDetailsOriginalPrice");
        HotelDetailsOriginalPriceText.innerHTML = "---.---";

        let HotelDetailsDiscountedPriceText = document.getElementById("HotelDetailsDiscountedPrice");
        HotelDetailsDiscountedPriceText.innerHTML = "Rp ---.---";

        let DownPaymentPriceText = document.getElementById("DownPaymentPriceText");
        DownPaymentPriceText.innerHTML = "Rp ---.---";

        let FinalPriceEstimationText = document.getElementById("FinalPriceEstimationText");
        FinalPriceEstimationText.innerHTML = "Rp ---.---";
        
        let YouSavedPriceText = document.getElementById("YouSavedPriceText");
        YouSavedPriceText.innerHTML = window["YouSavedTxt" + window.CurrentCountryID] + " &#xB1; Rp ---.---";

        let PingNowButton = document.getElementById("PingNowButton"); // Main Book Button -----------------------------------------------------------------------
        let PingNowButtonHREF = document.getElementById("PingNowButtonHREF");
        PingNowButtonHREF.style.display = "none";
        PingNowButtonHREF.href = "";


        if(MobileBookCheckRoomButtonHotelDetails != null) // Mobile Low Panel Button -----------------------------------------------------------------------
        {
            MobileBookCheckRoomButtonHotelDetails.innerHTML = window["ContinueTxt2" + window.CurrentCountryID];
            MobileBookCheckRoomButtonHotelDetails.className = "BasicTextButton BasicBoxShadow OrangeButton HorizontalButtonExpanded SignInTopDropDownText ButtonInvalid";
            MobileBookCheckRoomButtonHotelDetails.onclick = function(){}
        }


        // Check If It is Per Night or Item --------------------------------------------------------------

        let CheckInHeaderText = document.getElementById("CheckInHeaderText");
        let DateOfVisitHeaderContainer = document.getElementById("DateOfVisitHeaderContainer");
        let UpdatedMobileDateText = "";
        let CheckInDateArray = window.CheckInDateNonTop.split("-");
        let CheckOutDateArray = window.CheckOutDateNonTop.split("-");

        if(window.ThisRoomData.book_type == "per night") // Can Range of Date (Check In and Out)
        {
            window.CheckOutNonTopInput.style.display = "";
            CheckInHeaderText.style.display = "";
            DateOfVisitHeaderContainer.style.display = "none";

            let ThisCheckInDateToDisplay = CheckInDateArray[2].padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][parseInt(CheckInDateArray[1])-1] + " " + CheckInDateArray[0];
            let ThisCheckOutDateToDisplay = CheckOutDateArray[2].padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][parseInt(CheckOutDateArray[1])-1] + " " + CheckOutDateArray[0];
            UpdatedMobileDateText = ThisCheckInDateToDisplay + " - " + ThisCheckOutDateToDisplay;
        
            // window.CheckOutNonTopInput.className = "HoverableContentInsideInputField Unselectable";
        }
        else if(window.ThisRoomData.book_type == "per day") // Select Date Only one day at a time
        {
            window.CheckOutNonTopInput.style.display = "none";
            CheckInHeaderText.style.display = "none";
            DateOfVisitHeaderContainer.style.display = "flex";

            UpdatedMobileDateText = CheckInDateArray[2].padStart(2, '0') + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(CheckInDateArray[1])-1] + " " + CheckInDateArray[0];
            // window.CheckOutNonTopInput.className = "HoverableContentInsideInputField DarkenUnselectable ButtonUnselectableOpacity";
        }
        // console.log("window.HotelDetails", ThisRoomPingData);


        let ThisCheckInOutMobileText = document.querySelectorAll(".ExtraMobileCheckInOutDateText");
        ThisCheckInOutMobileText.forEach(thistext =>
        {
            thistext.innerHTML = UpdatedMobileDateText;
        });
            

        // Apply Based On Room Status -------------------------------------------------------------------------

        if(RoomPingDataCheck.room_status == false)
        {
            RoomTypeUnavailableText.style.display = "";
            RoomTypeUnavailableText.innerHTML = RoomPingDataCheck.unavailable_text;

            // MobileWarningContainer.style.display = "";
            // MobileWarningText.innerHTML = RoomPingDataCheck.unavailable_text;

            PingNowButton.className = "BasicTextButton BasicBoxShadow ButtonInvalid SignInButtonTop";
            PingNowButton.onclick = function(){};
        }
        else
        {
            console.log("ThisRoomPingData", ThisRoomPingData);

            let OriginalPriceTotal = parseInt(RoomPingDataCheck.temp_final_price_basic);
            let FinalPriceAfterDiscount = parseInt(RoomPingDataCheck.temp_final_price_after_disc);
            let DiscountedPriceTotal = OriginalPriceTotal - FinalPriceAfterDiscount;
            // let FinalPriceAfterDiscount = parseInt(RoomPingDataCheck.temp_final_price_after_disc);

            // let OriginalPriceTotal = parseInt(RoomPingDataCheck.price_basic * window.RoomQuotaNonTop);
            // console.log("Total Original Price = " + RoomPingDataCheck.price_basic + " (Original Price) x " + window.RoomQuotaNonTop + " (Room Quota) = " + OriginalPriceTotal);

            // let DiscountedPriceTotal = parseInt(OriginalPriceTotal * HotelDetailsLoadedData.max_disc / 100);
            // console.log("Total Discounted (Before Max) = " + OriginalPriceTotal + " (Total Original Price) x " + HotelDetailsLoadedData.max_disc + "% (Discount) = " + DiscountedPriceTotal);

            // if(DiscountedPriceTotal >= HotelDetailsLoadedData.max_disc_until && HotelDetailsLoadedData.max_disc_until != 0 && HotelDetailsLoadedData.max_disc_until != null)
            // {
            //     DiscountedPriceTotal = HotelDetailsLoadedData.max_disc_until;
            //     console.log("Total Discounted Updated (Since it Exceed the Max) = " + DiscountedPriceTotal);
            // }

            // let FinalPriceAfterDiscount = OriginalPriceTotal - DiscountedPriceTotal;
            // console.log("Final Price After Discount = " + OriginalPriceTotal + " (Original Price) - " + DiscountedPriceTotal + " (Discount Price) = " + FinalPriceAfterDiscount);

            let PayAtHotelPercentage = 100 - parseInt(DPPercentage);
            //console.log("Pay at Hotel Percentage = 100 - " + DPPercentage + " (DP Percentage)");

            let PayAtHotelPrice = OriginalPriceTotal * PayAtHotelPercentage / 100;
            //console.log("Pay at Hotel Price = " + OriginalPriceTotal + " (Original Price) x " + PayAtHotelPercentage + "% (Pay at Hotel %)/ 100 = " + PayAtHotelPrice)

            let FinalDPPrice = parseInt(FinalPriceAfterDiscount - PayAtHotelPrice);
            //console.log("Total Down Payment = " + FinalPriceAfterDiscount + " (Final Price After Discount) - " + PayAtHotelPrice + " (Pay at Hotel Price) = " + FinalDPPrice);


            if(FinalDPPrice <= 0 && DPPercentage > 0)
            {
                console.log("!!!!!!!!!!!!!!!!!!!! Since DP Become Minus Let's Calculate with 2nd Method !!!!!!!!!!!!!!!!!!!!");
                PayAtHotelPrice =  FinalPriceAfterDiscount * PayAtHotelPercentage / 100;
                //console.log("Pay at Hotel Price = " + FinalPriceAfterDiscount + " (Final Price) x " + PayAtHotelPercentage + "% (Pay at Hotel %)/ 100");

                FinalDPPrice = parseInt(FinalPriceAfterDiscount - PayAtHotelPrice);
                //console.log("Total Down Payment = " + FinalPriceAfterDiscount + " (Final Price After Discount) - " + PayAtHotelPrice + " (Pay at Hotel Price)");
            }

            let TotalSaved = OriginalPriceTotal - FinalPriceAfterDiscount;
            //console.log(OriginalPriceTotal + " - " + FinalPriceAfterDiscount + " = " + TotalSaved)


            HotelDetailsOriginalPriceText.innerHTML = OriginalPriceTotal;
            HotelDetailsDiscountedPriceText.innerHTML = window.ConvertTextToRP(FinalPriceAfterDiscount, 1, false, false);
            DownPaymentPriceText.innerHTML = window.ConvertTextToRP(FinalDPPrice, 1, false, false);
            FinalPriceEstimationText.innerHTML = "&#xB1; " + window.ConvertTextToRP(FinalPriceAfterDiscount, 1, false, false);
            YouSavedPriceText.innerHTML = window["YouSavedTxt" + window.CurrentCountryID] + " &#xB1; " + window.ConvertTextToRP(TotalSaved, 1, false, false);


            let DownPaymentContentWrapper = document.querySelectorAll(".DownPaymentContentWrapper");
            DownPaymentContentWrapper.forEach(element =>
            {
                if(DPPercentage == 0 || (DPPercentage > 0 && FinalDPPrice == 0))
                {
                    element.style.display = "none";
                }
                else
                {
                    element.style.display = "";
                }
            });



            // UI Mobile (Old) --------------------------------------------------------------------------------------------------------------------------------------------------------------
            let OriginalPriceTextMobileHotelDetails = document.getElementById("OriginalPriceTextMobileHotelDetails");
            let FinalPriceTextMobileHotelDetails = document.getElementById("FinalPriceTextMobileHotelDetails");

            if(OriginalPriceTextMobileHotelDetails != null)
                OriginalPriceTextMobileHotelDetails.innerHTML = window.ConvertTextToRP(RoomPingDataCheck.temp_final_price_basic_only_quota, 1, false, false);

            if(FinalPriceTextMobileHotelDetails != null)
            {
                if(window.ThisRoomData.book_type == "per day")
                {
                    FinalPriceTextMobileHotelDetails.innerHTML = window.ConvertTextToRP(RoomPingDataCheck.temp_final_price_after_disc_only_quota, 1, false, false) + "<span class='InterMediumTextFont' style='color:#000000'>" + window["PerItemTxt" + window.CurrentCountryID] + "</span>";
                }
                else
                {
                    FinalPriceTextMobileHotelDetails.innerHTML = window.ConvertTextToRP(RoomPingDataCheck.temp_final_price_after_disc_only_quota, 1, false, false) + "<span class='InterMediumTextFont' style='color:#000000'>" + window["PerMalam2Txt" + window.CurrentCountryID] + "</span>";
                }
            }

            // UI Mobile (New) ---------------------------------------------------------------------------------------------------------------------------------------------------------------
            let OriginalPriceTextMobileHotelDetails2 = document.getElementById("OriginalPriceTextMobileHotelDetails2");
            let FinalPriceTextMobileHotelDetails2 = document.getElementById("FinalPriceTextMobileHotelDetails2");
            let KamuBerhasilHematMobileText = document.getElementById("KamuBerhasilHematMobileText");

            if(OriginalPriceTextMobileHotelDetails2 != null)
                OriginalPriceTextMobileHotelDetails2.innerHTML = OriginalPriceTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            if(FinalPriceTextMobileHotelDetails2 != null)
                FinalPriceTextMobileHotelDetails2.innerHTML = window.ConvertTextToRP(FinalPriceAfterDiscount, 1, false, false);

            if(KamuBerhasilHematMobileText != null)
            {
                if(DiscountedPriceTotal <= 0)
                {
                    KamuBerhasilHematMobileText.style.display = "none";
                }
                else
                {
                    KamuBerhasilHematMobileText.style.display = "";
                    KamuBerhasilHematMobileText.innerHTML = window["YouSavedTxt2" + window.CurrentCountryID] + " " +  window.ConvertTextToRP(DiscountedPriceTotal, 1, false, false);
                }
            }

            // Update URL BOOK NOW -----------------------------------------------------------------------------------------------------------------------------------------------------------
            let ThisCheckOutData = window.CheckOutDateNonTop;
            // if(window.ThisRoomData != null && window.ThisRoomData.book_type == "per day")
            //     ThisCheckOutData = window.CheckInDateNonTop;
        

            let UpdateHREFPingNow = "/" + window.CurrentCountryID + "/payment.html?search=" + HotelDetailsLoadedData.province + "&checkin=" + window.CheckInDateNonTop + "&checkout=" + ThisCheckOutData + "&room=" + window.RoomQuotaNonTop + "&id_hotel="+ window.HotelID + "&id_hotel_room=" + window.CurrentSelectedRoomID + "&slug=" + window.HotelSlug + "&type=" + window.CurrentSelectedAccFacilitiesType;

            if(window.CurrentSelectedAccFacilitiesType == "Experiences")
            {
                const jsonString = JSON.stringify(window.CurrentUserInputExperienceAddOns);
                const encodedJSON = encodeURIComponent(jsonString);

                UpdateHREFPingNow = UpdateHREFPingNow + "&expin=" + encodedJSON;
            }

            console.log(UpdateHREFPingNow);

            PingNowButtonHREF.style.display = "";
            PingNowButtonHREF.href = UpdateHREFPingNow;

            PingNowButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
            PingNowButton.onclick = function()
            {
                window.location.href = UpdateHREFPingNow;
            }

            if(MobileBookCheckRoomButtonHotelDetails != null)
            {
                MobileBookCheckRoomButtonHotelDetails.className = "BasicTextButton BasicBoxShadow OrangeButton HorizontalButtonExpanded SignInTopDropDownText Selectable";
                MobileBookCheckRoomButtonHotelDetails.onclick = function()
                {
                    window.location.href = UpdateHREFPingNow;
                }
            }

        }
    })();
}



// ============================================ LOAD ADD ONS ============================================

function LoadAddOnsHotel()
{
    // Prepare Elements --------------------------------------------------------------------------
    let MainContainer = document.getElementById("HotelDetailsAddOnMainContainer");
    let SwiperWrapper = document.getElementById("AddOnsHotelDetailSwiperWrapper");

    MainContainer.style.display = "";
    SwiperWrapper.innerHTML = "";
    
    InstantiateLoadingAddOnHotelDetailsPanel(SwiperWrapper);

    // Load Add Ons --------------------------------------------------------------------------
    let LoadAddOnsURL = "/v2/hotels/" +window.HotelID + "/add-ons";
    // let LoadAddOnsURL = "/v2/rooms/" + window.CurrentSelectedRoomID + "/add-ons";

    let CheckAddOnFormData = new FormData();
    CheckAddOnFormData.append('checkin', window.CheckInDateNonTop);
    CheckAddOnFormData.append('checkout', window.CheckOutDateNonTop);
    CheckAddOnFormData.append('lang', window.CurrentCountryID);

    window.CallApiAxios({
        method: "POST",
        url: LoadAddOnsURL,
        data: CheckAddOnFormData,
    })
    .then(res =>
    {
        let ThisAddOnRoomData = res.data.data;
        console.log(LoadAddOnsURL);
        console.log(ThisAddOnRoomData);

        SwiperWrapper.innerHTML = "";
        InstantiateAddOnHotelDetailsPanel(SwiperWrapper, ThisAddOnRoomData);
    })
    .catch(err =>
    {
        console.error(err);
        MainContainer.style.display = "none";
    });
}

function InstantiateLoadingAddOnHotelDetailsPanel(SwiperWrapper)
{
    for(let i = 0; i < 5; i++)
    {
        let AddOnsPanel = document.createElement("div");
        AddOnsPanel.className = "AddOnsHotelDetailsPanel swiper-slide";
        SwiperWrapper.append(AddOnsPanel);

        let AddOnsContainer = document.createElement("div");
        AddOnsContainer.className = "FaciltyChildrenContainer InputFieldMargin3";
        AddOnsPanel.append(AddOnsContainer);

        let AddOnsNameText = document.createElement("p");
        AddOnsNameText.className = "FacilityNameText InterBoldTextFont loading_grey";
        AddOnsNameText.innerHTML = 'Test Add Ons Name';
        AddOnsNameText.style.color = "transparent";
        AddOnsNameText.style.width = "fit-content";
        AddOnsContainer.append(AddOnsNameText);

        let AddOnsDescriptionContainer = document.createElement("div");
        AddOnsDescriptionContainer.className = "OrangeWarningContainer BasicRadius InputFieldMargin2";
        AddOnsDescriptionContainer.style.display = "flex";
        AddOnsDescriptionContainer.style.flexDirection = "column";
        AddOnsPanel.append(AddOnsDescriptionContainer);

        let AddOnsDescriptionText = document.createElement("p");
        AddOnsDescriptionText.className = "LabelGreyHeaderSmallerText InterRegularTextFont loading_grey InputFieldMargin3";
        AddOnsDescriptionText.style.width = "95%";
        AddOnsDescriptionText.style.color = "transparent";
        AddOnsDescriptionText.innerText = "Test Info For A While";
        AddOnsDescriptionContainer.append(AddOnsDescriptionText);

        let AddOnsDescriptionText2 = document.createElement("p");
        AddOnsDescriptionText2.className = "LabelGreyHeaderSmallerText InterRegularTextFont loading_grey";
        AddOnsDescriptionText2.style.width = "70%";
        AddOnsDescriptionText2.style.color = "transparent";
        AddOnsDescriptionText2.innerText = "This Shorter";
        AddOnsDescriptionContainer.append(AddOnsDescriptionText2);
    }
}

function InstantiateAddOnHotelDetailsPanel(SwiperWrapper, thisaddondata)
{
    for(let i = 0; i < thisaddondata.length; i++)
    {
        let AmountRequiredThisData = thisaddondata[i].is_required;

        let AddOnName = thisaddondata[i]["name_" + window.CurrentCountryID];
        if(AmountRequiredThisData != "0")
            AddOnName = AddOnName + ' <span style="color: #c10000">*</span>';


        let AddOnsPanel = document.createElement("div");
        AddOnsPanel.className = "AddOnsHotelDetailsPanel swiper-slide";
        SwiperWrapper.append(AddOnsPanel);

        let FacilityContainer2 = document.createElement("div");
        FacilityContainer2.className = "FaciltyChildrenContainer InputFieldMargin3";
        AddOnsPanel.append(FacilityContainer2);

        let FacilityIcon2 = document.createElement("img");
        FacilityIcon2.className = "FacilityIcon";
        FacilityIcon2.src = thisaddondata[i].image_link;
        FacilityContainer2.append(FacilityIcon2);

        let FacilityText2 = document.createElement("p");
        FacilityText2.className = "FacilityNameText InterBoldTextFont";
        FacilityText2.innerHTML = AddOnName;
        FacilityContainer2.append(FacilityText2);

        if(thisaddondata[i]["desc_" + window.CurrentCountryID] != null  && thisaddondata[i]["desc_" + window.CurrentCountryID].replace(/ /g, "") != "")
        {
            let WarningContainer2 = document.createElement("div");
            WarningContainer2.className = "OrangeWarningContainer BasicRadius InputFieldMargin2";
            WarningContainer2.style.display = "flex";
            WarningContainer2.style.flexDirection = "row";
            AddOnsPanel.append(WarningContainer2);

            let WarningText2 = document.createElement("p");
            WarningText2.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
            WarningText2.style.color = "#344054";
            WarningText2.innerHTML = thisaddondata[i]["desc_" + window.CurrentCountryID];
            WarningContainer2.append(WarningText2);
        }
    }
}



// ============================================ UBAH KAMAR MOBILE ============================================

// window.MobileCheckInToChange = '';
// window.MobileCheckOutToChange = '';
// window.MobileQuotaToChange = '';
// window.MobileRoomTypeIDToChange = 0;
// window.MobilePotentialRoomDataToChange = null;

window.InstantiateEditHotelDetailsMobileMenu = function(functiontocallonsave, functiontocallonclose, isallowchangeroomtype, isallowrefreshexperiencedata, allowchangedate)
{
    if(window.ThisRoomData == null)
    {
        const RoomHotelContainer = document.getElementById("ChangeRoomContainerHotelDetailsMobile");
        if(RoomHotelContainer != null)
            window.ScrollToWindow(RoomHotelContainer);

        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["PleaseSelectARoomOrItemFirstTxt" + window.CurrentCountryID]);
        return
    }

    // Early Setup -----------------------------------------------------------

    window.CurrentSelectedCheckIn = ''; // Check In -----------------------
    if(window.CheckInDateNonTop != null)
    {
        let MobileCheckInArray = window.CheckInDateNonTop.split("-");
        let ThisCheckInDate = new Date(MobileCheckInArray[0], parseInt(MobileCheckInArray[1] - 1), MobileCheckInArray[2]);

        window.CurrentSelectedCheckIn = ThisCheckInDate;
    }

    window.CurrentSelectedCheckOut = ''; // Check Out -----------------------
    if(window.CheckOutDateNonTop != null)
    {
        let MobileCheckOutArray = window.CheckOutDateNonTop.split("-");
        let ThisCheckOutDate = new Date(MobileCheckOutArray[0], parseInt(MobileCheckOutArray[1] - 1), MobileCheckOutArray[2]);

        window.CurrentSelectedCheckOut = ThisCheckOutDate;
    }

    window.ThisCurrentQuotaInput = 0; // Quota 
    if(window.RoomQuotaNonTop != null)
        window.ThisCurrentQuotaInput = window.RoomQuotaNonTop;

    window.CurrentSelectedDayEdit = window.CurrentSelectedCheckIn.getDate(); // Current Selected Date (Individual)
    window.CurrentSelectedMonthEdit = window.CurrentSelectedCheckIn.getMonth()+1;
    window.CurrentSelectedYearEdit = window.CurrentSelectedCheckIn.getFullYear();


    window.CurrentSelectedRoomTypeIDToChange = 0; // Room Type ID 
    if(window.CurrentSelectedRoomID != null)
        window.CurrentSelectedRoomTypeIDToChange = window.CurrentSelectedRoomID;

    let ContentWrapper = null; // Main Container ------------------------------

    let ContainerWarningBookingAtLeast = null; // Top Warning -----------
    let WarningBookingAtLeastText = null;

    let RoomExperienceValue = null; // Room or Experience Type -----------

    let CheckInValue = null; // Check In Out Value -----------

    let GuestTitle = null; // Guest Or Number of Room ------------------
    let GuestValue = null;
    let RoomWarning = null;

    let ExperienceInputContainer = null; // Experience Where To Instantiate -------------------

    let SaveButton = null;
    
    let RefreshMobileUpdateUI = function(isreload)
    {
        console.log("UPDATING................");
        console.log("LatestUpdate",
            {
                "window.CurrentSelectedRoomID":window.CurrentSelectedRoomID,
                "window.CurrentSelectedRoomExpBookType":window.CurrentSelectedRoomExpBookType,
                "window.CurrentSelectedAccFacilitiesType":window.CurrentSelectedAccFacilitiesType,
                "window.ThisRoomData":window.ThisRoomData,
                "window.CheckInDateNonTop": window.CheckInDateNonTop,
                "window.CheckOutDateNonTop": window.CheckOutDateNonTop,
                "window.CurrentSelectedYearEdit": window.CurrentSelectedYearEdit,
                "window.CurrentSelectedMonthEdit": window.CurrentSelectedMonthEdit,
                "window.CurrentSelectedDayEdit": window.CurrentSelectedDayEdit,
                "window.CurrentUserInputExperienceAddOns": window.CurrentUserInputExperienceAddOns
            }
        )

        // if(RoomExperienceValue != null) // Room or Experience Type -----------
        // {
        //     for(let i = 0; i < window.HotelDetails.rooms.length; i++)
        //     {
        //         if(window.HotelDetails.rooms[i].id_hotel_room == window.CurrentSelectedRoomTypeIDToChange)
        //         {
        //             window.MobilePotentialRoomDataToChange = window.HotelDetails.rooms[i];
        //             RoomExperienceValue.innerHTML = window.MobilePotentialRoomDataToChange.room_name;
        //         }
        //     }
        // }
        // let NewUpdate

        // window.CurrentSelectedDayEdit =

        if(ContainerWarningBookingAtLeast != null)
        {
            if(window.ThisRoomData.min_booking_notice_days != null && window.ThisRoomData.min_booking_notice_days > 0) // Top Warning
            {
                ContainerWarningBookingAtLeast.style.display = "";
                WarningBookingAtLeastText.innerHTML = window.MinRangeTextLeft(window.ThisRoomData.min_booking_notice_days);
            }
            else
            {
                ContainerWarningBookingAtLeast.style.display = "none";
            }
        }

        
        if(CheckInValue != null)  // Check In Out Value -----------
        {
            let CheckInDateDisplay = "-- ---- ----";
            if(window.CurrentSelectedCheckIn != "")
            {
                CheckInDateDisplay = window.CurrentSelectedCheckIn.getDate() + " " + window["monthNames" + window.CurrentCountryID][window.CurrentSelectedCheckIn.getMonth()] + " " + window.CurrentSelectedCheckIn.getFullYear();
            }
            
            if(window.ThisRoomData.book_type == "per night")
            {
                let CheckOutDateDisplay = "-- ---- ----";

                if(window.CurrentSelectedCheckOut != "")
                {
                    CheckOutDateDisplay = window.CurrentSelectedCheckOut.getDate() + " " + window["monthNames" + window.CurrentCountryID][window.CurrentSelectedCheckOut.getMonth()] + " " + window.CurrentSelectedCheckOut.getFullYear();
                }

                CheckInValue.innerHTML = CheckInDateDisplay + " - " + CheckOutDateDisplay;
            }
            else
            {
                CheckInValue.innerHTML = CheckInDateDisplay;
            }
        }

        if(GuestTitle != null && GuestValue != null && RoomWarning != null)
        {
            GuestTitle.innerHTML = window["RoomAmountTxt" + window.CurrentCountryID];

            let RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["RoomTxt" + window.CurrentCountryID];
            if(window.RoomQuotaNonTop > 1)
            {
                RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["RoomTxtex" + window.CurrentCountryID];
            }

            // if(window.ThisRoomData.book_type == "per day") // Select Date Only one day at a time
            // {
            //     GuestTitle.innerHTML = window["ItemAmountTxt" + window.CurrentCountryID];

            //     RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["ItemsTxt" + window.CurrentCountryID];
            //     if(window.RoomQuotaNonTop > 1)
            //         RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["ItemsTxtex" + window.CurrentCountryID];
            // }

            GuestValue.innerHTML = RoomQuotaTextToDisplay;
        }


        if(window.CurrentSelectedAccFacilitiesType == "Experiences")
        {
            if(isreload == true) // If Require Reload Reload All ----------------------------------------------------
            {
                let ThisLoading = window.InstantiateLoadingCircle(ContentWrapper, true);
                ThisLoading.style.zIndex = 1;

                let UpdatedCheckInFullDate = window.ConvertDateStringToDateFormat(window.CheckInDateNonTop);
                let UpdatedCheckOutFullDate = window.ConvertDateStringToDateFormat(window.CheckOutDateNonTop);

                window.LoadTipeExperienceBefore(UpdatedCheckInFullDate, UpdatedCheckOutFullDate, isallowrefreshexperiencedata, ()=>
                {
                    window.InstantiateDropDownExperienceOptions(ExperienceInputContainer, ()=>
                    {
                        RefreshMobileUpdateUI(false);
                    }, false);
                        
                    ThisLoading.remove();  
                });
            }
            else
            {
                CheckAllExperienceInputted(SaveButton);
            }
        }
    };
    
    // Instantiate -----------------------------------------------------------

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker ResponsiveMobilePanel";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    /* ==================== PANEL ==================== */

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel FlexPanelOnlyForMobile";
    FlexFullDisplayPanel.style.padding = "0px";
    BasicBlackBlocker.append(FlexFullDisplayPanel);


    /* ==================== HEADER ==================== */

    let HeaderContainer = document.createElement("div");
    HeaderContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow BasicRadius";
    FlexFullDisplayPanel.append(HeaderContainer);

    let HeaderRow = document.createElement("div");
    HeaderRow.style.flex = "1 1 0%";
    HeaderRow.style.height = "fit-content";
    HeaderRow.style.display = "flex";
    HeaderRow.style.position = "relative";
    HeaderContainer.append(HeaderRow);

    let HeaderTitle = document.createElement("p");
    HeaderTitle.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    HeaderTitle.style.margin = "auto 0";
    HeaderRow.append(HeaderTitle);

    let CloseButton = document.createElement("img");
    CloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.style.position = "absolute";
    CloseButton.style.right = "0px";
    CloseButton.style.top = "50%";
    CloseButton.style.transform = "translateY(-50%)";
    CloseButton.onclick = function()
    {
        if(functiontocallonclose != null)
            functiontocallonclose();

        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    HeaderRow.append(CloseButton);

    BasicBlackBlocker.OnResponsiveRemove = function()
    {
        if(functiontocallonclose != null)
            functiontocallonclose();
    };
    
    /* ==================== CONTENT ==================== */
    ContentWrapper = document.createElement("div");
    ContentWrapper.className = "TopBottomHeaderButtonPaddingContainer PingExprezyViewMoreContainer";
    ContentWrapper.style.width = "auto";
    ContentWrapper.style.display = "flex";
    ContentWrapper.style.flexDirection = "column";
    FlexFullDisplayPanel.append(ContentWrapper);


    /* ==================== BOOKING NOTICE DAYS ==================== */

    ContainerWarningBookingAtLeast = document.createElement("div"); // Top Warning Text ------------------------------------
    ContainerWarningBookingAtLeast.className = "ContainerWithIconAndText BasicRadius InputFieldMargin3";
    ContainerWarningBookingAtLeast.style.backgroundColor = "#FFFAEB";
    ContainerWarningBookingAtLeast.style.flexDirection = "column";
    ContainerWarningBookingAtLeast.style.display = "none";
    ContentWrapper.append(ContainerWarningBookingAtLeast);

    let WarningBookingHeaderText = document.createElement("p");
    WarningBookingHeaderText.className = "LabelGreyHeaderSmallerText2 InterBoldTextFont InputFieldMargin3";
    WarningBookingHeaderText.innerHTML = window["KebijakanReservasiTxt" + window.CurrentCountryID];
    ContainerWarningBookingAtLeast.append(WarningBookingHeaderText);

    WarningBookingAtLeastText = document.createElement("p"); 
    WarningBookingAtLeastText.className = "LabelGreyHeaderSmallerText2 InterMediumTextFont";
    WarningBookingAtLeastText.style.margin = "auto 0";
    WarningBookingAtLeastText.style.color = "#344054";
    ContainerWarningBookingAtLeast.append(WarningBookingAtLeastText);

    /* ==================== ROOM OR EXPERIENCE TYPE ==================== */

    if(window.HotelDetails?.rooms?.length > 0 && isallowchangeroomtype == true)
    {
        let RoomExperienceWrapper = document.createElement("div");
        RoomExperienceWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
        ContentWrapper.append(RoomExperienceWrapper);

        let RoomExperienceHover = document.createElement("div");
        RoomExperienceHover.className = "HoverableContentInsideInputField Unselectable";
        RoomExperienceWrapper.append(RoomExperienceHover);

        let RoomExperienceField = document.createElement("div");
        RoomExperienceField.className = "SearchTopNonIndexSection BasicInputFieldContainer Selectable3";
        RoomExperienceField.style.backgroundColor = "rgba(252, 252, 255, 0.8)";
        RoomExperienceHover.append(RoomExperienceField);

        let RoomExperienceIcon = document.createElement("img");
        RoomExperienceIcon.className = "BasicIconInsideInput";
        RoomExperienceIcon.src = "/Assets/images/ButtonIcon/room-icon.svg";
        RoomExperienceIcon.style.marginLeft = "0";
        RoomExperienceField.append(RoomExperienceIcon);

        let RoomExperienceTextWrapper = document.createElement("div");
        RoomExperienceTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
        RoomExperienceField.append(RoomExperienceTextWrapper);

        let RoomExperienceTitle = document.createElement("p");
        RoomExperienceTitle.className = "BasicInputTextTop InterBoldTextFont";
        RoomExperienceTitle.style.marginTop = "0";
        RoomExperienceTitle.innerHTML = window["RoomOrItemTypeTxt" + window.CurrentCountryID];
        RoomExperienceTextWrapper.append(RoomExperienceTitle);

        RoomExperienceValue = document.createElement("p");
        RoomExperienceValue.className = "BasicInputTextBottom InterRegularTextFont";
        RoomExperienceValue.style.color = "#667085";
        RoomExperienceValue.innerHTML = "------ ------";
        RoomExperienceTextWrapper.append(RoomExperienceValue);

        let RoomExperienceChevron = document.createElement("img");
        RoomExperienceChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
        RoomExperienceChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow Selectable2";
        RoomExperienceChevron.style.rotate = "-90deg";
        RoomExperienceField.append(RoomExperienceChevron);

        RoomExperienceField.onclick = function()
        {
            window.InstantiateMobileRoomExperienceTypeScrollChoice(()=>
            {
                window.CurrentSelectedRoomID = window.CurrentSelectedRoomTypeIDToChange;
                
                RefreshMobileUpdateUI(false);

            }, false);
        }
    }


    /* ==================== CHECK IN / OUT ==================== */

    if(allowchangedate == true)
    {
        let CheckInWrapper = document.createElement("div");
        CheckInWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
        ContentWrapper.append(CheckInWrapper);

        let CheckInHover = document.createElement("div");
        CheckInHover.className = "HoverableContentInsideInputField Unselectable";
        CheckInWrapper.append(CheckInHover);

        let CheckInField = document.createElement("div");
        CheckInField.className = "SearchTopNonIndexSection BasicInputFieldContainer Selectable3";
        CheckInField.style.backgroundColor = "rgba(252, 252, 255, 0.8)";
        CheckInHover.append(CheckInField);

        let CalendarIcon = document.createElement("img");
        CalendarIcon.className = "BasicIconInsideInput";
        CalendarIcon.src = "/Assets/images/ButtonIcon/calendar-black.svg";
        CalendarIcon.style.marginLeft = "0";
        CheckInField.append(CalendarIcon);

        let CheckInTextWrapper = document.createElement("div");
        CheckInTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
        CheckInField.append(CheckInTextWrapper);

        let CheckInTitle = document.createElement("p");
        CheckInTitle.className = "BasicInputTextTop InterBoldTextFont";
        CheckInTitle.style.marginTop = "0";
        CheckInTitle.innerHTML = window["CheckInNOutTxt" + window.CurrentCountryID];
        if(window.CurrentSelectedAccFacilitiesType == "Experiences")
            CheckInTitle.innerHTML = window["DateOfVisitTxt" + window.CurrentCountryID];
        CheckInTextWrapper.append(CheckInTitle);

        CheckInValue = document.createElement("p");
        CheckInValue.className = "BasicInputTextBottom InterRegularTextFont";
        CheckInValue.style.color = "#667085";
        CheckInValue.innerHTML = "-- ---- ---- -  -- ---- ----";
        CheckInTextWrapper.append(CheckInValue);

        let CheckInChevron = document.createElement("img");
        CheckInChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
        CheckInChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow Selectable2";
        CheckInChevron.style.rotate = "-90deg";
        CheckInField.append(CheckInChevron);

        CheckInField.onclick = function()
        {
            let PreviousCheckIn = window.CurrentSelectedCheckIn;
            let PreviousCheckOut = window.CurrentSelectedCheckOut;

            let PreviousCheckInYear = window.CurrentSelectedYearEdit;
            let PreviousCheckInMonth = window.CurrentSelectedMonthEdit;
            let PreviousCheckInDay = window.CurrentSelectedDayEdit;

            let isallowmorethanone = true;
            if(window.ThisRoomData.book_type == "per day")
                isallowmorethanone = false;

            window.InstantiateDateChoiceMobilePanel(()=>
            {
                let NewCheckInYear;
                let NewCheckInMonth;
                let NewCheckInDay;

                let NewCheckOutYear;
                let NewCheckOutMonth;
                let NewCheckOutDay;

                if(window.ThisRoomData.book_type == "per night")
                {
                    let NewUpdateCheckInDateInfo = window.CurrentSelectedCheckIn;

                    NewCheckInYear = NewUpdateCheckInDateInfo.getFullYear();
                    NewCheckInMonth = (NewUpdateCheckInDateInfo.getMonth() + 1);
                    NewCheckInDay = NewUpdateCheckInDateInfo.getDate();

                    let NewUpdateCheckOutDateInfo = window.CurrentSelectedCheckOut;

                    NewCheckOutYear = NewUpdateCheckOutDateInfo.getFullYear();
                    NewCheckOutMonth = (NewUpdateCheckOutDateInfo.getMonth() + 1);
                    NewCheckOutDay = NewUpdateCheckOutDateInfo.getDate();
                }
                else
                {
                    NewCheckInYear = window.CurrentSelectedYearEdit;
                    NewCheckInMonth = window.CurrentSelectedMonthEdit;
                    NewCheckInDay = window.CurrentSelectedDayEdit;

                    let CurrentCheckOutDate = new Date(NewCheckInYear, NewCheckInMonth-1, NewCheckInDay);
                    CurrentCheckOutDate.setDate(CurrentCheckOutDate.getDate() + 1);

                    NewCheckOutYear = CurrentCheckOutDate.getFullYear();
                    NewCheckOutMonth = (CurrentCheckOutDate.getMonth() + 1);
                    NewCheckOutDay = CurrentCheckOutDate.getDate();
                }

                window.CheckInDateNonTop = NewCheckInYear + "-" + NewCheckInMonth + "-" + NewCheckInDay;
                window.CheckOutDateNonTop = NewCheckOutYear + "-" + NewCheckOutMonth + "-" + NewCheckOutDay;

                console.log("window.CheckInDateNonTop", window.CheckInDateNonTop);
                console.log("window.CheckOutDateNonTop", window.CheckOutDateNonTop);

                RefreshMobileUpdateUI(true);
                
            },
            ()=>
            {
                window.CurrentSelectedCheckIn = PreviousCheckIn;
                window.CurrentSelectedCheckOut = PreviousCheckOut;

                window.CurrentSelectedYearEdit = PreviousCheckInYear;
                window.CurrentSelectedMonthEdit = PreviousCheckInMonth;
                window.CurrentSelectedDayEdit = PreviousCheckInDay;

            }, false, isallowmorethanone);
        }

    }

    // Main Update Section For Accommodation =======================================================================

    if(window.CurrentSelectedAccFacilitiesType == "Rooms") // For Accommodation Instantiate 
    {
        /* ==================== GUEST & ROOM ==================== */
        let GuestWrapper = document.createElement("div");
        GuestWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
        ContentWrapper.append(GuestWrapper);

        let GuestHover = document.createElement("div");
        GuestHover.className = "HoverableContentInsideInputField Unselectable";
        GuestWrapper.append(GuestHover);

        let GuestField = document.createElement("div");
        GuestField.className = "SearchTopNonIndexSection BasicInputFieldContainer Selectable3";
        GuestField.style.backgroundColor = "rgba(252, 252, 255, 0.8)";
        GuestHover.append(GuestField);

        let GuestIcon = document.createElement("img");
        GuestIcon.className = "BasicIconInsideInput";
        GuestIcon.src = "/Assets/images/ButtonIcon/two-people-black.svg";
        GuestIcon.style.marginLeft = "0";
        GuestField.append(GuestIcon);

        let GuestTextWrapper = document.createElement("div");
        GuestTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
        GuestField.append(GuestTextWrapper);

        GuestTitle = document.createElement("p");
        GuestTitle.className = "BasicInputTextTop InterBoldTextFont";
        GuestTextWrapper.append(GuestTitle);

        GuestValue = document.createElement("p");
        GuestValue.className = "BasicInputTextBottom InterRegularTextFont";
        GuestValue.style.color = "#667085";
        GuestValue.innerHTML = "- ----";
        GuestTextWrapper.append(GuestValue);

        RoomWarning = document.createElement("p");
        RoomWarning.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont";
        RoomWarning.style.color = "#D92D20";
        RoomWarning.style.display = "none";
        RoomWarning.innerHTML = "Sorry, Room not Available for this date please change room type.";
        GuestTextWrapper.append(RoomWarning);

        let GuestChevron = document.createElement("img");
        GuestChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
        GuestChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow Selectable2";
        GuestChevron.style.rotate = "-90deg";
        GuestField.append(GuestChevron);

        
        GuestField.onclick = function()
        {
            let PreviousQuotaData = window.RoomQuotaNonTop;
            
            window.InstantiateEditGuestandRoomQuotaMobilePanel(()=>
            {
                window.RoomQuotaNonTop = window.ThisCurrentQuotaInput;

                RefreshMobileUpdateUI(false);

            },
            ()=>
            {
                window.RoomQuotaNonTop = PreviousQuotaData;
                
            }, false, false, window.CurrentSelectedAccFacilitiesType);
        }
    }
    else
    {
        // Experience Option section -----------------------------------------------
        ExperienceInputContainer = document.createElement("div");
        ExperienceInputContainer.className = "HoverableContentInsideInputField HotelDetailsHotelInformationMarginWrapper2";
        ExperienceInputContainer.style.flexDirection = "column";
        ExperienceInputContainer.style.backgroundColor = "#FFFAF5";
        // ExperienceInputContainer.className = "HotelDetailsHotelInformationMarginWrapper2";
        // ExperienceInputContainer.style.flexDirection = "column";
        // ExperienceInputContainer.style.display = "flex";
        // ExperienceInputContainer.style.width = "100%";
        ContentWrapper.append(ExperienceInputContainer);
    }



    /* ==================== SAVE BUTTON ==================== */
    let SaveWrapper = document.createElement("div");
    SaveWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    SaveWrapper.style.marginBottom = "0";
    ContentWrapper.append(SaveWrapper);

    SaveButton = document.createElement("button");
    SaveButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SaveButton.style.margin = "0";
    SaveButton.style.width = "100%";
    SaveButton.onclick = function()
    {
        console.log("Save Ubah Change Mobile");
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);

        if(functiontocallonsave != null)
            functiontocallonsave();
    }
    SaveWrapper.append(SaveButton);

    let SaveText = document.createElement("p");
    SaveText.className = "LabelGreyHeaderText";
    SaveText.style.cssText = "color:white; margin:auto;";
    SaveText.innerHTML = window["SavedButtonTxt" + window.CurrentCountryID];
    SaveButton.append(SaveText);


    // UPDATE FUNCTION ==============================================

    if(window.CurrentSelectedAccFacilitiesType == "Rooms")
    {
        HeaderTitle.innerHTML = window["ChangeRoomTxt" + window.CurrentCountryID];
    }
    else
    {
        HeaderTitle.innerHTML = window["ChangeExperienceTxt" + window.CurrentCountryID];
    }

    //------------------------------------ ANIMATE EASE IN --------------------------------------

    RefreshMobileUpdateUI(true);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}

// Room Quota --------------------------------------------------------------------------------------------------


window.InstantiateEditGuestandRoomQuotaMobilePanel = function(functiontocallonsave, functiontocallonclose, allowskip, isdirect, whichtype)
{
    console.log("CALLED window.InstantiateEditGuestandRoomQuotaMobilePanel");

    if(window.ThisRoomData == null && allowskip == false)
    {
        const RoomHotelContainer = document.getElementById("ChangeRoomContainerHotelDetailsMobile");
        if(RoomHotelContainer != null)
            window.ScrollToWindow(RoomHotelContainer);

        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["PleaseSelectARoomOrItemFirstTxt" + window.CurrentCountryID]);
        return
    }

    window.ThisCurrentQuotaInput = 0;
    if(whichtype == "Experiences" && window.CurrentUserInputExperienceAddOns != null && Array.isArray(window.CurrentUserInputExperienceAddOns.data_input) == false)
    {
        window.ThisCurrentQuotaInput = window.CurrentUserInputExperienceAddOns.data_input;
    }
    else
    {
        window.ThisCurrentQuotaInput = parseInt(window.RoomQuotaNonTop);
    }

    let WhichRoomDataToUsed = window.ThisRoomData;

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker ResponsiveMobilePanel";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel FlexPanelOnlyForMobile";
    FlexFullDisplayPanel.style.padding = "0px";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    BasicBlackBlocker.OnResponsiveRemove = function()
    {
        if(functiontocallonclose != null && isdirect == true)
            functiontocallonclose();
    };

    /* ==================== HEADER ==================== */
    let HeaderContainer = document.createElement("div");
    HeaderContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow";
    FlexFullDisplayPanel.append(HeaderContainer);

    let HeaderRow = document.createElement("div");
    HeaderRow.className = "ColumnGapExtraLong";
    HeaderRow.style.flex = "1 1 0%";
    HeaderRow.style.height = "fit-content";
    HeaderRow.style.display = "flex";
    HeaderRow.style.position = "relative";
    HeaderContainer.append(HeaderRow);

    let BackButton = document.createElement("img");
    BackButton.src = "/Assets/images/ButtonIcon/chevron.svg";
    BackButton.className = "BasicInputFieldChevronIconSearch Selectable2";
    BackButton.style.margin = "auto 0";
    BackButton.style.rotate = "90deg";
    HeaderRow.append(BackButton);

    let HeaderTitle = document.createElement("p");
    HeaderTitle.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    HeaderTitle.style.margin = "auto 0";
    HeaderTitle.innerHTML = window["ChangeRoomAmountTxt" + window.CurrentCountryID];
    HeaderRow.append(HeaderTitle);

    let CloseButton = document.createElement("img");
    CloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.style.position = "absolute";
    CloseButton.style.right = "0px";
    CloseButton.style.top = "50%";
    CloseButton.style.transform = "translateY(-50%)";
    HeaderRow.append(CloseButton);


    /* ==================== CONTENT ==================== */
    let ContentWrapper = document.createElement("div");
    ContentWrapper.className = "TopBottomHeaderButtonPaddingContainer PingExprezyViewMoreContainer RowGapBasic2";
    ContentWrapper.style.width = "auto";
    ContentWrapper.style.flexDirection = "column";
    FlexFullDisplayPanel.append(ContentWrapper);

    let HotelInfoWrapper = document.createElement("div");
    HotelInfoWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
    ContentWrapper.append(HotelInfoWrapper);

    let HoverContainer = document.createElement("div");
    HoverContainer.className = "HoverableContentInsideInputField";
    HoverContainer.style.flexDirection = "column";
    HotelInfoWrapper.append(HoverContainer);


    /* ==================== JUMLAH KAMAR ==================== */
    let RoomSection = document.createElement("div");
    RoomSection.className = "BasicPadding AddOnsExperienceChoices NoPaddingLeftRight";
    RoomSection.style.backgroundColor = "transparent";
    RoomSection.style.display = "flex";
    RoomSection.setAttribute("room-quota", window.ThisCurrentQuotaInput);
    HoverContainer.append(RoomSection);

    let RoomIcon = document.createElement("img");
    RoomIcon.className = "BasicIconInsideInput";
    RoomIcon.src = "/Assets/images/ButtonIcon/room-icon-2-black.svg";
    RoomIcon.style.marginLeft = "0";
    RoomSection.append(RoomIcon);

    let RoomTextWrapper = document.createElement("div");
    RoomTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    RoomTextWrapper.style.flexDirection = "row";
    RoomSection.append(RoomTextWrapper);

    let RoomTitle = document.createElement("p");
    RoomTitle.className = "BasicInputTextTop InterBoldTextFont";
    RoomTitle.style.margin = "auto 0";
    RoomTitle.innerHTML = window["RoomAmountTxt" + window.CurrentCountryID];
    RoomTextWrapper.append(RoomTitle);

    let RoomInputContainer = document.createElement("div");
    RoomInputContainer.className = "RoomButtonAndInputContainer";
    RoomTextWrapper.append(RoomInputContainer);

    let RoomReduce = document.createElement("img");
    RoomReduce.className = "IncreaseReduceRoomButton Selectable2 ButtonUnselectableOpacity";
    RoomReduce.src = "/Assets/images/ButtonIcon/reduce-circle-button.svg";
    RoomInputContainer.append(RoomReduce);

    let RoomInputWrapper = document.createElement("div");
    RoomInputWrapper.className = "SmallPanelDropDownContainer Selectable3";
    RoomInputContainer.append(RoomInputWrapper);

    let RoomInput = document.createElement("input");
    RoomInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    RoomInput.type = "number";
    RoomInput.placeholder = "0";
    RoomInput.value = window.ThisCurrentQuotaInput;
    RoomInputWrapper.append(RoomInput);

    let RoomIncrease = document.createElement("img");
    RoomIncrease.className = "IncreaseReduceRoomButton Selectable2";
    RoomIncrease.src = "/Assets/images/ButtonIcon/increase-circle-button.svg";
    RoomInputContainer.append(RoomIncrease);


    /* ==================== SAVE BUTTON ==================== */
    let SaveWrapper = document.createElement("div");
    SaveWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    SaveWrapper.style.marginBottom = "0";
    ContentWrapper.append(SaveWrapper);

    let SaveButton = document.createElement("button");
    SaveButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SaveButton.style.margin = "0";
    SaveButton.style.width = "100%";
    SaveWrapper.append(SaveButton);


    let SaveText = document.createElement("p");
    SaveText.className = "LabelGreyHeaderText";
    SaveText.style.cssText = "color:white; margin:auto;";
    SaveText.innerHTML = window["SavedButtonTxt" + window.CurrentCountryID];
    SaveButton.append(SaveText);

    
    // Check If It is Per Night or Item --------------------------------------------------------------

    if(whichtype == "Experiences")
    {
        HeaderTitle.innerHTML = window["ChangeItemAmountTxt" + window.CurrentCountryID];
        RoomTitle.innerHTML = window["UbahJumlahTamuTxt" + window.CurrentCountryID];
        // HeaderTitle.innerHTML = window["ChangeItemAmountTxt" + window.CurrentCountryID];
        // RoomTitle.innerHTML = window["ItemAmountTxt" + window.CurrentCountryID];
        RoomIcon.src = "/Assets/images/ButtonIcon/three-people-black.svg";
    }

    // if(WhichRoomDataToUsed.book_type == "per day") // Select Date Only one day at a time
    // {
    //     HeaderTitle.innerHTML = window["ChangeItemAmountTxt" + window.CurrentCountryID];
    //     RoomTitle.innerHTML = window["ItemAmountTxt" + window.CurrentCountryID];
    // }

    /* ==================== SET FUNCTION ==================== */

    let ClosePanelFunction = function(isjustclose)
    {
        if(functiontocallonsave != null && isjustclose == false) // If Just Close Then don't call any function assigned
            functiontocallonsave();
        
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    
    let CloseWithoutSavingFunction = function()
    {
        // window.ThisCurrentQuotaInput = window.MobileQuotaToChange;
        if(functiontocallonclose != null)
            functiontocallonclose();

        ClosePanelFunction(true);
    }

    SaveButton.onclick = function()
    {
        ClosePanelFunction(false);
    }

    BackButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    CloseButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    if(isdirect == true)
    {
        BackButton.style.display = "none";
    }
    else
    {
        CloseButton.style.display = "none";
    }

    let OnChangeQuotaFunction = function()
    {
        window.OnChangeCurrentQuotaInput(RoomSection, RoomInput, null, RoomReduce, null);
    }

    RoomReduce.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();

        window.ThisCurrentQuotaInput = window.ThisCurrentQuotaInput - 1;
        OnChangeQuotaFunction();
    }
    RoomIncrease.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();

        window.ThisCurrentQuotaInput = window.ThisCurrentQuotaInput + 1;
        OnChangeQuotaFunction();
    }

    RoomInput.addEventListener("focusout", (event) =>
    {
        window.ThisCurrentQuotaInput = RoomInput.value;
        OnChangeQuotaFunction();
    });

    window.OnChangeCurrentQuotaInput(RoomSection, RoomInput, null, RoomReduce, null);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}


// ======================================================= PILIH JENIS EXPERIENCE =======================================================

window.CurrentChoiceDataJenisExperience = null; // Experience Choice 
window.CurrentChoiceExperienceAddOns = null; // Experience Current Option Choices
window.CurrentUserInputExperienceAddOns = null; // Current User Input Experience Option Choice


window.InstantiateJenisExperienceOptionResponsive = function(functiontocall, functiontocallonclose, isallowrefreshexperiencedata, isdirect)
{
    if(window.ResponsivePanelMediaQuery.matches)
    {
        window.InstantiateJenisExperienceOptionMobile(functiontocall, functiontocallonclose, isallowrefreshexperiencedata, isdirect);
    }
    else
    {
        window.InstantiateJenisExperienceOptionDesktop(functiontocall, functiontocallonclose, isallowrefreshexperiencedata, isdirect);
    }
};


window.InstantiateJenisExperienceOptionMobile = function(functiontocall, functiontocallonclose, isallowrefreshexperiencedata, isdirect)
{
    console.log("CALLED window.InstantiateJenisExperienceOptionMobile");
    
    let ThisCheckInDateArray = window.CheckInDateNonTop.split("-");
    let ThisCheckOutDateArray = window.CheckOutDateNonTop.split("-");
    window.CurrentChoiceDataJenisExperience = null;

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker ResponsiveMobilePanel";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel FlexPanelOnlyForMobile";
    FlexFullDisplayPanel.style.padding = "0px";
    BasicBlackBlocker.append(FlexFullDisplayPanel);
    
    // Header -----------------------------------------------------------------------
    let TopBottomHeaderButtonPaddingContainer = document.createElement("div");
    TopBottomHeaderButtonPaddingContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow";
    TopBottomHeaderButtonPaddingContainer.style.backgroundColor = "white";
    FlexFullDisplayPanel.append(TopBottomHeaderButtonPaddingContainer);

    let ColumnGapExtraLong = document.createElement("div");
    ColumnGapExtraLong.className = "ColumnGapExtraLong";
    ColumnGapExtraLong.style.flex = "1 1 0%";
    ColumnGapExtraLong.style.height = "fit-content";
    ColumnGapExtraLong.style.display = "flex";
    ColumnGapExtraLong.style.position = "relative";
    TopBottomHeaderButtonPaddingContainer.append(ColumnGapExtraLong);

    let BackButton = document.createElement("img");
    BackButton.src = "/Assets/images/ButtonIcon/chevron.svg";
    BackButton.className = "BasicInputFieldChevronIconSearch Selectable2";
    BackButton.style.margin = "auto 0";
    BackButton.style.rotate = "90deg";
    ColumnGapExtraLong.append(BackButton);

    let HeaderText = document.createElement("p");
    HeaderText.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    HeaderText.style.margin = "auto 0";
    HeaderText.innerText = window["ChooseExperienceTypeTxt" + window.CurrentCountryID];
    ColumnGapExtraLong.append(HeaderText);

    let CloseButton = document.createElement("img");
    CloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.style.position = "absolute";
    CloseButton.style.right = "0px";
    CloseButton.style.top = "50%";
    CloseButton.style.transform = "translateY(-50%)";
    ColumnGapExtraLong.append(CloseButton);


    // Main Content -----------------------------------------------------------------------
    let FlexContainerBaseAnimate = document.createElement("div");
    FlexContainerBaseAnimate.className = "TopBottomHeaderButtonPaddingContainer PingExprezyViewMoreContainer RowGapBasic2";
    FlexContainerBaseAnimate.style.width = "auto";
    FlexContainerBaseAnimate.style.flexDirection = "column";
    FlexFullDisplayPanel.append(FlexContainerBaseAnimate);

    let HotelDetailsHotelInformationMarginWrapper2 = document.createElement("div");
    HotelDetailsHotelInformationMarginWrapper2.className = "HotelDetailsHotelInformationMarginWrapper2";
    FlexContainerBaseAnimate.append(HotelDetailsHotelInformationMarginWrapper2);

    
    // Top Warning -----------------------------------------------------------------------------------------------
    let ContainerWarningBookingAtLeast = document.createElement("div"); // Top Warning Text ------------------------------------
    ContainerWarningBookingAtLeast.className = "ContainerWithIconAndText BasicRadius InputFieldMargin3";
    ContainerWarningBookingAtLeast.style.backgroundColor = "#FFFAEB";
    ContainerWarningBookingAtLeast.style.flexDirection = "column";
    ContainerWarningBookingAtLeast.style.display = "none";
    HotelDetailsHotelInformationMarginWrapper2.append(ContainerWarningBookingAtLeast);

    let WarningBookingHeaderText = document.createElement("p");
    WarningBookingHeaderText.className = "LabelGreyHeaderSmallerText2 InterBoldTextFont InputFieldMargin3";
    WarningBookingHeaderText.innerHTML = window["KebijakanReservasiTxt" + window.CurrentCountryID];
    ContainerWarningBookingAtLeast.append(WarningBookingHeaderText);

    let WarningBookingAtLeastText = document.createElement("p"); 
    WarningBookingAtLeastText.className = "LabelGreyHeaderSmallerText2 InterMediumTextFont";
    WarningBookingAtLeastText.style.margin = "auto 0";
    WarningBookingAtLeastText.style.lineHeight = "none";
    WarningBookingAtLeastText.style.color = "#344054";
    ContainerWarningBookingAtLeast.append(WarningBookingAtLeastText);


    // Date section
    let HoverableContentInsideInputField = document.createElement("div");
    HoverableContentInsideInputField.className = "HoverableContentInsideInputField Unselectable";
    HoverableContentInsideInputField.id = "JenisExperienceDateCheckIn";
    HoverableContentInsideInputField.setAttribute("date", ThisCheckInDateArray[2]);
    HoverableContentInsideInputField.setAttribute("month", ThisCheckInDateArray[1]);
    HoverableContentInsideInputField.setAttribute("year", ThisCheckInDateArray[0]);
    HotelDetailsHotelInformationMarginWrapper2.append(HoverableContentInsideInputField);

    let DateSectionWrapper = document.createElement("div");
    DateSectionWrapper.className = "SearchTopNonIndexSection BasicInputFieldContainer Selectable3 NoPaddingLeftRight";
    DateSectionWrapper.style.backgroundColor = "transparent";
    HoverableContentInsideInputField.append(DateSectionWrapper);

    let CalendarIcon = document.createElement("img");
    CalendarIcon.className = "BasicIconInsideInput";
    CalendarIcon.src = "/Assets/images/ButtonIcon/calendar-black.svg";
    CalendarIcon.style.marginLeft = "0";
    DateSectionWrapper.append(CalendarIcon);

    let SearchInputFieldTopBottomTextWrapper = document.createElement("div");
    SearchInputFieldTopBottomTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    DateSectionWrapper.append(SearchInputFieldTopBottomTextWrapper);

    let CheckInOutText = document.createElement("p");
    CheckInOutText.className = "BasicInputTextTop InterBoldTextFont";
    CheckInOutText.style.marginTop = "0";
    CheckInOutText.innerText = window["DateOfVisitTxt" + window.CurrentCountryID];
    SearchInputFieldTopBottomTextWrapper.append(CheckInOutText);

    let CheckInOutDateText = document.createElement("p");
    CheckInOutDateText.className = "BasicInputTextBottom InterRegularTextFont";
    CheckInOutDateText.style.color = "#667085";
    CheckInOutDateText.innerText = "-- ---- ---- -  -- ---- ----";
    SearchInputFieldTopBottomTextWrapper.append(CheckInOutDateText);

    let CheckInOutChevron = document.createElement("img");
    CheckInOutChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    CheckInOutChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow";
    CheckInOutChevron.id = "JenisExpeienceDateInputChevron";
    CheckInOutChevron.style.rotate = "-90deg";
    DateSectionWrapper.append(CheckInOutChevron);
    
    let DateCheckOutHide = document.createElement("div");
    DateCheckOutHide.id = "JenisExperienceDateCheckOut";
    DateCheckOutHide.style.display = "none";
    DateCheckOutHide.setAttribute("date", ThisCheckOutDateArray[2]);
    DateCheckOutHide.setAttribute("month", ThisCheckOutDateArray[1]);
    DateCheckOutHide.setAttribute("year", ThisCheckOutDateArray[0]);
    HotelDetailsHotelInformationMarginWrapper2.append(DateCheckOutHide);

    // Experience section
    let ExperienceHoverableContent = document.createElement("div");
    ExperienceHoverableContent.className = "HoverableContentInsideInputField Unselectable";
    HotelDetailsHotelInformationMarginWrapper2.append(ExperienceHoverableContent);

    let ExperienceSearchSection = document.createElement("div");
    ExperienceSearchSection.className = "SearchTopNonIndexSection BasicInputFieldContainer Selectable3 NoPaddingLeftRight";
    ExperienceSearchSection.style.backgroundColor = "transparent";
    ExperienceHoverableContent.append(ExperienceSearchSection);

    let ExperienceIcon = document.createElement("img");
    ExperienceIcon.className = "BasicIconInsideInput";
    ExperienceIcon.src = "/Assets/images/ButtonIcon/black-outline-star.svg";
    ExperienceIcon.style.marginLeft = "0";
    ExperienceSearchSection.append(ExperienceIcon);

    let ExperienceTextWrapper = document.createElement("div");
    ExperienceTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    ExperienceSearchSection.append(ExperienceTextWrapper);

    let ExperienceTitle = document.createElement("p");
    ExperienceTitle.className = "BasicInputTextTop InterBoldTextFont";
    ExperienceTitle.style.marginTop = "0";
    ExperienceTitle.innerText = window["TipeExperienceTxt" + window.CurrentCountryID];
    ExperienceTextWrapper.append(ExperienceTitle);

    let ExperienceName = document.createElement("p");
    ExperienceName.className = "BasicInputTextBottom InterRegularTextFont";
    ExperienceName.style.color = "#667085";
    ExperienceName.innerText = "----- --------";
    ExperienceTextWrapper.append(ExperienceName);

    let ExperienceChevron = document.createElement("img");
    ExperienceChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    ExperienceChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow";
    ExperienceChevron.style.rotate = "-90deg";
    ExperienceSearchSection.append(ExperienceChevron);


    let GuestHoverableContent = document.createElement("div");
    GuestHoverableContent.className = "HoverableContentInsideInputField";
    GuestHoverableContent.style.flexDirection = "column";
    HotelDetailsHotelInformationMarginWrapper2.append(GuestHoverableContent);

    // Save button ------------------------------------------------------------
    let SaveButtonWrapper = document.createElement("div");
    SaveButtonWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    SaveButtonWrapper.style.marginBottom = "0";
    FlexContainerBaseAnimate.append(SaveButtonWrapper);

    let SaveButton = document.createElement("button");
    SaveButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SaveButton.style.margin = "0";
    SaveButton.style.width = "100%";
    SaveButton.innerText = window["SavedButtonTxt" + window.CurrentCountryID];
    SaveButtonWrapper.append(SaveButton);

    // ============================= FUNCTION ===================================

    let ClosePanelFunction = function(isjustclose)
    {
        if(functiontocall != null && isjustclose == false) // If Just Close Then don't call any function assigned
            functiontocall();
        
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    
    let CloseWithoutSavingFunction = function()
    {
        // window.CurrentSelectedRoomTypeIDToChange = window.MobileRoomTypeIDToChange;

        // Re-Apply Previous Temp Data ------------------------------
        if(functiontocallonclose != null)
            functiontocallonclose();

        ClosePanelFunction(true);
    }

    let FunctionToCallOnUpdate = function(isreload)
    {
        let UpdatedCheckInDate = HoverableContentInsideInputField.getAttribute("date");
        let UpdatedCheckInMonth = HoverableContentInsideInputField.getAttribute("month");
        let UpdatedCheckInYear = HoverableContentInsideInputField.getAttribute("year");
        let UpdatedCheckInFullDate = new Date(parseInt(UpdatedCheckInYear), parseInt(UpdatedCheckInMonth) - 1, parseInt(UpdatedCheckInDate));
        window.CheckInDateNonTop = UpdatedCheckInYear + "-" + UpdatedCheckInMonth.padStart(2, '0') + "-" + UpdatedCheckInDate.padStart(2, '0');

        window.CurrentSelectedDayEdit = UpdatedCheckInDate; // Current Selected Date (Individual)
        window.CurrentSelectedMonthEdit = UpdatedCheckInMonth;
        window.CurrentSelectedYearEdit = UpdatedCheckInYear;

        if(window.CurrentSelectedRoomExpBookType == "per day")
        {
            let GetFinalSelectedCheckOutDate = new Date(UpdatedCheckInYear, parseInt(UpdatedCheckInMonth) - 1, UpdatedCheckInDate);
            GetFinalSelectedCheckOutDate.setDate(GetFinalSelectedCheckOutDate.getDate() + 1);
            
            let NewCheckOutYear = GetFinalSelectedCheckOutDate.getFullYear();
            let NewCheckOutMonth = (GetFinalSelectedCheckOutDate.getMonth() + 1);
            let NewCheckOutDay = GetFinalSelectedCheckOutDate.getDate();

            DateCheckOutHide.setAttribute("date", NewCheckOutDay);
            DateCheckOutHide.setAttribute("month", NewCheckOutMonth);
            DateCheckOutHide.setAttribute("year", NewCheckOutYear);
        }

        let UpdatedCheckOutDate = DateCheckOutHide.getAttribute("date");
        let UpdatedCheckOutMonth = DateCheckOutHide.getAttribute("month");
        let UpdatedCheckOutYear = DateCheckOutHide.getAttribute("year");
        let UpdatedCheckOutFullDate = new Date(parseInt(UpdatedCheckOutYear), parseInt(UpdatedCheckOutMonth) - 1, parseInt(UpdatedCheckOutDate));
        window.CheckOutDateNonTop = UpdatedCheckOutYear + "-" + UpdatedCheckOutMonth.padStart(2, '0') + "-" + UpdatedCheckOutDate.padStart(2, '0');

        if(window.CurrentChoiceDataJenisExperience != null)
        {
            for(let i = 0; i < window.CurrentChoiceDataJenisExperience.length; i++)
            {
                if(window.CurrentChoiceDataJenisExperience[i].id == window.CurrentSelectedRoomID)
                    window.ThisRoomData = window.CurrentChoiceDataJenisExperience[i];
            }
        }

        console.log("UPDATING................");
        console.log("LatestUpdate",
            {
                "window.CurrentSelectedRoomID":window.CurrentSelectedRoomID,
                "window.CurrentSelectedRoomExpBookType":window.CurrentSelectedRoomExpBookType,
                "window.CurrentSelectedAccFacilitiesType":window.CurrentSelectedAccFacilitiesType,
                "window.ThisRoomData":window.ThisRoomData,
                "UpdatedCheckInFullDate":UpdatedCheckInFullDate,
                "UpdatedCheckOutFullDate":UpdatedCheckOutFullDate,
                "window.CheckInDateNonTop": window.CheckInDateNonTop,
                "window.CheckOutDateNonTop": window.CheckOutDateNonTop,
                "window.CurrentSelectedYearEdit": window.CurrentSelectedYearEdit,
                "window.CurrentSelectedMonthEdit": window.CurrentSelectedMonthEdit,
                "window.CurrentSelectedDayEdit": window.CurrentSelectedDayEdit,
                "window.CurrentUserInputExperienceAddOns": window.CurrentUserInputExperienceAddOns
            }
        )
        
        if(window.ThisRoomData.book_type == "per day")
        {
            CheckInOutDateText.innerHTML = window["weekdayFull" + window.CurrentCountryID][(UpdatedCheckInFullDate.getDay())] + " " + UpdatedCheckInDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(UpdatedCheckInMonth) - 1] + " " + UpdatedCheckInFullDate.getFullYear();
        }
        else
        {
            CheckInOutDateText.innerHTML = window.DisplayFinalCheckInOutDat(UpdatedCheckInFullDate, UpdatedCheckOutFullDate, true, false);
        }

        for(let i = 0; i < window.CurrentLoadedExperience.length; i++)
        {
            if(window.CurrentLoadedExperience[i].id == window.CurrentSelectedRoomID)
            {
                ExperienceName.innerHTML = window.CurrentLoadedExperience[i]["name_" + window.CurrentCountryID];

                if(window.CurrentLoadedExperience[i].min_booking_notice_days > 0)
                {
                    ContainerWarningBookingAtLeast.style.display = "flex";
                    WarningBookingAtLeastText.innerHTML = window.MinRangeTextRight(window.CurrentLoadedExperience[i].min_booking_notice_days);
                }
                else
                {
                    ContainerWarningBookingAtLeast.style.display = "none";
                }
            }
        }

        if(isreload == true) // If Require Reload Reload All ----------------------------------------------------
        {
            let ThisLoading = window.InstantiateLoadingCircle(FlexContainerBaseAnimate, true);
            ThisLoading.style.zIndex = 1;

            window.LoadTipeExperienceBefore(UpdatedCheckInFullDate, UpdatedCheckOutFullDate, isallowrefreshexperiencedata, ()=>
            {
                window.InstantiateDropDownExperienceOptions(GuestHoverableContent, ()=>
                {
                    FunctionToCallOnUpdate(false);
                }, true);
                
                ThisLoading.remove();
            });
        }
        else
        {
            CheckAllExperienceInputted(SaveButton);
        }
    }


    BasicBlackBlocker.OnResponsiveRemove = function()
    {
        CloseWithoutSavingFunction();
    };
        
    SaveButton.onclick = function()
    {
        ClosePanelFunction(false);
    }

    BackButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    CloseButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    DateSectionWrapper.onclick = function()
    {
        let PrevData = window.CreateHotelDetailsSnapshot();
        
        let isallowmorethanone = true;
        if(window.ThisRoomData.book_type == "per day")
            isallowmorethanone = false;

        window.InstantiateDateChoiceMobilePanel(()=>
        {
            let NewCheckInYear;
            let NewCheckInMonth;
            let NewCheckInDay;

            let NewCheckOutYear;
            let NewCheckOutMonth;
            let NewCheckOutDay;

            if(window.ThisRoomData.book_type == "per night")
            {
                let NewUpdateCheckInDateInfo = window.CurrentSelectedCheckIn;

                NewCheckInYear = NewUpdateCheckInDateInfo.getFullYear();
                NewCheckInMonth = (NewUpdateCheckInDateInfo.getMonth() + 1);
                NewCheckInDay = NewUpdateCheckInDateInfo.getDate();

                let NewUpdateCheckOutDateInfo = window.CurrentSelectedCheckOut;

                NewCheckOutYear = NewUpdateCheckOutDateInfo.getFullYear();
                NewCheckOutMonth = (NewUpdateCheckOutDateInfo.getMonth() + 1);
                NewCheckOutDay = NewUpdateCheckOutDateInfo.getDate();
            }
            else
            {
                NewCheckInYear = window.CurrentSelectedYearEdit;
                NewCheckInMonth = window.CurrentSelectedMonthEdit;
                NewCheckInDay = window.CurrentSelectedDayEdit;

                let CurrentCheckOutDate = new Date(NewCheckInYear, NewCheckInMonth-1, NewCheckInDay);
                CurrentCheckOutDate.setDate(CurrentCheckOutDate.getDate() + 1);

                NewCheckOutYear = CurrentCheckOutDate.getFullYear();
                NewCheckOutMonth = (CurrentCheckOutDate.getMonth() + 1);
                NewCheckOutDay = CurrentCheckOutDate.getDate();
            }

            HoverableContentInsideInputField.setAttribute("Date", NewCheckInDay);
            HoverableContentInsideInputField.setAttribute("Month", NewCheckInMonth);
            HoverableContentInsideInputField.setAttribute("Year", NewCheckInYear);

            DateCheckOutHide.setAttribute("Date", NewCheckOutDay);
            DateCheckOutHide.setAttribute("Month", NewCheckOutMonth);
            DateCheckOutHide.setAttribute("Year", NewCheckOutYear);

            
            window.CheckInDateNonTop = NewCheckInYear + "-" + NewCheckInMonth + "-" + NewCheckInDay;
            window.CheckOutDateNonTop = NewCheckOutYear + "-" + NewCheckOutMonth + "-" + NewCheckOutDay;

            FunctionToCallOnUpdate(true);

        },
        ()=>
        {
            window.RestoreHotelDetailsSnapshot (PrevData);

            FunctionToCallOnUpdate(false);
            
        }, true, isallowmorethanone);
    }
    
    ExperienceSearchSection.onclick = function()
    {
        let PrevData = window.CreateHotelDetailsSnapshot();
        PrevData.PreviousRoomOrBookCategory = "Experiences";

        window.InstantiateMobileRoomExperienceTypeScrollChoice(
        ()=>FunctionToCallOnUpdate(true),
        ()=>
        {
            window.RestoreHotelDetailsSnapshot (PrevData);
        },
        false);
    }

    // Call Function =================================================
    
    if(isdirect == true)
    {
        BackButton.style.display = "none";
    }
    else
    {
        CloseButton.style.display = "none";
    }

    FunctionToCallOnUpdate(true);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);

    return BasicBlackBlocker;
}

window.InstantiateJenisExperienceOptionDesktop = function(functiontocall, functiontocallonclose, isallowrefreshexperiencedata, isdirect)
{
    console.log("CALLING window.InstantiateJenisExperienceOptionDesktop");

    let ThisCheckInDateArray = window.CheckInDateNonTop.split("-");
    let ThisCheckOutDateArray = window.CheckOutDateNonTop.split("-");
    window.CurrentChoiceDataJenisExperience = null;

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker ResponsiveDesktopPanel";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    FlexFullDisplayPanel.style.padding = "0";
    FlexFullDisplayPanel.style.overflow = "visible";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    let FlexContainerBaseAnimate = document.createElement("div");
    FlexContainerBaseAnimate.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    FlexContainerBaseAnimate.style.maxHeight = "none";
    FlexContainerBaseAnimate.style.overflow = "visible";
    FlexFullDisplayPanel.append(FlexContainerBaseAnimate);

    // Header
    let TopBottomHeaderButtonPaddingContainer = document.createElement("div");
    TopBottomHeaderButtonPaddingContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow BasicRadius NoBottomRadius";
    TopBottomHeaderButtonPaddingContainer.style.backgroundColor = "#2494D9";
    FlexContainerBaseAnimate.append(TopBottomHeaderButtonPaddingContainer);

    let HeaderInnerContainer = document.createElement("div");
    HeaderInnerContainer.className = "ColumnGapExtraLong";
    HeaderInnerContainer.style.flex = "1 1 0%";
    HeaderInnerContainer.style.height = "fit-content";
    HeaderInnerContainer.style.display = "flex";
    HeaderInnerContainer.style.position = "relative";
    TopBottomHeaderButtonPaddingContainer.append(HeaderInnerContainer);

    
    let BackButton = document.createElement("img");
    BackButton.src = "/Assets/images/ButtonIcon/chevron-white.svg";
    BackButton.className = "BasicInputFieldChevronIconSearch Selectable2";
    BackButton.style.margin = "auto 0";
    BackButton.style.rotate = "90deg";
    HeaderInnerContainer.append(BackButton);

    let HeaderText = document.createElement("p");
    HeaderText.className = "LabelGreyHeaderText MarginTextUpDown InterBoldTextFont";
    HeaderText.style.margin = "auto 0";
    HeaderText.style.color = "#FFFFFF";
    HeaderText.innerText = window["ChooseExperienceTypeTxt" + window.CurrentCountryID];
    HeaderInnerContainer.append(HeaderText);

    let CloseButton = document.createElement("img");
    CloseButton.src = "/Assets/images/ButtonIcon/x-close.svg";
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.style.position = "absolute";
    CloseButton.style.right = "0";
    CloseButton.style.top = "50%";
    CloseButton.style.transform = "translateY(-50%)";
    HeaderInnerContainer.append(CloseButton);


    // Main content
    let MainFlexContainer = document.createElement("div");
    MainFlexContainer.className = "FlexContainerBaseAnimate RowGapBasic2";
    MainFlexContainer.style.width = "100%";
    MainFlexContainer.style.position = "relative";
    FlexContainerBaseAnimate.append(MainFlexContainer);

    let MainPaddingContainer = document.createElement("div");
    MainPaddingContainer.className = "TopBottomHeaderButtonPaddingContainer";
    MainPaddingContainer.style.flexDirection = "column";
    MainFlexContainer.append(MainPaddingContainer);

    let HotelDetailsWrapper = document.createElement("div");
    HotelDetailsWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
    MainPaddingContainer.append(HotelDetailsWrapper);


    let ContainerWarningBookingAtLeast = document.createElement("div"); // Top Warning Text ------------------------------------
    ContainerWarningBookingAtLeast.className = "ContainerWithIconAndText BasicRadius InputFieldMargin3";
    ContainerWarningBookingAtLeast.style.backgroundColor = "#FFFAEB";
    ContainerWarningBookingAtLeast.style.flexDirection = "column";
    ContainerWarningBookingAtLeast.style.display = "none";
    HotelDetailsWrapper.append(ContainerWarningBookingAtLeast);

    let WarningBookingHeaderText = document.createElement("p");
    WarningBookingHeaderText.className = "LabelGreyHeaderSmallerText2 InterBoldTextFont InputFieldMargin3";
    WarningBookingHeaderText.innerHTML = window["KebijakanReservasiTxt" + window.CurrentCountryID];
    ContainerWarningBookingAtLeast.append(WarningBookingHeaderText);

    let WarningBookingAtLeastText = document.createElement("p"); 
    WarningBookingAtLeastText.className = "LabelGreyHeaderSmallerText2 InterMediumTextFont";
    WarningBookingAtLeastText.style.margin = "auto 0";
    WarningBookingAtLeastText.style.lineHeight = "none";
    WarningBookingAtLeastText.style.color = "#344054";
    ContainerWarningBookingAtLeast.append(WarningBookingAtLeastText);

    // Date section
    let DateInputContainer = document.createElement("div");
    DateInputContainer.className = "SearchTopNonIndexSection BasicInputFieldContainer SmallMarginList NoPaddingLeftRight";
    DateInputContainer.style.backgroundColor = "transparent";
    HotelDetailsWrapper.append(DateInputContainer);

    let DateIcon = document.createElement("img");
    DateIcon.className = "BasicIconInsideInput2";
    DateIcon.src = "/Assets/images/ButtonIcon/calendar-black.svg";
    DateIcon.style.marginLeft = "0";
    DateInputContainer.append(DateIcon);

    let DateTextWrapper = document.createElement("div");
    DateTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    DateInputContainer.append(DateTextWrapper);

    let DateTitle = document.createElement("p");
    DateTitle.className = "BasicInputTextTop InterBoldTextFont";
    DateTitle.style.marginTop = "0";
    DateTitle.innerText = window["DateOfVisitTxt" + window.CurrentCountryID];
    DateTextWrapper.append(DateTitle);

    let DateWhereToInstantiate = document.createElement("div");
    DateWhereToInstantiate.id = "JenisExperienceDateCheckIn";
    DateWhereToInstantiate.style.position = "relative";
    DateWhereToInstantiate.style.display = "flex";
    DateWhereToInstantiate.setAttribute("date", ThisCheckInDateArray[2]);
    DateWhereToInstantiate.setAttribute("month", ThisCheckInDateArray[1]);
    DateWhereToInstantiate.setAttribute("year", ThisCheckInDateArray[0]);
    DateInputContainer.append(DateWhereToInstantiate);

    let DateRightContainer = document.createElement("div");
    DateRightContainer.className = "ColumnGapLong Selectable2";
    DateRightContainer.style.display = "flex";
    DateWhereToInstantiate.append(DateRightContainer);

    let DateText = document.createElement("p");
    DateText.className = "BasicInputTextTop InterRegularTextFont";
    DateText.style.color = "#667085";
    DateText.innerText = "-- ---- ---- -  -- ---- ----";
    DateRightContainer.append(DateText);

    let DateChevron = document.createElement("img");
    DateChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    DateChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow";
    DateChevron.id = "JenisExpeienceDateInputChevron";
    DateChevron.style.rotate = "0deg";
    DateRightContainer.append(DateChevron);

    let DateCheckOutHide = document.createElement("div");
    DateCheckOutHide.id = "JenisExperienceDateCheckOut";
    DateCheckOutHide.style.display = "none";
    DateCheckOutHide.setAttribute("date", ThisCheckOutDateArray[2]);
    DateCheckOutHide.setAttribute("month", ThisCheckOutDateArray[1]);
    DateCheckOutHide.setAttribute("year", ThisCheckOutDateArray[0]);
    DateInputContainer.append(DateCheckOutHide);


    // Experience section -------------------------------------------
    let ExperienceHoverableContainer = document.createElement("div");
    ExperienceHoverableContainer.className = "HoverableContentInsideInputField";
    ExperienceHoverableContainer.style.flexDirection = "column";
    HotelDetailsWrapper.append(ExperienceHoverableContainer);

    let ExperienceTypeContainer = document.createElement("div");
    ExperienceTypeContainer.className = "SearchTopNonIndexSection NoPaddingLeftRight";
    ExperienceTypeContainer.style.backgroundColor = "transparent";
    ExperienceHoverableContainer.append(ExperienceTypeContainer);

    let ExperienceIcon = document.createElement("img");
    ExperienceIcon.className = "BasicIconInsideInput2";
    ExperienceIcon.src = "/Assets/images/ButtonIcon/black-outline-star.svg";
    ExperienceIcon.style.marginLeft = "0";
    ExperienceTypeContainer.append(ExperienceIcon);

    let ExperienceTextWrapper = document.createElement("div");
    ExperienceTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    ExperienceTypeContainer.append(ExperienceTextWrapper);

    let ExperienceTitle = document.createElement("p");
    ExperienceTitle.className = "BasicInputTextTop InterExBoldTextFont";
    ExperienceTitle.style.marginTop = "0";
    ExperienceTitle.innerText = window["TipeExperienceTxt" + window.CurrentCountryID];
    ExperienceTextWrapper.append(ExperienceTitle);

    let ExperienceRightContainer = document.createElement("div");
    ExperienceRightContainer.style.position = "relative";
    ExperienceRightContainer.style.display = "flex";
    ExperienceRightContainer.style.flexDirection = "column";
    ExperienceTypeContainer.append(ExperienceRightContainer);

    let SelectedExperienceContainer = document.createElement("div");
    SelectedExperienceContainer.className = "ColumnGapLong Selectable2";
    SelectedExperienceContainer.style.display = "flex";
    ExperienceRightContainer.append(SelectedExperienceContainer);

    let SelectedExperienceText = document.createElement("p");
    SelectedExperienceText.className = "BasicInputTextTop InterExBoldTextFont";
    SelectedExperienceText.style.color = "#1D2939";
    SelectedExperienceText.innerText = "----- --------";
    SelectedExperienceContainer.append(SelectedExperienceText);

    let ExperienceChevron = document.createElement("img");
    ExperienceChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    ExperienceChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow";
    ExperienceChevron.style.rotate = "0deg";
    SelectedExperienceContainer.append(ExperienceChevron);


    // Experience Option section -----------------------------------------------
    let ExperienceOptionHoverableContainer = document.createElement("div");
    ExperienceOptionHoverableContainer.className = "HoverableContentInsideInputField";
    ExperienceOptionHoverableContainer.style.flexDirection = "column";
    ExperienceOptionHoverableContainer.style.backgroundColor = "#FFFAF5";
    HotelDetailsWrapper.append(ExperienceOptionHoverableContainer);

    // Save button ------------------------------------------------------------
    let SaveWrapper = document.createElement("div");
    SaveWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    SaveWrapper.style.marginBottom = "0";
    MainPaddingContainer.append(SaveWrapper);

    let SaveButton = document.createElement("button");
    SaveButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SaveButton.style.margin = "0";
    SaveButton.style.width = "100%";
    SaveButton.innerText = window["SavedButtonTxt" + window.CurrentCountryID];
    SaveWrapper.append(SaveButton);


    // ============================= FUNCTION ===================================

    let ClosePanelFunction = function(isjustclose)
    {
        if(functiontocall != null && isjustclose == false) // If Just Close Then don't call any function assigned
            functiontocall();
        
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    
    let CloseWithoutSavingFunction = function()
    {
        // window.CurrentSelectedRoomTypeIDToChange = window.MobileRoomTypeIDToChange;

        // Re-Apply Previous Temp Data ------------------------------
        if(functiontocallonclose != null)
            functiontocallonclose();

        ClosePanelFunction(true);
    }

    let FunctionToCallOnUpdate = function(isreload)
    {
        let UpdatedCheckInDate = DateWhereToInstantiate.getAttribute("date");
        let UpdatedCheckInMonth = DateWhereToInstantiate.getAttribute("month");
        let UpdatedCheckInYear = DateWhereToInstantiate.getAttribute("year");
        let UpdatedCheckInFullDate = new Date(parseInt(UpdatedCheckInYear), parseInt(UpdatedCheckInMonth) - 1, parseInt(UpdatedCheckInDate));
        window.CheckInDateNonTop = UpdatedCheckInYear + "-" + UpdatedCheckInMonth.padStart(2, '0') + "-" + UpdatedCheckInDate.padStart(2, '0');


        window.CurrentSelectedDayEdit = UpdatedCheckInDate; // Current Selected Date (Individual)
        window.CurrentSelectedMonthEdit = UpdatedCheckInMonth;
        window.CurrentSelectedYearEdit = UpdatedCheckInYear;

        if(window.CurrentSelectedRoomExpBookType == "per day")
        {
            let GetFinalSelectedCheckOutDate = new Date(UpdatedCheckInYear, parseInt(UpdatedCheckInMonth) - 1, UpdatedCheckInDate);
            GetFinalSelectedCheckOutDate.setDate(GetFinalSelectedCheckOutDate.getDate() + 1);
            
            let NewCheckOutYear = GetFinalSelectedCheckOutDate.getFullYear();
            let NewCheckOutMonth = (GetFinalSelectedCheckOutDate.getMonth() + 1);
            let NewCheckOutDay = GetFinalSelectedCheckOutDate.getDate();

            DateCheckOutHide.setAttribute("date", NewCheckOutDay);
            DateCheckOutHide.setAttribute("month", NewCheckOutMonth);
            DateCheckOutHide.setAttribute("year", NewCheckOutYear);
        }

        let UpdatedCheckOutDate = DateCheckOutHide.getAttribute("date");
        let UpdatedCheckOutMonth = DateCheckOutHide.getAttribute("month");
        let UpdatedCheckOutYear = DateCheckOutHide.getAttribute("year");
        let UpdatedCheckOutFullDate = new Date(parseInt(UpdatedCheckOutYear), parseInt(UpdatedCheckOutMonth) - 1, parseInt(UpdatedCheckOutDate));
        window.CheckOutDateNonTop = UpdatedCheckOutYear + "-" + UpdatedCheckOutMonth.padStart(2, '0') + "-" + UpdatedCheckOutDate.padStart(2, '0');
        
        console.log("UPDATING................");
        console.log("LatestUpdate",
            {
                "window.CurrentSelectedRoomID":window.CurrentSelectedRoomID,
                "window.CurrentSelectedRoomExpBookType":window.CurrentSelectedRoomExpBookType,
                "window.CurrentSelectedAccFacilitiesType":window.CurrentSelectedAccFacilitiesType,
                "window.ThisRoomData":window.ThisRoomData,
                "UpdatedCheckInFullDate":UpdatedCheckInFullDate,
                "UpdatedCheckOutFullDate":UpdatedCheckOutFullDate,
                "window.CheckInDateNonTop": window.CheckInDateNonTop,
                "window.CheckOutDateNonTop": window.CheckOutDateNonTop,
                "window.CurrentSelectedYearEdit": window.CurrentSelectedYearEdit,
                "window.CurrentSelectedMonthEdit": window.CurrentSelectedMonthEdit,
                "window.CurrentSelectedDayEdit": window.CurrentSelectedDayEdit,
                "window.CurrentUserInputExperienceAddOns": window.CurrentUserInputExperienceAddOns
            }
        )

        if(window.ThisRoomData.book_type == "per day")
        {
            DateText.innerHTML = window["weekdayFull" + window.CurrentCountryID][(UpdatedCheckInFullDate.getDay())] + " " + UpdatedCheckInDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(UpdatedCheckInMonth) - 1] + " " + UpdatedCheckInFullDate.getFullYear();
        }
        else
        {
            DateText.innerHTML = window.DisplayFinalCheckInOutDat(UpdatedCheckInFullDate, UpdatedCheckOutFullDate, true, false);
        }

        console.log("window.CurrentLoadedExperience", window.CurrentLoadedExperience);

        for(let i = 0; i < window.CurrentLoadedExperience.length; i++)
        {
            if(window.CurrentLoadedExperience[i].id == window.CurrentSelectedRoomID)
            {
                SelectedExperienceText.innerHTML = window.CurrentLoadedExperience[i]["name_" + window.CurrentCountryID];

                if(window.CurrentLoadedExperience[i].min_booking_notice_days > 0)
                {
                    ContainerWarningBookingAtLeast.style.display = "flex";
                    WarningBookingAtLeastText.innerHTML = window.MinRangeTextRight(window.CurrentLoadedExperience[i].min_booking_notice_days);
                }
                else
                {
                    ContainerWarningBookingAtLeast.style.display = "none";
                }
            }
        }

        if(isreload == true) // If Require Reload Reload All ----------------------------------------------------
        {
            let ThisLoading = window.InstantiateLoadingCircle(MainFlexContainer, true);
            ThisLoading.style.zIndex = 1;

            window.LoadTipeExperienceBefore(UpdatedCheckInFullDate, UpdatedCheckOutFullDate, isallowrefreshexperiencedata, ()=>
            {
                window.InstantiateDropDownExperienceOptions(ExperienceOptionHoverableContainer, ()=>
                {
                    FunctionToCallOnUpdate(false);
                }, false);
                    
                ThisLoading.remove();  
            });
        }
        else
        {
            CheckAllExperienceInputted(SaveButton);
        }
    }
    

    BasicBlackBlocker.OnResponsiveRemove = function()
    {
        CloseWithoutSavingFunction();
    };
        
    SaveButton.onclick = function()
    {
        ClosePanelFunction(false);
    }

    BackButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    CloseButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    DateRightContainer.onclick = function()
    {
        let isallinonechoice = false;
        if(window.CurrentSelectedRoomExpBookType == "per night")
            isallinonechoice = true;

        window.OpenDateChoiceContainer('JenisExperienceDateCheckIn', 'JenisExperienceDateCheckOut', 'JenisExpeienceDateInputChevron', 'Start', '', 1, false, false, true, false, true, isallinonechoice, ()=>FunctionToCallOnUpdate(true));
    }
    
    SelectedExperienceContainer.onclick = function()
    {
        window.InstantiateDropDownPilihTipeExperience(ExperienceRightContainer, SelectedExperienceText, ()=>FunctionToCallOnUpdate(true));
    }

    // Call Function =================================================
    
    if(isdirect == true)
    {
        BackButton.style.display = "none";
    }
    else
    {
        CloseButton.style.display = "none";
    }

    FunctionToCallOnUpdate(true);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);

    return BasicBlackBlocker;
}

function CheckAllExperienceInputted(SaveButton)
{
    let IsCorrect = true;

    let ExperienceData = window.ThisRoomData;
    let DataInputted = window.CurrentUserInputExperienceAddOns.data_input;


    console.log("window.CurrentUserInputExperienceAddOns", window.CurrentUserInputExperienceAddOns);
    console.log("window.CurrentSelectedRoomID", window.CurrentSelectedRoomID);
    console.log("window.CurrentSelectedRoomExpBookType", window.CurrentSelectedRoomExpBookType);
    console.log("window.ThisRoomData", window.ThisRoomData);


    // =========================================================
    // EXPERIENCE ITSELF
    // =========================================================

    if(ExperienceData.status_available == "No")
    {
        IsCorrect = false;
    }


    // =========================================================
    // EXPERIENCE ITSELF
    // =========================================================

    const FirstDateArray = window.CheckInDateNonTop.split("-");
    const FirstDate = new Date(FirstDateArray[0], parseInt(FirstDateArray[1])-1, FirstDateArray[2]);
    const DateNow = window.GetAndConvertCurrentDate(false);

    const diffInMs = Math.abs(DateNow - FirstDate);
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    if (diffInDays < ExperienceData.min_booking_notice_days)
    {
        console.log("Error Here");
        IsCorrect = false;
    }


    // =========================================================
    // EXPERIENCE WITH OPTIONS
    // =========================================================

    if(Array.isArray(ExperienceData.options) && ExperienceData.options.length > 0)
    {
        let OptionsData = ExperienceData.options;

        let TotalQuotaInputted = 0;

        if(Array.isArray(DataInputted) == false)
        {
            console.log("Error Here");
            IsCorrect = false;
        }
        else
        {
            for(let i = 0; i < DataInputted.length; i++)
            {
                let InputOption = DataInputted[i];

                let MatchingOption = null;

                for(let j = 0; j < OptionsData.length; j++)
                {
                    if(OptionsData[j].id == InputOption.id && OptionsData[j].id_hotel_experience == InputOption.id_hotel_experience)
                    {
                        MatchingOption = OptionsData[j];
                        break;
                    }
                }


                // Option doesn't exist
                if(MatchingOption == null)
                {
                    console.log("Error Here");
                    IsCorrect = false;
                    continue;
                }


                let QuotaInput = parseInt(InputOption.quantity);

                if(isNaN(QuotaInput))
                {
                    console.log("Error Here");
                    IsCorrect = false;
                    continue;
                }

                // ---------------------------------------------
                // Every option must not be negative
                // ---------------------------------------------

                if(QuotaInput < 0)
                {
                    console.log("Error Here");
                    IsCorrect = false;
                }


                // ---------------------------------------------
                // Add to total
                // ---------------------------------------------

                TotalQuotaInputted += QuotaInput;


                // ---------------------------------------------
                // Find lowest available quota
                // ---------------------------------------------

                let LowestAvailable = null;

                let ThisDataDates = MatchingOption.dates || [];

                console.log("DataInputted", DataInputted);
                console.log("MatchingOption", MatchingOption);
                console.log("ThisDataDates", ThisDataDates);

                for(let x = 0; x < ThisDataDates.length; x++)
                {
                    let AvailableQuota = ThisDataDates[x].available_quota;
                    console.log("ThisDataDates[x]", ThisDataDates[x]);

                    if(AvailableQuota != null)
                    {
                        AvailableQuota = parseInt(AvailableQuota);

                        if(LowestAvailable == null || AvailableQuota < LowestAvailable)
                        {
                            LowestAvailable = AvailableQuota;
                        }
                    }
                }


                // ---------------------------------------------
                // Check available quota for this option
                // ---------------------------------------------

                if(LowestAvailable != null && QuotaInput > LowestAvailable)
                {
                    console.log("Error Here " +  QuotaInput + " > " + LowestAvailable);
                    IsCorrect = false;
                }


                // ---------------------------------------------
                // Check individual option pax
                // ---------------------------------------------

                let MustAtLeastDefault = MatchingOption.pax;

                if(MustAtLeastDefault != null && QuotaInput < parseInt(MustAtLeastDefault))
                {
                    console.log("Error Here");
                    IsCorrect = false;
                }
            }


            // =================================================
            // CHECK TOTAL EXPERIENCE PAX
            // =================================================

            let ExperienceMinimumPax = ExperienceData.pax;

            if(ExperienceMinimumPax != null && TotalQuotaInputted < parseInt(ExperienceMinimumPax))
            {
                console.log("Error Here");
                IsCorrect = false;
            }
        }
    }


    // =========================================================
    // EXPERIENCE WITHOUT OPTIONS
    // =========================================================

    else
    {
        let QuotaInput = parseInt(DataInputted);

        if(isNaN(QuotaInput))
        {
            console.log("Error Here");
            IsCorrect = false;
        }
        else
        {
            // Must select at least something
            if(QuotaInput <= 0)
            {
                console.log("Error Here");
                IsCorrect = false;
            }


            // ---------------------------------------------
            // Find lowest available quota
            // ---------------------------------------------

            let LowestAvailable = null;

            let ThisDataDates = ExperienceData.dates || [];

            for(let i = 0; i < ThisDataDates.length; i++)
            {
                let AvailableQuota = ThisDataDates[i].available_quota;

                if(AvailableQuota != null)
                {
                    AvailableQuota = parseInt(AvailableQuota);

                    if(LowestAvailable == null || AvailableQuota < LowestAvailable)
                    {
                        LowestAvailable = AvailableQuota;
                    }
                }
            }


            // ---------------------------------------------
            // Check available quota
            // ---------------------------------------------

            if(LowestAvailable != null && QuotaInput > LowestAvailable)
            {
                console.log("Error Here");
                IsCorrect = false;
            }


            // ---------------------------------------------
            // Check minimum pax
            // ---------------------------------------------

            let MustAtLeastDefault = ExperienceData.pax;

            if(MustAtLeastDefault != null && QuotaInput < parseInt(MustAtLeastDefault))
            {
                console.log("Error Here");
                IsCorrect = false;
            }
        }
    }


    // =========================================================
    // BUTTON STATE
    // =========================================================


    if(IsCorrect == false)
    {
        if(SaveButton.classList.contains("ButtonInvalid") == false)
        {
            SaveButton.classList.add("ButtonInvalid");
        }
    }
    else
    {
        if(SaveButton.classList.contains("ButtonInvalid") == true)
        {
            SaveButton.classList.remove("ButtonInvalid");
        }
    }


    return IsCorrect;
}

function CheckAllRoomInputted(SaveButton)
{
    let IsCorrect = true;

    let RoomData = window.ThisRoomData;
    let DataInputted = window.RoomQuotaNonTop;

    console.log("window.CurrentUserInputExperienceAddOns", window.CurrentUserInputExperienceAddOns);
    console.log("window.CurrentSelectedRoomID", window.CurrentSelectedRoomID);
    console.log("window.CurrentSelectedRoomExpBookType", window.CurrentSelectedRoomExpBookType);
    console.log("window.ThisRoomData", window.ThisRoomData);

    if(RoomData.status_available == "No")
    {
        IsCorrect = false;
    }

    const FirstDateArray = window.CheckInDateNonTop.split("-");
    const FirstDate = new Date(FirstDateArray[0], parseInt(FirstDateArray[1])-1, FirstDateArray[2]);
    const DateNow = window.GetAndConvertCurrentDate(false);

    const diffInMs = Math.abs(DateNow - FirstDate);
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    if (diffInDays < RoomData.min_booking_notice_days)
    {
        console.log("Error Here");
        IsCorrect = false;
    }

    let QuotaInput = parseInt(DataInputted);

    if(isNaN(QuotaInput))
    {
        console.log("Error Here");
        IsCorrect = false;
    }
    else
    {
        // Must select at least something
        if(QuotaInput <= 0)
        {
            console.log("Error Here");
            IsCorrect = false;
        }


        // ---------------------------------------------
        // Find lowest available quota
        // ---------------------------------------------

        let LowestAvailable = null;

        let ThisDataDates = RoomData.dates || [];

        console.log("ThisDataDates", ThisDataDates);

        for(let i = 0; i < ThisDataDates.length; i++)
        {
            let AvailableQuota = ThisDataDates[i].available_quota;

            if(AvailableQuota != null)
            {
                AvailableQuota = parseInt(AvailableQuota);

                if(LowestAvailable == null || AvailableQuota < LowestAvailable)
                {
                    LowestAvailable = AvailableQuota;
                }
            }
        }


        // ---------------------------------------------
        // Check available quota
        // ---------------------------------------------

        if(LowestAvailable != null && QuotaInput > LowestAvailable)
        {
            console.log("Error Here");
            IsCorrect = false;
        }


        // ---------------------------------------------
        // Check minimum pax
        // ---------------------------------------------

        let MustAtLeastDefault = RoomData.pax;

        if(MustAtLeastDefault != null && QuotaInput < parseInt(MustAtLeastDefault))
        {
            console.log("Error Here");
            IsCorrect = false;
        }
    }


    if(IsCorrect == false)
    {
        if(SaveButton.classList.contains("ButtonInvalid") == false)
        {
            SaveButton.classList.add("ButtonInvalid");
        }
    }
    else
    {
        if(SaveButton.classList.contains("ButtonInvalid") == true)
        {
            SaveButton.classList.remove("ButtonInvalid");
        }
    }


    return IsCorrect;
}

// function CheckAllExperienceInputted(SaveButton)
// {
//     console.log("window.CurrentUserInputExperienceAddOns", window.CurrentUserInputExperienceAddOns);
//     console.log("window.CurrentSelectedRoomID", window.CurrentSelectedRoomID);
//     console.log("window.CurrentSelectedRoomExpBookType", window.CurrentSelectedRoomExpBookType);
//     console.log("window.ThisRoomData", window.ThisRoomData);

//     let IsCorrect = true;
//     let DataInputted = window.CurrentUserInputExperienceAddOns.data_input;

//     if(window.ThisRoomData.status_available == "No")
//         IsCorrect = false;

//     if(Array.isArray(DataInputted) == true)
//     {
//         let OptionsData = window.ThisRoomData.options;

//         for(let i = 0; i < DataInputted.length; i++)
//         {
//             for(let j = 0; j < OptionsData.length; j++)
//             {
//                 if(OptionsData[j].id == DataInputted[i].id && OptionsData[j].id_hotel_experience == DataInputted[i].id_hotel_experience)
//                 {
//                     let QuotaInput = DataInputted[i].quota;
//                     let ThisDataDates = OptionsData[j].dates;
//                     let LowestAvailable = null;
//                     let MustAtLeastDefault = OptionsData[j].default_quota;

//                     for(let x = 0; x < ThisDataDates.length; x++)
//                     {
//                         if(ThisDataDates[x].available_quota != null || (LowestAvailable != null && LowestAvailable > ThisDataDates[x].available_quota))
//                         {
//                             LowestAvailable = ThisDataDates[x].available_quota;
//                         }
//                     }

//                     if(QuotaInput > LowestAvailable || (MustAtLeastDefault != null && QuotaInput <= MustAtLeastDefault))
//                         IsCorrect = false;
//                 }
//             }
//         }
//     }
//     else
//     {
//         let ThisDataDates = window.ThisRoomData.dates;
//         let LowestAvailable = null;
//         let MustAtLeastDefault = window.ThisRoomData.pax;

//         for(let i = 0; i < ThisDataDates.length; i++)
//         {
//             if(ThisDataDates[i].available_quota != null || (LowestAvailable != null && LowestAvailable > ThisDataDates[i].available_quota))
//             {
//                 LowestAvailable = ThisDataDates[i].available_quota;
//             }
//         }

//         if(parseInt(DataInputted) <= 0 || (LowestAvailable != null && parseInt(DataInputted) > LowestAvailable) || (MustAtLeastDefault != null && parseInt(DataInputted) <= MustAtLeastDefault))
//             IsCorrect = false;
//     }


//     if(IsCorrect == false)
//     {
//         if(SaveButton.classList.contains("ButtonInvalid") == false)
//             SaveButton.classList.add("ButtonInvalid");
//     }
//     else
//     {
//         if(SaveButton.classList.contains("ButtonInvalid") == true)
//             SaveButton.classList.remove("ButtonInvalid");
//     }
// }


// ======================================= EDIT ROOM EXPERIENCE =============================================

window.InstantiateEditRoomOrExperiencePaymentPageDesktop = function(functiontocall, functiontocallonclose, isdirect)
{
    console.log("CALLING window.InstantiateEditRoomOrExperiencePaymentPageDesktop");
    
    let ThisCheckInDateArray = window.CheckInDateNonTop.split("-");
    let ThisCheckOutDateArray = window.CheckOutDateNonTop.split("-");

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker ResponsiveDesktopPanel";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    FlexFullDisplayPanel.style.padding = "0";
    FlexFullDisplayPanel.style.overflow = "visible";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    let FlexContainerBaseAnimate = document.createElement("div");
    FlexContainerBaseAnimate.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    FlexContainerBaseAnimate.style.maxHeight = "none";
    FlexContainerBaseAnimate.style.overflow = "visible";
    FlexFullDisplayPanel.append(FlexContainerBaseAnimate);

    // Header ------------------------------------------------------------------------------------------------------
        
    let TopBottomHeaderButtonPaddingContainer = document.createElement("div");
    TopBottomHeaderButtonPaddingContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow BasicRadius NoBottomRadius";
    TopBottomHeaderButtonPaddingContainer.style.backgroundColor = "#2494D9";
    FlexContainerBaseAnimate.append(TopBottomHeaderButtonPaddingContainer);

    let HeaderInnerContainer = document.createElement("div");
    HeaderInnerContainer.className = "ColumnGapExtraLong";
    HeaderInnerContainer.style.flex = "1 1 0%";
    HeaderInnerContainer.style.height = "fit-content";
    HeaderInnerContainer.style.display = "flex";
    HeaderInnerContainer.style.position = "relative";
    TopBottomHeaderButtonPaddingContainer.append(HeaderInnerContainer);

        
    let BackButton = document.createElement("img");
    BackButton.src = "/Assets/images/ButtonIcon/chevron-white.svg";
    BackButton.className = "BasicInputFieldChevronIconSearch Selectable2";
    BackButton.style.margin = "auto 0";
    BackButton.style.rotate = "90deg";
    HeaderInnerContainer.append(BackButton);

    let HeaderText = document.createElement("p");
    HeaderText.className = "LabelGreyHeaderText MarginTextUpDown InterBoldTextFont";
    HeaderText.style.margin = "auto 0";
    HeaderText.style.color = "#FFFFFF";
    HeaderText.innerText = window["ChooseRoomOrExperienceTypeTxt" + window.CurrentCountryID];
    HeaderInnerContainer.append(HeaderText);

    let CloseButton = document.createElement("img");
    CloseButton.src = "/Assets/images/ButtonIcon/x-close.svg";
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.style.position = "absolute";
    CloseButton.style.right = "0";
    CloseButton.style.top = "50%";
    CloseButton.style.transform = "translateY(-50%)";
    HeaderInnerContainer.append(CloseButton);


    // Main content ------------------------------------------------------------------------------------------------------
        
    let MainFlexContainer = document.createElement("div");
    MainFlexContainer.className = "FlexContainerBaseAnimate RowGapBasic2";
    MainFlexContainer.style.width = "100%";
    MainFlexContainer.style.position = "relative";
    FlexContainerBaseAnimate.append(MainFlexContainer);

    let MainPaddingContainer = document.createElement("div");
    MainPaddingContainer.className = "TopBottomHeaderButtonPaddingContainer";
    MainPaddingContainer.style.flexDirection = "column";
    MainFlexContainer.append(MainPaddingContainer);

    let HotelDetailsWrapper = document.createElement("div");
    HotelDetailsWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
    MainPaddingContainer.append(HotelDetailsWrapper);


    let ContainerWarningBookingAtLeast = document.createElement("div"); // Top Warning Text ------------------------------------
    ContainerWarningBookingAtLeast.className = "ContainerWithIconAndText BasicRadius InputFieldMargin3";
    ContainerWarningBookingAtLeast.style.backgroundColor = "#FFFAEB";
    ContainerWarningBookingAtLeast.style.flexDirection = "column";
    ContainerWarningBookingAtLeast.style.display = "none";
    HotelDetailsWrapper.append(ContainerWarningBookingAtLeast);

    let WarningBookingHeaderText = document.createElement("p");
    WarningBookingHeaderText.className = "LabelGreyHeaderSmallerText2 InterBoldTextFont InputFieldMargin3";
    WarningBookingHeaderText.innerHTML = window["KebijakanReservasiTxt" + window.CurrentCountryID];
    ContainerWarningBookingAtLeast.append(WarningBookingHeaderText);

    let WarningBookingAtLeastText = document.createElement("p"); 
    WarningBookingAtLeastText.className = "LabelGreyHeaderSmallerText2 InterMediumTextFont";
    WarningBookingAtLeastText.style.margin = "auto 0";
    WarningBookingAtLeastText.style.lineHeight = "none";
    WarningBookingAtLeastText.style.color = "#344054";
    ContainerWarningBookingAtLeast.append(WarningBookingAtLeastText);


    // Experience or Room section
        
    let ExperienceHoverableContainer = document.createElement("div");
    ExperienceHoverableContainer.className = "HoverableContentInsideInputField";
    ExperienceHoverableContainer.style.flexDirection = "column";
    HotelDetailsWrapper.append(ExperienceHoverableContainer);

    let ExperienceTypeContainer = document.createElement("div");
    ExperienceTypeContainer.className = "SearchTopNonIndexSection NoPaddingLeftRight";
    ExperienceTypeContainer.style.backgroundColor = "transparent";
    ExperienceHoverableContainer.append(ExperienceTypeContainer);

    let ExperienceIcon = document.createElement("img");
    ExperienceIcon.className = "BasicIconInsideInput2";
    ExperienceIcon.src = "/Assets/images/ButtonIcon/black-outline-star.svg";
    ExperienceIcon.style.marginLeft = "0";
    ExperienceTypeContainer.append(ExperienceIcon);

    let ExperienceTextWrapper = document.createElement("div");
    ExperienceTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    ExperienceTypeContainer.append(ExperienceTextWrapper);

    let ExperienceTitle = document.createElement("p");
    ExperienceTitle.className = "BasicInputTextTop InterExBoldTextFont";
    ExperienceTitle.style.marginTop = "0";
    ExperienceTitle.innerText = window["RoomOrExperienceTypeTxt" + window.CurrentCountryID];
    ExperienceTextWrapper.append(ExperienceTitle);

    let ExperienceRightContainer = document.createElement("div");
    ExperienceRightContainer.style.position = "relative";
    ExperienceRightContainer.style.display = "flex";
    ExperienceRightContainer.style.flexDirection = "column";
    ExperienceTypeContainer.append(ExperienceRightContainer);

    let SelectedExperienceContainer = document.createElement("div");
    SelectedExperienceContainer.className = "ColumnGapLong Selectable2";
    SelectedExperienceContainer.style.display = "flex";
    ExperienceRightContainer.append(SelectedExperienceContainer);

    let SelectedExperienceText = document.createElement("p");
    SelectedExperienceText.className = "BasicInputTextTop InterExBoldTextFont";
    SelectedExperienceText.style.color = "#1D2939";
    SelectedExperienceText.innerText = "----- --------";
    SelectedExperienceContainer.append(SelectedExperienceText);

    let ExperienceChevron = document.createElement("img");
    ExperienceChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    ExperienceChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow";
    ExperienceChevron.style.rotate = "0deg";
    SelectedExperienceContainer.append(ExperienceChevron);

    // Date section 

    let DateInputContainer = document.createElement("div");
    DateInputContainer.className = "SearchTopNonIndexSection BasicInputFieldContainer SmallMarginList NoPaddingLeftRight";
    DateInputContainer.style.backgroundColor = "transparent";
    HotelDetailsWrapper.append(DateInputContainer);

    let DateIcon = document.createElement("img");
    DateIcon.className = "BasicIconInsideInput2";
    DateIcon.src = "/Assets/images/ButtonIcon/calendar-black.svg";
    DateIcon.style.marginLeft = "0";
    DateInputContainer.append(DateIcon);

    let DateTextWrapper = document.createElement("div");
    DateTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    DateInputContainer.append(DateTextWrapper);

    let DateTitle = document.createElement("p");
    DateTitle.className = "BasicInputTextTop InterBoldTextFont";
    DateTitle.style.marginTop = "0";
    DateTitle.innerText = window["DateOfVisitTxt" + window.CurrentCountryID];
    DateTextWrapper.append(DateTitle);

    let DateWhereToInstantiate = document.createElement("div");
    DateWhereToInstantiate.id = "JenisExperienceDateCheckIn";
    DateWhereToInstantiate.style.position = "relative";
    DateWhereToInstantiate.style.display = "flex";
    DateWhereToInstantiate.setAttribute("date", ThisCheckInDateArray[2]);
    DateWhereToInstantiate.setAttribute("month", ThisCheckInDateArray[1]);
    DateWhereToInstantiate.setAttribute("year", ThisCheckInDateArray[0]);
    DateInputContainer.append(DateWhereToInstantiate);

    let DateRightContainer = document.createElement("div");
    DateRightContainer.className = "ColumnGapLong Selectable2";
    DateRightContainer.style.display = "flex";
    DateWhereToInstantiate.append(DateRightContainer);

    let DateText = document.createElement("p");
    DateText.className = "BasicInputTextTop InterRegularTextFont";
    DateText.style.color = "#667085";
    DateText.innerText = "-- ---- ---- -  -- ---- ----";
    DateRightContainer.append(DateText);

    let DateChevron = document.createElement("img");
    DateChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    DateChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow";
    DateChevron.id = "JenisExpeienceDateInputChevron";
    DateChevron.style.rotate = "0deg";
    DateRightContainer.append(DateChevron);

    let DateCheckOutHide = document.createElement("div");
    DateCheckOutHide.id = "JenisExperienceDateCheckOut";
    DateCheckOutHide.style.display = "none";
    DateCheckOutHide.setAttribute("date", ThisCheckOutDateArray[2]);
    DateCheckOutHide.setAttribute("month", ThisCheckOutDateArray[1]);
    DateCheckOutHide.setAttribute("year", ThisCheckOutDateArray[0]);
    DateInputContainer.append(DateCheckOutHide);


    // Experience Option section -----------------------------------------------
    let ExperienceOptionHoverableContainer = document.createElement("div");
    ExperienceOptionHoverableContainer.className = "HoverableContentInsideInputField";
    ExperienceOptionHoverableContainer.style.flexDirection = "column";
    ExperienceOptionHoverableContainer.style.backgroundColor = "#FFFAF5";
    HotelDetailsWrapper.append(ExperienceOptionHoverableContainer);

    // Save button ------------------------------------------------------------
    let SaveWrapper = document.createElement("div");
    SaveWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    SaveWrapper.style.marginBottom = "0";
    MainPaddingContainer.append(SaveWrapper);

    let SaveButton = document.createElement("button");
    SaveButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SaveButton.style.margin = "0";
    SaveButton.style.width = "100%";
    SaveButton.innerText = window["SavedButtonTxt" + window.CurrentCountryID];
    SaveWrapper.append(SaveButton);


    // ============================= FUNCTION ===================================

    let ClosePanelFunction = function(isjustclose)
    {
        if(functiontocall != null && isjustclose == false) // If Just Close Then don't call any function assigned
            functiontocall();
            
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
        
    let CloseWithoutSavingFunction = function()
    {
        // Re-Apply Previous Temp Data ------------------------------
        if(functiontocallonclose != null)
                functiontocallonclose();

        ClosePanelFunction(true);
    }

    let FunctionToCallOnUpdate = function(isreload)
    {
        let UpdatedCheckInDate = DateWhereToInstantiate.getAttribute("date");
        let UpdatedCheckInMonth = DateWhereToInstantiate.getAttribute("month");
        let UpdatedCheckInYear = DateWhereToInstantiate.getAttribute("year");
        let UpdatedCheckInFullDate = new Date(parseInt(UpdatedCheckInYear), parseInt(UpdatedCheckInMonth) - 1, parseInt(UpdatedCheckInDate));
        window.CheckInDateNonTop = UpdatedCheckInYear + "-" + UpdatedCheckInMonth.padStart(2, '0') + "-" + UpdatedCheckInDate.padStart(2, '0');

        window.CurrentSelectedDayEdit = UpdatedCheckInDate; // Current Selected Date (Individual)
        window.CurrentSelectedMonthEdit = UpdatedCheckInMonth;
        window.CurrentSelectedYearEdit = UpdatedCheckInYear;

        if(window.CurrentSelectedRoomExpBookType == "per day")
        {
            let GetFinalSelectedCheckOutDate = new Date(UpdatedCheckInYear, parseInt(UpdatedCheckInMonth) - 1, UpdatedCheckInDate);
            GetFinalSelectedCheckOutDate.setDate(GetFinalSelectedCheckOutDate.getDate() + 1);
            
            let NewCheckOutYear = GetFinalSelectedCheckOutDate.getFullYear();
            let NewCheckOutMonth = (GetFinalSelectedCheckOutDate.getMonth() + 1);
            let NewCheckOutDay = GetFinalSelectedCheckOutDate.getDate();

            DateCheckOutHide.setAttribute("date", NewCheckOutDay);
            DateCheckOutHide.setAttribute("month", NewCheckOutMonth);
            DateCheckOutHide.setAttribute("year", NewCheckOutYear);
        }
        
        let UpdatedCheckOutDate = DateCheckOutHide.getAttribute("date");
        let UpdatedCheckOutMonth = DateCheckOutHide.getAttribute("month");
        let UpdatedCheckOutYear = DateCheckOutHide.getAttribute("year");
        let UpdatedCheckOutFullDate = new Date(parseInt(UpdatedCheckOutYear), parseInt(UpdatedCheckOutMonth) - 1, parseInt(UpdatedCheckOutDate));
        window.CheckOutDateNonTop = UpdatedCheckOutYear + "-" + UpdatedCheckOutMonth.padStart(2, '0') + "-" + UpdatedCheckOutDate.padStart(2, '0');

        console.log("UPDATING................");
        console.log("LatestUpdate",
            {
                "window.CurrentSelectedRoomID":window.CurrentSelectedRoomID,
                "window.CurrentSelectedRoomExpBookType":window.CurrentSelectedRoomExpBookType,
                "window.CurrentSelectedAccFacilitiesType":window.CurrentSelectedAccFacilitiesType,
                "window.ThisRoomData":window.ThisRoomData,
                "UpdatedCheckInFullDate":UpdatedCheckInFullDate,
                "UpdatedCheckOutFullDate":UpdatedCheckOutFullDate,
                "window.CheckInDateNonTop": window.CheckInDateNonTop,
                "window.CheckOutDateNonTop": window.CheckOutDateNonTop,
                "window.RoomQuotaNonTop": window.RoomQuotaNonTop,
                "window.CurrentSelectedYearEdit": window.CurrentSelectedYearEdit,
                "window.CurrentSelectedMonthEdit": window.CurrentSelectedMonthEdit,
                "window.CurrentSelectedDayEdit": window.CurrentSelectedDayEdit,
                "window.CurrentUserInputExperienceAddOns": window.CurrentUserInputExperienceAddOns,
                "isreload": isreload
            }
        )

        if(window.ThisRoomData.book_type == "per day")
        {
            DateText.innerHTML = window["weekdayFull" + window.CurrentCountryID][(UpdatedCheckInFullDate.getDay())] + " " + UpdatedCheckInDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(UpdatedCheckInMonth) - 1] + " " + UpdatedCheckInFullDate.getFullYear();
        }
        else
        {
            DateText.innerHTML = window.DisplayFinalCheckInOutDat(UpdatedCheckInFullDate, UpdatedCheckOutFullDate, true, false);
        }
        

        for(let i = 0; i < window.ListOfChoicesThisAccommodation.length; i++)
        {
            if(window.ListOfChoicesThisAccommodation[i].id == window.CurrentSelectedRoomID && window.CurrentSelectedAccFacilitiesType == window.ListOfChoicesThisAccommodation[i].type)
            {
                SelectedExperienceText.innerHTML = window.ListOfChoicesThisAccommodation[i]["name_" + window.CurrentCountryID];

                if(window.ListOfChoicesThisAccommodation[i].data.min_booking_notice_days > 0)
                {
                    ContainerWarningBookingAtLeast.style.display = "flex";
                    WarningBookingAtLeastText.innerHTML = window.MinRangeTextRight(window.ListOfChoicesThisAccommodation[i].data.min_booking_notice_days);
                }
                else
                {
                    ContainerWarningBookingAtLeast.style.display = "none";
                }
            }
        }

        if(isreload == true) // If Require Reload Reload All ----------------------------------------------------
        {
            let ThisLoading = window.InstantiateLoadingCircle(MainFlexContainer, true);
            ThisLoading.style.zIndex = 1;

            window.CheckIfAllRoomExperienceDataAlreadyLoaded(()=>
            {
                for(let i = 0; i < window.ListOfChoicesThisAccommodation.length; i++)
                {
                    let ThisData = window.ListOfChoicesThisAccommodation[i];
                    console.log("ThisData", ThisData);

                    if(window.CurrentSelectedAccFacilitiesType == ThisData.type && ThisData.id == window.CurrentSelectedRoomID)
                    {
                        window.ThisRoomData = ThisData.data;
                    }
                }

                console.log("window.ThisRoomData", window.ThisRoomData);
                if(window.CurrentSelectedAccFacilitiesType == "Experiences")
                {
                    window.InstantiateDropDownExperienceOptions(ExperienceOptionHoverableContainer, ()=>
                    {
                        FunctionToCallOnUpdate(false);
                    }, false);
                }
                else
                {
                    window.InstantiateDropDownRoomOptions(ExperienceOptionHoverableContainer, ()=>
                    {
                        FunctionToCallOnUpdate(false);
                    }, false);
                }

                ThisLoading.remove();  
            });
        }
        else
        {
            if(window.CurrentSelectedAccFacilitiesType == "Experiences")
            {
                CheckAllExperienceInputted(SaveButton);
            }
            else
            {
                CheckAllRoomInputted(SaveButton);
            }
        }
    }
    

    BasicBlackBlocker.OnResponsiveRemove = function()
    {
        CloseWithoutSavingFunction();
    };
        
    SaveButton.onclick = function()
    {
        ClosePanelFunction(false);
    }

    BackButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    CloseButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    DateRightContainer.onclick = function()
    {
        let isallinonechoice = false;
        if(window.CurrentSelectedRoomExpBookType == "per night")
            isallinonechoice = true;

        window.OpenDateChoiceContainer('JenisExperienceDateCheckIn', 'JenisExperienceDateCheckOut', 'JenisExpeienceDateInputChevron', 'Start', '', 1, false, false, true, false, true, isallinonechoice, ()=>FunctionToCallOnUpdate(true));
    }
    
    SelectedExperienceContainer.onclick = function()
    {
        window.InstantiateDropDownPilihRoomAndExperience(ExperienceRightContainer, SelectedExperienceText, ()=>FunctionToCallOnUpdate(true));
    }

    // Call Function =================================================
    
    if(isdirect == true)
    {
        BackButton.style.display = "none";
    }
    else
    {
        CloseButton.style.display = "none";
    }

    FunctionToCallOnUpdate(true);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);



    return BasicBlackBlocker;
}


window.InstantiateDropDownPilihRoomAndExperience = function(wheretoinstantiate, textdisplayer, functiontocall)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("PilihTipeRoomExperience", wheretoinstantiate);

    if(ThisDropDownContainer == null)
        return

    console.log("window.ListOfChoicesThisAccommodation", window.ListOfChoicesThisAccommodation);

    ThisDropDownContainer.style.bottom = "0";
    ThisDropDownContainer.style.right = "0";
    ThisDropDownContainer.style.left = "auto";
    ThisDropDownContainer.style.width = "max-content";
    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.innerHTML = "";

    let ExperienceDropdown = document.createElement("div");
    ExperienceDropdown.className = "DropDownContainer HideScrollBar ExtendedDropDown";
    ThisDropDownContainer.append(ExperienceDropdown);
    

    // Sort it First -------------------------------------------------------------------------
    window.ListOfChoicesThisAccommodation.sort((a, b) =>
    {
        if(a.type == "Rooms" && b.type == "Experiences")
            return -1;

        if(a.type == "Experiences" && b.type == "Rooms")
            return 1;

        return 0;
    });
    // --------------------------------------------------------------------------------------

    let LastType = null;
    let ScrollToDropDown;

    for(let i = 0; i < window.ListOfChoicesThisAccommodation.length; i++)
    {
        let ThisChoice = window.ListOfChoicesThisAccommodation[i];

        // =========================================================
        // CREATE HEADER WHEN TYPE CHANGES
        // =========================================================
        if(ThisChoice.type != LastType)
        {
            let TypeHeader = document.createElement("div");
            TypeHeader.className = "DropDownSelectionContainer DropDownWithStatus SlightlyBigPadding";
            TypeHeader.style.width = "auto";
            TypeHeader.style.pointerEvents = "none";
            ExperienceDropdown.append(TypeHeader);

            let ExperienceIcon = document.createElement("img");
            ExperienceIcon.className = "BasicIconInsideInput3";
            ExperienceIcon.style.marginLeft = "0";
            TypeHeader.append(ExperienceIcon);

            let TypeHeaderText = document.createElement("p");
            TypeHeaderText.className = "DropDownSelectionText InterExBoldTextFont";
            TypeHeaderText.style.color = "#344054";
            if(ThisChoice.type == "Rooms")
            {
                ExperienceIcon.src = "/Assets/images/ButtonIcon/dark-blue-bed.svg";
                TypeHeaderText.innerHTML = window["AccommodationTxt" + window.CurrentCountryID];
            }
            else if(ThisChoice.type == "Experiences")
            {
                ExperienceIcon.src = "/Assets/images/ButtonIcon/dark-blue-twin-star-outline.svg";
                TypeHeaderText.innerHTML = window["ExperienceTxt" + window.CurrentCountryID];
            }
            else
            {
                TypeHeaderText.innerText = ThisChoice.type;
            }
            TypeHeader.append(TypeHeaderText);
            
            LastType = ThisChoice.type;
        }

        // ==============================================================================================
        // CREATE NORMAL OPTION
        // ==============================================================================================

        
        let ChoiceOption = document.createElement("div");
        ChoiceOption.className = "DropDownSelectionContainer DropDownWithStatus SlightlyBigPadding";
        ChoiceOption.style.width = "auto";
        ChoiceOption.onclick = function()
        {
            ThisDropDownContainer.remove();

            textdisplayer.innerHTML = ThisChoice["name_" + window.CurrentCountryID];

            // Update All Info
            window.CurrentSelectedRoomID = ThisChoice.id;
            window.CurrentSelectedRoomExpBookType = ThisChoice.book_type;
            window.CurrentSelectedAccFacilitiesType = ThisChoice.type;
            window.ThisRoomData = ThisChoice.data;

            if(functiontocall != null)
                functiontocall();
        };
        ExperienceDropdown.append(ChoiceOption);

        let ChoiceOptionText = document.createElement("p");
        ChoiceOptionText.className = "DropDownSelectionText";
        ChoiceOptionText.style.color = "#667085";
        ChoiceOptionText.innerText = ThisChoice["name_" + window.CurrentCountryID];
        ChoiceOption.append(ChoiceOptionText);

        if(ThisChoice.id == window.CurrentSelectedRoomID && window.CurrentSelectedAccFacilitiesType == ThisChoice.type)
        {
            ScrollToDropDown = ChoiceOption;
            ChoiceOption.classList.add("DropDownSelectionContainerSelected2");
        }
    }

    window.ScrollToSelectedDropDown(ExperienceDropdown, ScrollToDropDown)
}


// Tipe Experience Choice Functions ------------------------------------

window.LoadTipeExperienceBefore = function(thischeckindate, thischeckoutdate, isallowrefresh, functiontocall)
{
    let URLAccRoomExpData = "/v2/hotels/" + window.HotelID + "/experiences?date_visit=" + window.formatDatetoString(thischeckindate) + "&date_until=" + window.formatDatetoString(thischeckoutdate) + "&rooms=" + window.RoomQuotaNonTop;

    if(isallowrefresh == false && window.ListOfChoicesThisAccommodation.length <= 0)
        isallowrefresh = true;

    if(isallowrefresh == true)
    {
        window.ListOfChoicesThisAccommodation = [];

        window.CallApiAxios({
            method: "GET",
            url: URLAccRoomExpData,
        })
        .then(res =>
        {
            console.log(URLAccRoomExpData);

            if(res.status == 200)
            {
                let WhichData = res.data.data[0];

                window.CurrentChoiceDataJenisExperience = WhichData.experiences;

                console.log("ThisAccExpData", window.CurrentChoiceDataJenisExperience);

                // Update Choices ---------------------------------------------------------------
                
                if(isallowrefresh == true)
                {
                    for(let i = 0; i < window.CurrentChoiceDataJenisExperience.length; i++)
                    {
                        let ChoiceDataToAppend =
                        {
                            "id": window.CurrentChoiceDataJenisExperience[i].id,
                            "type": "Experience",
                            "name_en": window.CurrentChoiceDataJenisExperience[i].name_en,
                            "name_id": window.CurrentChoiceDataJenisExperience[i].name_id,
                            "book_type": window.CurrentChoiceDataJenisExperience[i].book_type,
                            "data": window.CurrentChoiceDataJenisExperience[i],
                        }
                        window.ListOfChoicesThisAccommodation.push(ChoiceDataToAppend);

                        if(window.CurrentChoiceDataJenisExperience[i].id == window.CurrentSelectedRoomID)
                            window.ThisRoomData = window.CurrentChoiceDataJenisExperience[i];
                    }
                }

                // Call Function -----------------------------------------------------------------

                if(functiontocall != null)
                    functiontocall();
            }
        })
        .catch(err =>
        {
            console.error(err);

            if(functiontocall != null)
                functiontocall();
        });
    }
    else
    {
        if(functiontocall != null)
            functiontocall();
    }
}

window.InstantiateDropDownPilihTipeExperience = function(wheretoinstantiate, textdisplayer, functiontocall)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("PilihTipeExperience", wheretoinstantiate);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.style.bottom = "0";
    ThisDropDownContainer.style.right = "0";
    ThisDropDownContainer.style.left = "auto";
    ThisDropDownContainer.style.width = "max-content";
    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.innerHTML = "";

    let ExperienceDropdown = document.createElement("div");
    ExperienceDropdown.className = "DropDownContainer HideScrollBar ShorterHeightDropDown";
    ThisDropDownContainer.append(ExperienceDropdown);

    for (let i = 0; i < window.CurrentChoiceDataJenisExperience.length; i++)
    {
        let ExperienceOption = document.createElement("div");
        ExperienceOption.className = "DropDownSelectionContainer DropDownWithStatus";
        ExperienceOption.onclick = function()
        {
            ThisDropDownContainer.remove();
            textdisplayer.innerHTML = window.CurrentChoiceDataJenisExperience[i]["name_" + window.CurrentCountryID];

            // Update All Info ------------------------------------------------------------------------
            window.CurrentSelectedRoomID = window.CurrentChoiceDataJenisExperience[i].id;
            window.CurrentSelectedRoomExpBookType = window.CurrentChoiceDataJenisExperience[i].book_type;
            window.CurrentSelectedAccFacilitiesType = "Experiences";
            window.ThisRoomData = window.CurrentChoiceDataJenisExperience[i];

            if(functiontocall != null)
                functiontocall();
        }
        ExperienceDropdown.append(ExperienceOption);

        let ExperienceOptionText = document.createElement("p");
        ExperienceOptionText.className = "DropDownSelectionText";
        ExperienceOptionText.innerText = window.CurrentChoiceDataJenisExperience[i]["name_" + window.CurrentCountryID];
        ExperienceOption.append(ExperienceOptionText);
    }
}

window.InstantiateDropDownExperienceOptions = function(wheretoinstantiate, functiontocall, disableinputfield)
{
    console.log("CALLED window.InstantiateDropDownExperienceOptions");

    let AllExistingChoices = wheretoinstantiate.querySelectorAll(".AddOnsExperienceChoices");
    AllExistingChoices.forEach(thischoices =>
    {
        thischoices.remove();
    });

    // Reset List Of Choice from Add Ons --------------------------------------------------------
    window.CurrentChoiceExperienceAddOns = [];

    console.log("window.CurrentChoiceDataJenisExperience", window.CurrentChoiceDataJenisExperience);

    window.CurrentChoiceDataJenisExperience.forEach(thisexperience =>
    {
        if(window.CurrentSelectedRoomID == thisexperience.id)
        {
            window.CurrentChoiceExperienceAddOns = thisexperience.options;
        }
    });

    // Check if Not Exist or the In ------------------------------------------------------------------------
    if(window.CurrentUserInputExperienceAddOns == null || (window.CurrentUserInputExperienceAddOns != null && window.CurrentUserInputExperienceAddOns.id_experiences != window.CurrentSelectedRoomID))
    {
        let DataInputTemp = [];

        if(window.CurrentChoiceExperienceAddOns.length > 0)
        {
            for(let i = 0; i < window.CurrentChoiceExperienceAddOns.length; i++)
            {
                let DataToAppend =
                {
                    "id":window.CurrentChoiceExperienceAddOns[i].id,
                    "id_hotel_experience":window.CurrentChoiceExperienceAddOns[i].id_hotel_experience,
                    "quantity":0,
                }
                DataInputTemp.push(DataToAppend);
            }
        }
        else
        {
            DataInputTemp = 0;
        }

        window.CurrentUserInputExperienceAddOns =
        {
            "id_experiences": window.CurrentSelectedRoomID,
            "data_input":DataInputTemp
        }
    }

    console.log("window.CurrentUserInputExperienceAddOns", window.CurrentUserInputExperienceAddOns);


    // Instantiate Experience Options ------------------------------------------------------------------------

    let InstantiateInputExperienceOptions = function(addonname, whichaddondata, whichid)
    {
        let ThisAddOnContainer = document.createElement("div");
        ThisAddOnContainer.className = "BasicPadding AddOnsExperienceChoices";
        ThisAddOnContainer.style.backgroundColor = "transparent";
        wheretoinstantiate.append(ThisAddOnContainer);

        let ThisAddOnWrapper = document.createElement("div");
        ThisAddOnWrapper.className = "SearchInputFieldTopBottomTextWrapper";
        ThisAddOnWrapper.style.flexDirection = "row";
        ThisAddOnContainer.append(ThisAddOnWrapper);

        let ThisAddOnLabel = document.createElement("p");
        ThisAddOnLabel.className = "BasicInputTextTop InterBoldTextFont";
        ThisAddOnLabel.style.margin = "auto 0";
        ThisAddOnLabel.innerText = addonname;
        ThisAddOnWrapper.append(ThisAddOnLabel);

        let ThisAddOnButtonContainer = document.createElement("div");
        ThisAddOnButtonContainer.className = "RoomButtonAndInputContainer";
        ThisAddOnWrapper.append(ThisAddOnButtonContainer);

        let ThisAddOnReduceButton = document.createElement("img");
        ThisAddOnReduceButton.className = "IncreaseReduceRoomButton Selectable2";
        ThisAddOnReduceButton.src = "/Assets/images/ButtonIcon/reduce-circle-button.svg";
        ThisAddOnButtonContainer.append(ThisAddOnReduceButton);

        let ThisAddOnInputContainer = document.createElement("div");
        ThisAddOnInputContainer.className = "SmallPanelDropDownContainer Selectable3";
        ThisAddOnButtonContainer.append(ThisAddOnInputContainer);

        let ThisAddOnInput = document.createElement("input");
        ThisAddOnInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
        ThisAddOnInput.type = "number";
        ThisAddOnInput.placeholder = "0";
        ThisAddOnInputContainer.append(ThisAddOnInput);


        let ThisAddOnIncreaseButton = document.createElement("img");
        ThisAddOnIncreaseButton.className = "IncreaseReduceRoomButton Selectable2";
        ThisAddOnIncreaseButton.src = "/Assets/images/ButtonIcon/increase-circle-button.svg";
        ThisAddOnButtonContainer.append(ThisAddOnIncreaseButton);

        let CheckingFunction = function()
        {
            window.CheckAdjustmentOnAddOnExperienceQuota(whichaddondata, ThisAddOnReduceButton, ThisAddOnInput, ThisAddOnIncreaseButton, functiontocall);
        }

        ThisAddOnReduceButton.onclick = function()
        {
            window.AddorReduceAddOnExperience(whichid, -1, ()=>CheckingFunction());
        }

        ThisAddOnIncreaseButton.onclick = function()
        {
            window.AddorReduceAddOnExperience(whichid, 1, ()=>CheckingFunction());
        }

        if(disableinputfield == false)
        {
            ThisAddOnInput.addEventListener("focusout", (event) =>
            {
                if(Array.isArray(window.CurrentUserInputExperienceAddOns.data_input) == true) // Means Add On Exist ------------------------------------------------------------------
                {
                    for(let i = 0; i < window.CurrentUserInputExperienceAddOns.data_input.length; i++)
                    {
                        if(window.CurrentUserInputExperienceAddOns.data_input[i].id == whichid)
                        {
                            window.CurrentUserInputExperienceAddOns.data_input[i].quantity = parseInt(ThisAddOnInput.value);
                        }
                    }
                }
                else // Add Ons Not Exist (Means Direct Input) ------------------------------------------------------------------
                {
                    window.CurrentUserInputExperienceAddOns.data_input = parseInt(ThisAddOnInput.value);
                }
                CheckingFunction();
            });
        }
        else
        {   
            ThisAddOnInput.style.backgroundColor = "transparent";
            ThisAddOnInput.style.outline = "0";
            ThisAddOnInput.style.pointerEvents = "none";
            ThisAddOnInput.placeholder = "0";
            ThisAddOnInputContainer.style.pointerEvents = "none";
        }
        

        CheckingFunction();
    }

    if(window.CurrentChoiceExperienceAddOns.length > 0)
    {
        for (let i = 0; i < window.CurrentChoiceExperienceAddOns.length; i++)
        {
            InstantiateInputExperienceOptions(window.CurrentChoiceExperienceAddOns[i]["name_" + window.CurrentCountryID], window.CurrentChoiceExperienceAddOns[i], window.CurrentChoiceExperienceAddOns[i].id);
        }
    }
    else
    {
        InstantiateInputExperienceOptions(window["TotalTxt" + window.CurrentCountryID], null, null);
    }
}

window.InstantiateDropDownRoomOptions = function(wheretoinstantiate, functiontocall, disableinputfield)
{
    console.log("CALLED window.InstantiateDropDownExperienceOptions");

    let AllExistingChoices = wheretoinstantiate.querySelectorAll(".AddOnsExperienceChoices");
    AllExistingChoices.forEach(thischoices =>
    {
        thischoices.remove();
    });

    window.ThisCurrentQuotaInput = window.RoomQuotaNonTop;

    // Instantiate Experience Options ------------------------------------------------------------------------

    let ThisAddOnContainer = document.createElement("div");
    ThisAddOnContainer.className = "BasicPadding AddOnsExperienceChoices";
    ThisAddOnContainer.style.backgroundColor = "transparent";
    ThisAddOnContainer.setAttribute("room-quota", window.RoomQuotaNonTop);
    wheretoinstantiate.append(ThisAddOnContainer);

    let ThisAddOnWrapper = document.createElement("div");
    ThisAddOnWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    ThisAddOnWrapper.style.flexDirection = "row";
    ThisAddOnContainer.append(ThisAddOnWrapper);

    let ThisAddOnLabel = document.createElement("p");
    ThisAddOnLabel.className = "BasicInputTextTop InterBoldTextFont";
    ThisAddOnLabel.style.margin = "auto 0";
    ThisAddOnLabel.innerText = window["RoomAmountTxt" + window.CurrentCountryID];
    ThisAddOnWrapper.append(ThisAddOnLabel);

    let ThisAddOnButtonContainer = document.createElement("div");
    ThisAddOnButtonContainer.className = "RoomButtonAndInputContainer";
    ThisAddOnWrapper.append(ThisAddOnButtonContainer);

    let ThisAddOnReduceButton = document.createElement("img");
    ThisAddOnReduceButton.className = "IncreaseReduceRoomButton Selectable2";
    ThisAddOnReduceButton.src = "/Assets/images/ButtonIcon/reduce-circle-button.svg";
    ThisAddOnButtonContainer.append(ThisAddOnReduceButton);

    let ThisAddOnInputContainer = document.createElement("div");
    ThisAddOnInputContainer.className = "SmallPanelDropDownContainer Selectable3";
    ThisAddOnButtonContainer.append(ThisAddOnInputContainer);

    let ThisAddOnInput = document.createElement("input");
    ThisAddOnInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    ThisAddOnInput.type = "number";
    ThisAddOnInput.placeholder = "0";
    ThisAddOnInputContainer.append(ThisAddOnInput);


    let ThisAddOnIncreaseButton = document.createElement("img");
    ThisAddOnIncreaseButton.className = "IncreaseReduceRoomButton Selectable2";
    ThisAddOnIncreaseButton.src = "/Assets/images/ButtonIcon/increase-circle-button.svg";
    ThisAddOnButtonContainer.append(ThisAddOnIncreaseButton);

    let OnChangeQuotaFunction = function()
    {
        window.RoomQuotaNonTop = window.ThisCurrentQuotaInput;
        window.OnChangeCurrentQuotaInput(ThisAddOnContainer, ThisAddOnInput, null, ThisAddOnReduceButton, functiontocall);
    }

    ThisAddOnReduceButton.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();

        window.ThisCurrentQuotaInput = window.ThisCurrentQuotaInput - 1;
        OnChangeQuotaFunction();
    }

    ThisAddOnIncreaseButton.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();

        window.ThisCurrentQuotaInput = window.ThisCurrentQuotaInput + 1;
        OnChangeQuotaFunction();
    }

    if(disableinputfield == false)
    {
        ThisAddOnInput.addEventListener("focusout", (event) =>
        {
            OnChangeQuotaFunction();
        });
    }
    else
    {   
        ThisAddOnInput.style.backgroundColor = "transparent";
        ThisAddOnInput.style.outline = "0";
        ThisAddOnInput.style.pointerEvents = "none";
        ThisAddOnInput.placeholder = "0";
        ThisAddOnInputContainer.style.pointerEvents = "none";
    }
    

    OnChangeQuotaFunction();
}


// Experience Options Choice Functions ------------------------------------

window.AddorReduceAddOnExperience = function(thisid, whattoinput, functiontocall)
{
    if(Array.isArray(window.CurrentUserInputExperienceAddOns.data_input) == true) // Means Add On Exist ------------------------------------------------------------------
    {
        for(let i = 0; i < window.CurrentUserInputExperienceAddOns.data_input.length; i++)
        {
            if(window.CurrentUserInputExperienceAddOns.data_input[i].id == thisid)
            {
                let CurrentQuota = parseInt(window.CurrentUserInputExperienceAddOns.data_input[i].quantity);
                CurrentQuota = CurrentQuota + whattoinput;
                window.CurrentUserInputExperienceAddOns.data_input[i].quantity = CurrentQuota;
            }
        }
    }
    else // Add Ons Not Exist (Means Direct Input) ------------------------------------------------------------------
    {
        let CurrentQuota = parseInt(window.CurrentUserInputExperienceAddOns.data_input);
        CurrentQuota = CurrentQuota + whattoinput;
            window.CurrentUserInputExperienceAddOns.data_input = CurrentQuota;
    }


    if(functiontocall != null)
        functiontocall();
}

window.CheckAdjustmentOnAddOnExperienceQuota = function(currentuserchoicedata, ThisAddOnReduceButton, ThisAddOnInput, ThisAddOnIncreaseButton, functiontocall)
{
    if(Array.isArray(window.CurrentUserInputExperienceAddOns.data_input) == true)
    {
        for(let i = 0; i < window.CurrentUserInputExperienceAddOns.data_input.length; i++)
        {
            if(currentuserchoicedata.id == window.CurrentUserInputExperienceAddOns.data_input[i].id)
            {
                if(window.CurrentUserInputExperienceAddOns.data_input[i].quantity <= 0) // If Zero Disable Reduce Button -----------------------------
                {
                    ThisAddOnReduceButton.className = "IncreaseReduceRoomButton ButtonUnselectableOpacity";
                }
                else
                {
                    ThisAddOnReduceButton.className = "IncreaseReduceRoomButton Selectable2";
                }

                let ThisAddOnDataBasedOnDates = currentuserchoicedata.dates;
                let LowestAvailable = null;

                for(let j = 0; j < ThisAddOnDataBasedOnDates.length; j++)
                {
                    if(ThisAddOnDataBasedOnDates[j].available_quota != null || (LowestAvailable != null && LowestAvailable > ThisAddOnDataBasedOnDates[j].available_quota))
                    {
                        LowestAvailable = ThisAddOnDataBasedOnDates[j].available_quota;
                    }
                }

                console.log("currentuserchoicedata", currentuserchoicedata);
                console.log("window.CurrentUserInputExperienceAddOns.data_input", window.CurrentUserInputExperienceAddOns.data_input);
                console.log("ThisAddOnDataBasedOnDates", ThisAddOnDataBasedOnDates);
                console.log("LowestAvailable", LowestAvailable);

                if(LowestAvailable != null)
                {
                    if(window.CurrentUserInputExperienceAddOns.data_input[i].quantity >= LowestAvailable)
                    {
                        window.CurrentUserInputExperienceAddOns.data_input[i].quantity = LowestAvailable;

                        ThisAddOnIncreaseButton.className = "IncreaseReduceRoomButton ButtonUnselectableOpacity";
                    }
                    else
                    {
                        ThisAddOnIncreaseButton.className = "IncreaseReduceRoomButton Selectable2";
                    }

                }
                else
                {
                    ThisAddOnIncreaseButton.className = "IncreaseReduceRoomButton Selectable2";
                }
                // let CurrentQuota = currentuserchoicedata.data_input[i].quota;

                ThisAddOnInput.value = window.CurrentUserInputExperienceAddOns.data_input[i].quantity;
            }
        }
    }
    else
    {
        if(window.CurrentUserInputExperienceAddOns.data_input <= 0) // If Zero Disable Reduce Button -----------------------------
        {
            ThisAddOnReduceButton.className = "IncreaseReduceRoomButton ButtonUnselectableOpacity";
        }
        else
        {
            ThisAddOnReduceButton.className = "IncreaseReduceRoomButton Selectable2";
        }

        ThisAddOnInput.value = window.CurrentUserInputExperienceAddOns.data_input;
    }

    if(functiontocall != null)
        functiontocall();
}


// SCROLL ROOM OR EXPERIENCE TYPE CHOICES --------------------------------------------------------------------------------------------------

window.InstantiateMobileRoomExperienceTypeScrollChoice = function(functiontocallonsave, functiontocallwhenclose, isdirect)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker ResponsiveMobilePanel";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let MainPanel = document.createElement("div");
    MainPanel.className = "FlexFullDisplayPanel FlexPanelOnlyForMobile";
    MainPanel.style.padding = "0px";
    BasicBlackBlocker.append(MainPanel);

    BasicBlackBlocker.OnResponsiveRemove = function()
    {
        if(functiontocallwhenclose != null && isdirect == true)
            functiontocallwhenclose();
    };

    // ================= HEADER =================

    let HeaderContainer = document.createElement("div");
    HeaderContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow";
    MainPanel.append(HeaderContainer);

    let HeaderWrapper = document.createElement("div");
    HeaderWrapper.className = "ColumnGapExtraLong";
    HeaderWrapper.style.cssText = "flex:1 1 0%; height:fit-content; display:flex; position:relative;";
    HeaderContainer.append(HeaderWrapper);

    let BackButton = document.createElement("img");
    BackButton.src = "/Assets/images/ButtonIcon/chevron.svg";
    BackButton.className = "BasicInputFieldChevronIconSearch Selectable2";
    BackButton.style.cssText = "margin:auto 0; rotate:90deg;";
    HeaderWrapper.append(BackButton);

    let HeaderText = document.createElement("p");
    HeaderText.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    HeaderText.style.margin = "auto 0";
    HeaderText.textContent = window["SelectRoomItemButtonTxt" + window.CurrentCountryID];
    HeaderWrapper.append(HeaderText);

    let CloseButton = document.createElement("img");
    CloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.style.cssText = "position:absolute; right:0; top:50%; transform:translateY(-50%);";
    HeaderWrapper.append(CloseButton);

    // ================= BODY =================

    let BodyContainer = document.createElement("div");
    BodyContainer.className = "TopBottomHeaderButtonPaddingContainer PingExprezyViewMoreContainer RowGapBasic2";
    BodyContainer.style.width = "auto";
    BodyContainer.style.flexDirection = "column";
    MainPanel.append(BodyContainer);

    // ================= HOTEL CONTAINER =================

    let HotelWrapper = document.createElement("div");
    HotelWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
    BodyContainer.append(HotelWrapper);

    let HoverContainer = document.createElement("div");
    HoverContainer.className = "HoverableContentInsideInputField";
    HoverContainer.style.flexDirection = "column";
    HotelWrapper.append(HoverContainer);

    // ================= SWIPER =================

    let SwiperContainer = document.createElement("div");
    SwiperContainer.className = "BasicSwiperSlideVerticalContainer BasicGradientTopBottomMask";
    SwiperContainer.id = "BasicVerticalSlider";
    HoverContainer.append(SwiperContainer);

    let SwiperWrapper = document.createElement("div");
    SwiperWrapper.className = "swiper-wrapper";
    SwiperContainer.append(SwiperWrapper);

    let WhichIndexToSlide = 0;

    for(let i = 0; i < window.ListOfChoicesThisAccommodation.length; i++)
    {
        let WhatType = window.ListOfChoicesThisAccommodation[i].type;
        let WhatToDisplay = window["RoomTxt" + window.CurrentCountryID];
        if(WhatType == "Experiences")
            WhatToDisplay = window["ExperienceTxt" + window.CurrentCountryID];

        let RoomTypeDropDownSlide = document.createElement("div");
        RoomTypeDropDownSlide.className = "BasicSwiperSlideVerticalSlider swiper-slide Unselectable";
        SwiperWrapper.append(RoomTypeDropDownSlide);

        let RoomTypeDropDownText = document.createElement("p");
        RoomTypeDropDownText.className = "LabelGreyHeaderText InterBoldTextFont";
        RoomTypeDropDownText.innerHTML = window.ListOfChoicesThisAccommodation[i]["name_" + window.CurrentCountryID] + " ";
        RoomTypeDropDownSlide.append(RoomTypeDropDownText);

        let RoomTypeSpan = document.createElement("span");
        RoomTypeSpan.className = "LabelGreyHeaderText InterBoldItalicTextFont";
        RoomTypeSpan.style.color = "#667085";
        RoomTypeSpan.innerHTML = "(" + WhatToDisplay + ")";
        RoomTypeDropDownText.append(RoomTypeSpan);

        if(window.ListOfChoicesThisAccommodation[i].id == window.CurrentSelectedRoomID && window.ListOfChoicesThisAccommodation[i].type == window.CurrentSelectedAccFacilitiesType)
        {
            WhichIndexToSlide = i;
        }
    }

    // ================= SAVE BUTTON =================

    let ButtonWrapper = document.createElement("div");
    ButtonWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    ButtonWrapper.style.marginBottom = "0px";
    BodyContainer.append(ButtonWrapper);

    let SaveButton = document.createElement("button");
    SaveButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SaveButton.style.cssText = "margin:0; width:100%;";
    ButtonWrapper.append(SaveButton);

    let SaveText = document.createElement("p");
    SaveText.className = "LabelGreyHeaderText";
    SaveText.style.cssText = "color:white; margin:auto;";
    SaveText.textContent = window["ApplyTxt" + window.CurrentCountryID];
    SaveButton.append(SaveText);

    // ================= SWIPER INIT =================

    const swiper = new window.Swiper('.BasicSwiperSlideVerticalContainer',
    {
        direction: 'vertical',
        centeredSlides: true,
        initialSlide: 2,
        slidesPerView: 5,
        mousewheel: true,
    });

    swiper.on("slideChange", function ()
    {
        let index = swiper.realIndex;
        
        console.log("Swipe to this Data", window.ListOfChoicesThisAccommodation[index]);

        window.CurrentSelectedRoomID = window.ListOfChoicesThisAccommodation[index].id;
        window.CurrentSelectedRoomExpBookType = window.ListOfChoicesThisAccommodation[index].book_type;
        window.CurrentSelectedAccFacilitiesType = window.ListOfChoicesThisAccommodation[index].type;
        window.ThisRoomData = window.ListOfChoicesThisAccommodation[index].data;
    });


    SwiperWrapper.querySelectorAll('.swiper-slide').forEach((slide, index) =>
    {
        slide.addEventListener('click', () =>
        {
            swiper.slideTo(index);
        });
    });

    if(WhichIndexToSlide >= 0)
    {
        swiper.slideToLoop(WhichIndexToSlide, 0);
    }


    let ClosePanelFunction = function(isjustclose)
    {
        if(functiontocallonsave != null && isjustclose == false) // If Just Close Then don't call any function assigned
            functiontocallonsave();
        
        window.ClosePanelAnimate(MainPanel, BasicBlackBlocker, null);
    }
    
    let CloseWithoutSavingFunction = function()
    {
        functiontocallwhenclose();

        ClosePanelFunction(true);
    }

    
    SaveButton.onclick = function()
    {
        ClosePanelFunction(false);
    }

    BackButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    CloseButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    if(isdirect == true)
    {
        BackButton.style.display = "none";
    }
    else
    {
        CloseButton.style.display = "none";
    }
    
    window.OpenPanelAnimate(MainPanel, BasicBlackBlocker);
};



// ================================== STORE PREV DATA AND RESTORE ============================================

window.CreateHotelDetailsSnapshot = function()
{
    let PreviousData =
    {
        "PreviousID": window.CurrentSelectedRoomID, // Id
        "PreviousBookType": window.CurrentSelectedRoomExpBookType, // per day or per night
        "PreviousRoomOrBookCategory": window.CurrentSelectedAccFacilitiesType, // Experience or Room
        "PreviousRoomOrExpData": window.ThisRoomData, // Room or Experience Data

        "PreviousCheckIn": window.CheckInDateNonTop, // Check In
        "PreviousCheckOut": window.CheckOutDateNonTop, // Check Out

        "PreviousSelectedYear": window.CurrentSelectedYearEdit, // Year
        "PreviousSelectedMonth": window.CurrentSelectedMonthEdit, // Month
        "PreviousSelectedDay": window.CurrentSelectedDayEdit, // Day

        "ExperienceDataList": window.CurrentChoiceDataJenisExperience, // Experience Data Loaded Now
        "ExperienceOptionsList": window.CurrentChoiceExperienceAddOns, // Choice Experience Options
        
        "CurrentUserInputExperienceOptions": window.CurrentUserInputExperienceAddOns, //User Input Experience
        "roomquota": window.RoomQuotaNonTop //User Input Experience
    }

    return PreviousData
}

window.RestoreHotelDetailsSnapshot  = function(Snapshot)
{
    window.CurrentSelectedRoomID = Snapshot.PreviousID;
    window.CurrentSelectedRoomExpBookType = Snapshot.PreviousBookType;
    window.CurrentSelectedAccFacilitiesType = Snapshot.PreviousRoomOrBookCategory;
    window.ThisRoomData = Snapshot.PreviousRoomOrExpData;
    window.CheckInDateNonTop = Snapshot.PreviousCheckIn;
    window.CheckOutDateNonTop = Snapshot.PreviousCheckOut;
    window.CurrentSelectedYearEdit = Snapshot.PreviousSelectedYear;
    window.CurrentSelectedMonthEdit = Snapshot.PreviousSelectedMonth;
    window.CurrentSelectedDayEdit = Snapshot.PreviousSelectedDay;
    window.CurrentChoiceDataJenisExperience = Snapshot.ExperienceDataList;
    window.CurrentChoiceExperienceAddOns = Snapshot.ExperienceOptionsList;
    window.CurrentUserInputExperienceAddOns = Snapshot.CurrentUserInputExperienceOptions;
    window.RoomQuotaNonTop = Snapshot.roomquota;
}